import { TabsProps } from "antd";
import { formatJson, IndividualSearchType } from "../lib/types.ts";
import SearchSection from "../components/search/sections/SearchSection";
import AddressSection from "../components/search/sections/AddressSection";

export const searchMenuItems: TabsProps["items"] = [
  {
    key: "1",
    label: `CNPJ`,
    children: (
      <SearchSection
        menu={IndividualSearchType.CNPJ}
        label=""
        placeholder="Pesquise o CNPJ"
        mask="99.999.999/9999-99"
      />
    ),
  },
  {
    key: "2",
    label: `Raiz CNPJ`,
    children: (
      <SearchSection menu={IndividualSearchType.CNPJ_RAIZ} label="" placeholder="Pesquise a raíz CNPJ" mask="99.999.999" />
    ),
  },
  {
    key: "3",
    label: `Nome fantasia`,
    children: (
      <SearchSection
        menu={IndividualSearchType.NOME_FANTASIA}
        label=""
        placeholder="Pesquise o nome fantasia"
      />
    ),
  },
  {
    key: "4",
    label: `Razão social`,
    children: (
      <SearchSection
        menu={IndividualSearchType.RAZAO_SOCIAL}
        label=""
        placeholder="Pesquise a razão social"
      />
    ),
  },
  {
    key: "5",
    label: `Nome Sócio`,
    children: (
      <SearchSection
        menu={IndividualSearchType.NOME_SOCIO}
        label=""
        placeholder="Pesquise o nome do sócio"
      />
    ),
  },
  // {
  //   key: "6",
  //   label: `CPF`,
  //   children: (
  //     <SearchSection
  //       menu={IndividualSearchType.CPF}
  //       label=""
  //       placeholder="Pesquise o CPF"
  //       mask="999.999.999-99"
  //     />
  //   ),
  // },
  {
    key: "7",
    label: `Domínio`,
    children: (
      <SearchSection
        menu={IndividualSearchType.DOMINIO}
        label=""
        placeholder="Pesquise o dominio"
      />
    ),
  },
];

export const searchTableColumns = [
  {
    title: "CNPJ",
    dataIndex: "cnpj_completo",
  },
  {
    title: "Razão Social",
    dataIndex: "razao_social",
  },
  {
    title: "Nome Fantasia",
    dataIndex: "nome_fantasia",
  },
  {
    title: "UF",
    dataIndex: "uf",
  },
  {
    title: "Município",
    dataIndex: "municipio",
  },
  {
    title: "Bairro",
    dataIndex: "bairro",
  },
  {
    title: "CEP",
    dataIndex: "cep",
  },
  {
    title: "Logradouro",
    dataIndex: "logradouro",
  },
  {
    title: "CNAE Principal",
    dataIndex: "cnae_principal",
  },
  {
    title: "Porte",
    dataIndex: "porte",
  },
  {
    title: "Quantidade de Estabelecimentos",
    dataIndex: "qtd_estabelecimentos",
  },
  {
    title: "Quantidade de Sócios",
    dataIndex: "qtd_socios",
  },
  {
    title: "Capital Social",
    dataIndex: "capital_social",
  },
  {
    title: "MEI",
    dataIndex: "mei",
  },
  {
    title: "E-mail",
    dataIndex: "email",
  },
  {
    title: "Site",
    dataIndex: "dominio_email",
  },
  {
    title: "Telefone",
    dataIndex: "telefone",
  },
  {
    title: "Facebook",
    dataIndex: "facebook",
  },
  {
    title: "Instagram",
    dataIndex: "instagram",
  },
  {
    title: "Linkedin",
    dataIndex: "linkedin",
  },
  {
    title: "Whatsapp",
    dataIndex: "whatsapp",
  },
  {
    title: "Sócios",
    dataIndex: "socios",
  },
  {
    title: "Organização",
    dataIndex: "dados_empresa",
  },
  {
    title: "Pessoas",
    dataIndex: "dados_pessoas"
  }
];

// export const searchTableColumns = [
//     {
//         title: 'Raíz CNPJ',
//         dataIndex: 'raiz_cnpj',
//     },
//     {
//         title: 'CNPJ',
//         dataIndex: 'cnpj',
//     },
//     {
//         title: 'Razão Social',
//         dataIndex: 'razao_social',
//     },
//     {
//         title: 'Nome Fantasia',
//         dataIndex: 'nome_fantasia',
//     },
//     {
//         title: 'UF',
//         dataIndex: 'uf',
//     },
//     {
//         title: 'Município',
//         dataIndex: 'municipio',
//     },
//     {
//         title: 'Bairro',
//         dataIndex: 'bairro',
//     },
//     {
//         title: 'CEP',
//         dataIndex: 'cep',
//     },
//     {
//         title: 'Logradouro',
//         dataIndex: 'logradouro',
//     },
//     {
//         title: 'Número',
//         dataIndex: 'numero',
//     },
//     {
//         title: 'CNAE Principal',
//         dataIndex: 'cnae_principal',
//     },
//     {
//         title: 'Porte',
//         dataIndex: 'porte',
//     },
//     {
//         title: 'E-mail',
//         dataIndex: 'email',
//     },
//     {
//         title: 'Telefone',
//         dataIndex: 'telefone',
//     },
//     {
//         title: 'Sócios',
//         dataIndex: 'socios',
//     },
//     {
//         title: 'LinkedIn',
//         dataIndex: 'linkedin',
//     },
//     {
//         title: 'Qtn. Seguidores LinkedIn',
//         dataIndex: 'qtn_seguidores_linkedin',
//     },
//     {
//         title: 'Facebook',
//         dataIndex: 'facebook',
//     },
//     {
//         title: 'Qtn. Seguidores Facebook',
//         dataIndex: 'qtn_seguidores_facebook',
//     },
//     {
//         title: 'Instagram',
//         dataIndex: 'instagram',
//     },
//     {
//         title: 'Qtn. Seguidores Instagram',
//         dataIndex: 'qtn_seguidores_instagram',
//     }
// ]

export const exportSelect: Array<object> = [
  //{value: 'pdf', label: '.pdf'},
  { value: "xlsx", label: ".xlsx" },
  { value: "csv", label: ".csv" },
];

export const matrizFilialSelect: Array<object> = [
  { value: "0", label: "Matriz e Filial" },
  { value: "1", label: "Apenas Matriz" },
];

export const populationSelect: Array<object> = [
  {
    value: 0,
    label: "De 0 a 10.000 habitantes",
  },
  {
    value: 1,
    label: "De 10.001 a 50.000 habitantes",
  },
  {
    value: 2,
    label: "De 50.001 a 200.000 habitantes",
  },
  {
    value: 3,
    label: "De 200.001 a 500.000 habitantes",
  },
  {
    value: 4,
    label: "De 500.001 a 1.000.000 habitantes",
  },
  {
    value: 5,
    label: "Acima de 1.000.000 habitantes",
  },
];

export const pibSelect: Array<object> = [
  {
    value: 0,
    label: "De 0 a 200M",
  },
  {
    value: 1,
    label: "De 200M a 500M",
  },
  {
    value: 2,
    label: "De 500M a 1B",
  },
  {
    value: 3,
    label: "De 1B a 5B",
  },
  {
    value: 4,
    label: "De 5B a 50B",
  },
  {
    value: 5,
    label: "Acima de 50B",
  },
];

export const pibPerCapitaSelect: Array<object> = [
  {
    value: 0,
    label: "De 0 a 20k/ano",
  },
  {
    value: 1,
    label: "De 20k/ano a 50k/ano",
  },
  {
    value: 2,
    label: "De 50k/ano a 100k/ano",
  },
  {
    value: 3,
    label: "De 100k/ano a 200k/ano",
  },
  {
    value: 4,
    label: "Acima de 200k/ano",
  },
];

export const numeroEstabelecimentosSelect: Array<formatJson> = [
  {
    label: '1',
    value: 'A',
  },
  {
    label: '2 a 5',
    value: 'B',
  },
  {
    label: '6 a 20',
    value: 'C',
  },
  {
    label: '21 a 100',
    value: 'D',
  },
  {
    label: 'Acima de 100',
    value: 'E',
  }
]

export const quantidadeSociosSelect: Array<formatJson> = [
  {
    label: '1',
    value: 'A',
  },
  {
    label: '2 a 5',
    value: 'B',
  },
  {
    label: '6 a 10',
    value: 'C',
  },
  {
    label: '11 a 25',
    value: 'D',
  },
  {
    label: 'Acima de 25',
    value: 'E',
  }
]

export const faixaRendaSelect: Array<formatJson> = [
  {
    label: '0 até 800',
    value: 'E'
  },
  {
    label: '800,01 até 1.000',
    value: 'D'
  },
  {
    label: '1.000,01 até 1.400',
    value: 'C'
  },
  {
    label: '1.400,01 até 1.600',
    value: 'B'
  },
  {
    label: 'Acima de 1.600',
    value: 'A'
  }
];

export const naturezaJuridicaSelect: Array<formatJson> = [
  {
    value: "0000",
    label: "0000 - Natureza Jurídica não informada",
  },
  {
    value: "3271",
    label: "3271 - Órgão de Direção Local de Partido Político",
  },
  {
    value: "3280",
    label: "3280 - Comitê Financeiro de Partido Político",
  },
  {
    value: "3298",
    label: "3298 - Frente Plebiscitária ou Referendária",
  },
  {
    value: "3301",
    label: "3301 - Organização Social (OS)",
  },
  {
    value: "3999",
    label: "3999 - Associação Privada",
  },
  {
    value: "4014",
    label: "4014 - Empresa Individual Imobiliária",
  },
  {
    value: "4090",
    label: "4090 - Candidato a Cargo Político Eletivo",
  },
  {
    value: "4120",
    label: "4120 - Produtor Rural (Pessoa Física)",
  },
  {
    value: "5010",
    label: "5010 - Organização Internacional",
  },
  {
    value: "5029",
    label: "5029 - Representação Diplomática Estrangeira",
  },
  {
    value: "1015",
    label: "1015 - Órgão Público do Poder Executivo Federal",
  },
  {
    value: "1023",
    label:
      "1023 - Órgão Público do Poder Executivo Estadual ou do Distrito Federal",
  },
  {
    value: "1031",
    label: "1031 - Órgão Público do Poder Executivo Municipal",
  },
  {
    value: "1040",
    label: "1040 - Órgão Público do Poder Legislativo Federal",
  },
  {
    value: "1058",
    label:
      "1058 - Órgão Público do Poder Legislativo Estadual ou do Distrito Federal",
  },
  {
    value: "1066",
    label: "1066 - Órgão Público do Poder Legislativo Municipal",
  },
  {
    value: "1074",
    label: "1074 - Órgão Público do Poder Judiciário Federal",
  },
  {
    value: "1082",
    label: "1082 - Órgão Público do Poder Judiciário Estadual",
  },
  {
    value: "1104",
    label: "1104 - Autarquia Federal",
  },
  {
    value: "1112",
    label: "1112 - Autarquia Estadual ou do Distrito Federal",
  },
  {
    value: "1120",
    label: "1120 - Autarquia Municipal",
  },
  {
    value: "1139",
    label: "1139 - Fundação Pública de Direito Público Federal",
  },
  {
    value: "1147",
    label:
      "1147 - Fundação Pública de Direito Público Estadual ou do Distrito Federal",
  },
  {
    value: "1155",
    label: "1155 - Fundação Pública de Direito Público Municipal",
  },
  {
    value: "1163",
    label: "1163 - Órgão Público Autônomo Federal",
  },
  {
    value: "1171",
    label: "1171 - Órgão Público Autônomo Estadual ou do Distrito Federal",
  },
  {
    value: "1180",
    label: "1180 - Órgão Público Autônomo Municipal",
  },
  {
    value: "1198",
    label: "1198 - Comissão Polinacional",
  },
  {
    value: "1210",
    label: "1210 - Consórcio Público de Direito Público (Associação Pública)",
  },
  {
    value: "1228",
    label: "1228 - Consórcio Público de Direito Privado",
  },
  {
    value: "1236",
    label: "1236 - Estado ou Distrito Federal",
  },
  {
    value: "1244",
    label: "1244 - Município",
  },
  {
    value: "1252",
    label: "1252 - Fundação Pública de Direito Privado Federal",
  },
  {
    value: "1260",
    label:
      "1260 - Fundação Pública de Direito Privado Estadual ou do Distrito Federal",
  },
  {
    value: "1279",
    label: "1279 - Fundação Pública de Direito Privado Municipal",
  },
  {
    value: "1287",
    label: "1287 - Fundo Público da Administração Indireta Federal",
  },
  {
    value: "1295",
    label:
      "1295 - Fundo Público da Administração Indireta Estadual ou do Distrito Federal",
  },
  {
    value: "1309",
    label: "1309 - Fundo Público da Administração Indireta Municipal",
  },
  {
    value: "1317",
    label: "1317 - Fundo Público da Administração Direta Federal",
  },
  {
    value: "1325",
    label:
      "1325 - Fundo Público da Administração Direta Estadual ou do Distrito Federal",
  },
  {
    value: "1333",
    label: "1333 - Fundo Público da Administração Direta Municipal",
  },
  {
    value: "1341",
    label: "1341 - União",
  },
  {
    value: "2011",
    label: "2011 - Empresa Pública",
  },
  {
    value: "2038",
    label: "2038 - Sociedade de Economia Mista",
  },
  {
    value: "2046",
    label: "2046 - Sociedade Anônima Aberta",
  },
  {
    value: "2054",
    label: "2054 - Sociedade Anônima Fechada",
  },
  {
    value: "2062",
    label: "2062 - Sociedade Empresária Limitada",
  },
  {
    value: "2070",
    label: "2070 - Sociedade Empresária em Nome Coletivo",
  },
  {
    value: "2089",
    label: "2089 - Sociedade Empresária em Comandita Simples",
  },
  {
    value: "2097",
    label: "2097 - Sociedade Empresária em Comandita por Ações",
  },
  {
    value: "2100",
    label: "2100 - Sociedade Mercantil de Capital e Indústria",
  },
  {
    value: "2127",
    label: "2127 - Sociedade em Conta de Participação",
  },
  {
    value: "2135",
    label: "2135 - Empresário (Individual)",
  },
  {
    value: "2143",
    label: "2143 - Cooperativa",
  },
  {
    value: "2151",
    label: "2151 - Consórcio de Sociedades",
  },
  {
    value: "2160",
    label: "2160 - Grupo de Sociedades",
  },
  {
    value: "2178",
    label: "2178 - Estabelecimento, no Brasil, de Sociedade Estrangeira",
  },
  {
    value: "2194",
    label:
      "2194 - Estabelecimento, no Brasil, de Empresa Binacional Argentino-Brasileira",
  },
  {
    value: "2216",
    label: "2216 - Empresa Domiciliada no Exterior",
  },
  {
    value: "2224",
    label: "2224 - Clube/Fundo de Investimento",
  },
  {
    value: "2232",
    label: "2232 - Sociedade Simples Pura",
  },
  {
    value: "2240",
    label: "2240 - Sociedade Simples Limitada",
  },
  {
    value: "2259",
    label: "2259 - Sociedade Simples em Nome Coletivo",
  },
  {
    value: "2267",
    label: "2267 - Sociedade Simples em Comandita Simples",
  },
  {
    value: "2275",
    label: "2275 - Empresa Binacional",
  },
  {
    value: "2283",
    label: "2283 - Consórcio de Empregadores",
  },
  {
    value: "2291",
    label: "2291 - Consórcio Simples",
  },
  {
    value: "2305",
    label:
      "2305 - Empresa Individual de Responsabilidade Limitada (de Natureza Empresária)",
  },
  {
    value: "2313",
    label:
      "2313 - Empresa Individual de Responsabilidade Limitada (de Natureza Simples)",
  },
  {
    value: "2321",
    label: "2321 - Sociedade Unipessoal de Advocacia",
  },
  {
    value: "2330",
    label: "2330 - Cooperativas de Consumo",
  },
  {
    value: "2348",
    label: "2348 - Empresa Simples de Inovação",
  },
  {
    value: "3034",
    label: "3034 - Serviço Notarial e Registral (Cartório)",
  },
  {
    value: "3069",
    label: "3069 - Fundação Privada",
  },
  {
    value: "3077",
    label: "3077 - Serviço Social Autônomo",
  },
  {
    value: "3085",
    label: "3085 - Condomínio Edilício",
  },
  {
    value: "3107",
    label: "3107 - Comissão de Conciliação Prévia",
  },
  {
    value: "3115",
    label: "3115 - Entidade de Mediação e Arbitragem",
  },
  {
    value: "3131",
    label: "3131 - Entidade Sindical",
  },
  {
    value: "3204",
    label:
      "3204 - Estabelecimento, no Brasil, de Fundação ou Associação Estrangeiras",
  },
  {
    value: "3212",
    label: "3212 - Fundação ou Associação Domiciliada no Exterior",
  },
  {
    value: "3220",
    label: "3220 - Organização Religiosa",
  },
  {
    value: "3239",
    label: "3239 - Comunidade Indígena",
  },
  {
    value: "3247",
    label: "3247 - Fundo Privado",
  },
  {
    value: "3255",
    label: "3255 - Órgão de Direção Nacional de Partido Político",
  },
  {
    value: "3263",
    label: "3263 - Órgão de Direção Regional de Partido Político",
  },
  {
    value: "5037",
    label: "5037 - Outras Instituições Extraterritoriais",
  },
  {
    value: "3328",
    label: "3328 - Plano de Benefícios de Previdência Complementar Fechada",
  },
  {
    value: "8885",
    label: "8885 - Natureza Jurídica não informada",
  },
];

export const porteSelect: Array<formatJson> = [
  { value: "00", label: "Não Informado" },
  { value: "99", label: "MEI" },
  { value: "01", label: "Micro Empresa" },
  { value: "03", label: "Empresa de Pequeno Porte" },
  { value: "05", label: "Demais" },
];

export const capitalSocialSelect: Array<object> = [
  {
    value: "A",
    label: "0 até 50.000",
  },
  {
    value: "B",
    label: "de 50.000,01 até 200.000",
  },
  {
    value: "C",
    label: "200.000,01 até 500.000",
  },
  {
    value: "D",
    label: "500.000,01 até 2.000.000,00",
  },
  {
    value: "E",
    label: "de 2.000.000,01 até 10.000.000",
  },
  {
    value: "F",
    label: "Acima de 10.000.000",
  },
];

export const cnaeSelect: Array<object> = [
  {
    value: "0161001",
    label: "Serviço de pulverização e controle de pragas agrícolas",
  },
  {
    value: "2121101",
    label: "Fabricação de medicamentos alopáticos para uso humano",
  },
  {
    value: "7320300",
    label: "Pesquisas de mercado e de opinião pública",
  },
  {
    value: "3313902",
    label:
      "Manutenção e reparação de baterias e acumuladores elétricos, exceto para veículos",
  },
  {
    value: "7111100",
    label: "Serviços de arquitetura",
  },
  {
    value: "8640202",
    label: "Laboratórios clínicos",
  },
  {
    value: "0163600",
    label: "Atividades de pós-colheita",
  },
  {
    value: "8299706",
    label: "Casas lotéricas",
  },
  {
    value: "8599604",
    label: "Treinamento em desenvolvimento profissional e gerencial",
  },
  {
    value: "5822101",
    label: "Edição integrada à impressão de jornais diários",
  },
  {
    value: "2592601",
    label: "Fabricação de produtos de trefilados de metal padronizados",
  },
  {
    value: "4713005",
    label:
      "Lojas francas (Duty Free) de aeroportos, portos e em fronteiras terrestres",
  },
  {
    value: "0133499",
    label:
      "Cultivo de frutas de lavoura permanente não especificadas anteriormente",
  },
  {
    value: "4923001",
    label: "Serviço de táxi",
  },
  {
    value: "5590602",
    label: "Campings",
  },
  {
    value: "4679602",
    label: "Comércio atacadista de mármores e granitos",
  },
  {
    value: "4642702",
    label:
      "Comércio atacadista de roupas e acessórios para uso profissional e de segurança do trabalho",
  },
  {
    value: "6311900",
    label:
      "Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na Internet",
  },
  {
    value: "4771703",
    label: "Comércio varejista de produtos farmacêuticos homeopáticos",
  },
  {
    value: "7500100",
    label: "Atividades veterinárias",
  },
  {
    value: "9603302",
    label: "Serviços de cremação",
  },
  {
    value: "6201501",
    label: "Desenvolvimento de programas de computador sob encomenda",
  },
  {
    value: "2521700",
    label:
      "Fabricação de tanques, reservatórios metálicos e caldeiras para aquecimento central",
  },
  {
    value: "2431800",
    label: "Produção de tubos de aço com costura",
  },
  {
    value: "9319101",
    label: "Produção e promoção de eventos esportivos",
  },
  {
    value: "3299005",
    label: "Fabricação de aviamentos para costura",
  },
  {
    value: "3212400",
    label: "Fabricação de bijuterias e artefatos semelhantes",
  },
  {
    value: "1111901",
    label: "Fabricação de aguardente de cana-de-açúcar",
  },
  {
    value: "4120400",
    label: "Construção de edifícios",
  },
  {
    value: "0322105",
    label: "Ranicultura",
  },
  {
    value: "4520001",
    label:
      "Serviços de manutenção e reparação mecânica de veículos automotores",
  },
  {
    value: "2424501",
    label: "Produção de arames de aço",
  },
  {
    value: "4711301",
    label:
      "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - hipermercados",
  },
  {
    value: "0141502",
    label:
      "Produção de sementes certificadas de forrageiras para formação de pasto",
  },
  {
    value: "5620103",
    label: "Cantinas - serviços de alimentação privativos",
  },
  {
    value: "6541300",
    label: "Previdência complementar fechada",
  },
  {
    value: "0220905",
    label: "Coleta de palmito em florestas nativas",
  },
  {
    value: "4681804",
    label: "Comércio atacadista de combustíveis de origem mineral em bruto",
  },
  {
    value: "4761001",
    label: "Comércio varejista de livros",
  },
  {
    value: "4754701",
    label: "Comércio varejista de móveis",
  },
  {
    value: "4950700",
    label: "Trens turísticos, teleféricos e similares",
  },
  {
    value: "2029100",
    label:
      "Fabricação de produtos químicos orgânicos não especificados anteriormente",
  },
  {
    value: "6142600",
    label: "Operadoras de televisão por assinatura por micro-ondas",
  },
  {
    value: "7119704",
    label: "Serviços de perícia técnica relacionados à segurança do trabalho",
  },
  {
    value: "4511103",
    label:
      "Comércio por atacado de automóveis, camionetas e utilitários novos e usados",
  },
  {
    value: "4686901",
    label: "Comércio atacadista de papel e papelão em bruto",
  },
  {
    value: "5510802",
    label: "Apart-hotéis",
  },
  {
    value: "4520002",
    label:
      "Serviços de lanternagem ou funilaria e pintura de veículos automotores",
  },
  {
    value: "0133405",
    label: "Cultivo de coco-da-baía",
  },
  {
    value: "7711000",
    label: "Locação de automóveis sem condutor",
  },
  {
    value: "5620101",
    label:
      "Fornecimento de alimentos preparados preponderantemente para empresas",
  },
  {
    value: "4319300",
    label: "Serviços de preparação do terreno não especificados anteriormente",
  },
  {
    value: "4511102",
    label: "Comércio a varejo de automóveis, camionetas e utilitários usados",
  },
  {
    value: "4679699",
    label: "Comércio atacadista de materiais de construção em geral",
  },
  {
    value: "2511000",
    label: "Fabricação de estruturas metálicas",
  },
  {
    value: "8533300",
    label: "Educação superior - pós-graduação e extensão",
  },
  {
    value: "7420002",
    label: "Atividades de produção de fotografias aéreas e submarinas",
  },
  {
    value: "6493000",
    label: "Administração de consórcios para aquisição de bens e direitos",
  },
  {
    value: "2399199",
    label:
      "Fabricação de outros produtos de minerais não metálicos não especificados anteriormente",
  },
  {
    value: "3832700",
    label: "Recuperação de materiais plásticos",
  },
  {
    value: "2443100",
    label: "Metalurgia do cobre",
  },
  {
    value: "4329102",
    label:
      "Instalação de equipamentos para orientação à navegação marítima, fluvial e lacustre",
  },
  {
    value: "4623199",
    label:
      "Comércio atacadista de matérias-primas agrícolas não especificadas anteriormente",
  },
  {
    value: "3514000",
    label: "Distribuição de energia elétrica",
  },
  {
    value: "0322102",
    label: "Criação de camarões em água doce",
  },
  {
    value: "1122404",
    label: "Fabricação de bebidas isotônicas",
  },
  {
    value: "4771702",
    label:
      "Comércio varejista de produtos farmacêuticos, com manipulação de fórmulas",
  },
  {
    value: "0154700",
    label: "Criação de suínos",
  },
  {
    value: "6438799",
    label:
      "Outras instituições de intermediação não monetária não especificadas anteriormente",
  },
  {
    value: "1721400",
    label: "Fabricação de papel",
  },
  {
    value: "3831999",
    label: "Recuperação de materiais metálicos, exceto alumínio",
  },
  {
    value: "0722702",
    label: "Beneficiamento de minério de estanho",
  },
  {
    value: "6619399",
    label:
      "Outras atividades auxiliares dos serviços financeiros não especificadas anteriormente",
  },
  {
    value: "0600002",
    label: "Extração e beneficiamento de xisto",
  },
  {
    value: "6512000",
    label: "Sociedade seguradora de seguros não vida",
  },
  {
    value: "9329801",
    label: "Discotecas, danceterias, salões de dança e similares",
  },
  {
    value: "8610102",
    label:
      "Atividades de atendimento em pronto-socorro e unidades hospitalares para atendimento a urgências",
  },
  {
    value: "2631100",
    label:
      "Fabricação de equipamentos transmissores de comunicação, peças e acessórios",
  },
  {
    value: "8660700",
    label: "Atividades de apoio à gestão de saúde",
  },
  {
    value: "2051700",
    label: "Fabricação de defensivos agrícolas",
  },
  {
    value: "2950600",
    label:
      "Recondicionamento e recuperação de motores para veículos automotores",
  },
  {
    value: "8112500",
    label: "Condomínios prediais",
  },
  {
    value: "3831901",
    label: "Recuperação de sucatas de alumínio",
  },
  {
    value: "5611201",
    label: "Restaurantes e similares",
  },
  {
    value: "6010100",
    label: "Atividades de rádio",
  },
  {
    value: "2021500",
    label: "Fabricação de produtos petroquímicos básicos",
  },
  {
    value: "0119904",
    label: "Cultivo de cebola",
  },
  {
    value: "5240199",
    label:
      "Atividades auxiliares dos transportes aéreos, exceto operação dos aeroportos e campos de aterrissagem",
  },
  {
    value: "0159899",
    label: "Criação de outros animais não especificados anteriormente",
  },
  {
    value: "6410700",
    label: "Banco Central",
  },
  {
    value: "4645101",
    label:
      "Comércio atacadista de instrumentos e materiais para uso médico, cirúrgico, hospitalar e de laboratórios",
  },
  {
    value: "5112999",
    label: "Outros serviços de transporte aéreo de passageiros não regular",
  },
  {
    value: "0210104",
    label: "Cultivo de teca",
  },
  {
    value: "3299099",
    label: "Fabricação de produtos diversos não especificados anteriormente",
  },
  {
    value: "9200301",
    label: "Casas de bingo",
  },
  {
    value: "1122403",
    label:
      "Fabricação de refrescos, xaropes e pós para refrescos, exceto refrescos de frutas",
  },
  {
    value: "4684202",
    label: "Comércio atacadista de solventes",
  },
  {
    value: "3513100",
    label: "Comércio atacadista de energia elétrica",
  },
  {
    value: "3314722",
    label:
      "Manutenção e reparação de máquinas e aparelhos para a indústria do plástico",
  },
  {
    value: "1072401",
    label: "Fabricação de açúcar de cana refinado",
  },
  {
    value: "0155501",
    label: "Criação de frangos para corte",
  },
  {
    value: "4929999",
    label:
      "Outros transportes rodoviários de passageiros não especificados anteriormente",
  },
  {
    value: "2449199",
    label:
      "Metalurgia de outros metais não ferrosos e suas ligas não especificados anteriormente",
  },
  {
    value: "7319001",
    label: "Criação de estandes para feiras e exposições",
  },
  {
    value: "1330800",
    label: "Fabricação de tecidos de malha",
  },
  {
    value: "1922599",
    label:
      "Fabricação de outros produtos derivados do petróleo, exceto produtos do refino",
  },
  {
    value: "4221901",
    label:
      "Construção de barragens e represas para geração de energia \nelétrica",
  },
  {
    value: "1539400",
    label:
      "Fabricação de calçados de materiais não especificados\nanteriormente",
  },
  {
    value: "3220500",
    label: "Fabricação de instrumentos musicais, peças e acessórios",
  },
  {
    value: "9412099",
    label: "Outras atividades associativas profissionais",
  },
  {
    value: "0220904",
    label: "Coleta de látex em florestas nativas",
  },
  {
    value: "4313400",
    label: "Obras de terraplenagem",
  },
  {
    value: "2399102",
    label: "Fabricação de abrasivos",
  },
  {
    value: "7220700",
    label:
      "Pesquisa e desenvolvimento experimental em ciências sociais e humanas",
  },
  {
    value: "8230001",
    label: "Serviços de organização de feiras, congressos, exposições e festas",
  },
  {
    value: "0112101",
    label: "Cultivo de algodão herbáceo",
  },
  {
    value: "8630599",
    label: "Atividades de atenção ambulatorial não especificadas anteriormente",
  },
  {
    value: "6435202",
    label: "Associações de poupança e empréstimo",
  },
  {
    value: "3311200",
    label:
      "Manutenção e reparação de tanques, reservatórios metálicos e caldeiras, exceto para veículos",
  },
  {
    value: "8711502",
    label: "Instituições de longa permanência para idosos",
  },
  {
    value: "0311602",
    label: "Pesca de crustáceos e moluscos em água salgada",
  },
  {
    value: "4752100",
    label:
      "Comércio varejista especializado de equipamentos de telefonia e comunicação",
  },
  {
    value: "8630502",
    label:
      "Atividade médica ambulatorial com recursos para realização de exames complementares",
  },
  {
    value: "4731800",
    label: "Comércio varejista de combustíveis para veículos automotores",
  },
  {
    value: "1052000",
    label: "Fabricação de laticínios",
  },
  {
    value: "2091600",
    label: "Fabricação de adesivos e selantes",
  },
  {
    value: "1742702",
    label: "Fabricação de absorventes higiênicos",
  },
  {
    value: "0159801",
    label: "Apicultura",
  },
  {
    value: "8621601",
    label: "UTI móvel",
  },
  {
    value: "1351100",
    label: "Fabricação de artefatos têxteis para uso doméstico",
  },
  {
    value: "8299705",
    label: "Serviços de levantamento de fundos sob contrato",
  },
  {
    value: "4631100",
    label: "Comércio atacadista de leite e laticínios",
  },
  {
    value: "2532202",
    label: "Metalurgia do pó",
  },
  {
    value: "4292802",
    label: "Obras de montagem industrial",
  },
  {
    value: "2621300",
    label: "Fabricação de equipamentos de informática",
  },
  {
    value: "1830003",
    label: "Reprodução de software em qualquer suporte",
  },
  {
    value: "6470103",
    label: "Fundos de investimento imobiliários",
  },
  {
    value: "4753900",
    label:
      "Comércio varejista especializado de eletrodomésticos e equipamentos de áudio e vídeo",
  },
  {
    value: "4511101",
    label: "Comércio a varejo de automóveis, camionetas e utilitários novos",
  },
  {
    value: "2063100",
    label:
      "Fabricação de cosméticos, produtos de perfumaria e de higiene pessoal",
  },
  {
    value: "0142300",
    label:
      "Produção de mudas e outras formas de propagação vegetal, certificadas",
  },
  {
    value: "4756300",
    label:
      "Comércio varejista especializado de instrumentos musicais e acessórios",
  },
  {
    value: "9430800",
    label: "Atividades de associações de defesa de direitos sociais",
  },
  {
    value: "4321500",
    label: "Instalação e manutenção elétrica",
  },
  {
    value: "2099199",
    label:
      "Fabricação de outros produtos químicos não especificados anteriormente",
  },
  {
    value: "2391501",
    label: "Britamento de pedras, exceto associado à extração",
  },
  {
    value: "9529103",
    label: "Reparação de relógios",
  },
  {
    value: "6470102",
    label: "Fundos de investimento previdenciários",
  },
  {
    value: "4763603",
    label: "Comércio varejista de bicicletas e triciclos; peças e acessórios",
  },
  {
    value: "4651601",
    label: "Comércio atacadista de equipamentos de informática",
  },
  {
    value: "3250701",
    label:
      "Fabricação de instrumentos não eletrônicos e utensílios para uso médico, cirúrgico, odontológico e de laboratório",
  },
  {
    value: "0220999",
    label:
      "Coleta de produtos não madeireiros não especificados anteriormente em florestas nativas",
  },
  {
    value: "2531401",
    label: "Produção de forjados de aço",
  },
  {
    value: "0892402",
    label: "Extração de sal-gema",
  },
  {
    value: "6499902",
    label: "Sociedades de investimento",
  },
  {
    value: "1012104",
    label: "Matadouro - abate de suínos sob contrato",
  },
  {
    value: "3050400",
    label: "Fabricação de veículos militares de combate",
  },
  {
    value: "5510801",
    label: "Hotéis",
  },
  {
    value: "8020001",
    label: "Atividades de monitoramento de sistemas de segurança eletrônico",
  },
  {
    value: "4686902",
    label: "Comércio atacadista de embalagens",
  },
  {
    value: "4759899",
    label:
      "Comércio varejista de outros artigos de uso doméstico não especificados anteriormente",
  },
  {
    value: "4751202",
    label: "Recarga de cartuchos para equipamentos de informática",
  },
  {
    value: "1062700",
    label: "Moagem de trigo e fabricação de derivados",
  },
  {
    value: "5091201",
    label: "Transporte por navegação de travessia, municipal",
  },
  {
    value: "3250703",
    label:
      "Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral sob encomenda",
  },
  {
    value: "5229001",
    label:
      "Serviços de apoio ao transporte por táxi, inclusive centrais de chamada",
  },
  {
    value: "9103100",
    label:
      "Atividades de jardins botânicos, zoológicos, parques nacionais, reservas ecológicas e áreas de proteção ambiental",
  },
  {
    value: "4330402",
    label:
      "Instalação de portas, janelas, tetos, divisórias e armários embutidos de qualquer material",
  },
  {
    value: "2320600",
    label: "Fabricação de cimento",
  },
  {
    value: "3839499",
    label: "Recuperação de materiais não especificados anteriormente",
  },
  {
    value: "1082100",
    label: "Fabricação de produtos à base de café",
  },
  {
    value: "0321304",
    label: "Criação de peixes ornamentais em água salgada e salobra",
  },
  {
    value: "4789005",
    label: "Comércio varejista de produtos saneantes domissanitários",
  },
  {
    value: "4729602",
    label: "Comércio varejista de mercadorias em lojas de conveniência",
  },
  {
    value: "4542101",
    label:
      "Representantes comerciais e agentes do comércio de motocicletas e motonetas, peças e acessórios",
  },
  {
    value: "4520007",
    label:
      "Serviços de instalação, manutenção e reparação de acessórios para veículos automotores",
  },
  {
    value: "1033302",
    label:
      "Fabricação de sucos de frutas, hortaliças e legumes, exceto concentrados",
  },
  {
    value: "7810800",
    label: "Seleção e agenciamento de mão de obra",
  },
  {
    value: "6622300",
    label:
      "Corretores e agentes de seguros, de planos de previdência complementar e de saúde",
  },
  {
    value: "2599302",
    label: "Serviço de corte e dobra de metais",
  },
  {
    value: "2640000",
    label:
      "Fabricação de aparelhos de recepção, reprodução, gravação e amplificação de áudio e vídeo",
  },
  {
    value: "2330303",
    label: "Fabricação de artefatos de fibrocimento para uso na construção",
  },
  {
    value: "0899199",
    label:
      "Extração de outros minerais não metálicos não especificados anteriormente",
  },
  {
    value: "3314710",
    label:
      "Manutenção e reparação de máquinas e equipamentos para uso geral não especificados anteriormente",
  },
  {
    value: "5912002",
    label: "Serviços de mixagem sonora em produção audiovisual",
  },
  {
    value: "8650007",
    label: "Atividades de terapia de nutrição enteral e parenteral",
  },
  {
    value: "0133409",
    label: "Cultivo de maracujá",
  },
  {
    value: "7490104",
    label:
      "Atividades de intermediação e agenciamento de serviços e negócios em geral, exceto imobiliários",
  },
  {
    value: "4623101",
    label: "Comércio atacadista de animais vivos",
  },
  {
    value: "2944100",
    label:
      "Fabricação de peças e acessórios para o sistema de direção e suspensão de veículos automotores",
  },
  {
    value: "0322199",
    label:
      "Cultivos e semicultivos da aquicultura em água doce não especificados anteriormente",
  },
  {
    value: "9529101",
    label: "Reparação de calçados, bolsas e artigos de viagem",
  },
  {
    value: "2824102",
    label:
      "Fabricação de aparelhos e equipamentos de ar condicionado para uso não industrial",
  },
  {
    value: "3292201",
    label: "Fabricação de roupas de proteção e segurança e resistentes a fogo",
  },
  {
    value: "5229099",
    label:
      "Outras atividades auxiliares dos transportes terrestres não especificadas anteriormente",
  },
  {
    value: "1061902",
    label: "Fabricação de produtos do arroz",
  },
  {
    value: "4639702",
    label:
      "Comércio atacadista de produtos alimentícios em geral, com atividade de fracionamento e acondicionamento associada",
  },
  {
    value: "4541206",
    label:
      "Comércio a varejo de peças e acessórios novos para motocicletas e motonetas",
  },
  {
    value: "1922502",
    label: "Rerrefino de óleos lubrificantes",
  },
  {
    value: "1323500",
    label: "Tecelagem de fios de fibras artificiais e sintéticas",
  },
  {
    value: "4689302",
    label: "Comércio atacadista de fios e fibras beneficiados",
  },
  {
    value: "2229399",
    label:
      "Fabricação de artefatos de material plástico para outros usos não especificados anteriormente",
  },
  {
    value: "1314600",
    label: "Fabricação de linhas para costurar e bordar",
  },
  {
    value: "4674500",
    label: "Comércio atacadista de cimento",
  },
  {
    value: "8610101",
    label:
      "Atividades de atendimento hospitalar, exceto pronto-socorro e unidades para atendimento a urgências",
  },
  {
    value: "9609202",
    label: "Agências matrimoniais",
  },
  {
    value: "4644302",
    label: "Comércio atacadista de medicamentos e drogas de uso veterinário",
  },
  {
    value: "4789006",
    label: "Comércio varejista de fogos de artifício e artigos pirotécnicos",
  },
  {
    value: "0210107",
    label: "Extração de madeira em florestas plantadas",
  },
  {
    value: "0114800",
    label: "Cultivo de fumo",
  },
  {
    value: "6611804",
    label: "Administração de mercados de balcão organizados",
  },
  {
    value: "2861500",
    label:
      "Fabricação de máquinas para a indústria metalúrgica, peças e acessórios, exceto máquinas-ferramenta",
  },
  {
    value: "2722802",
    label:
      "Recondicionamento de baterias e acumuladores para veículos automotores",
  },
  {
    value: "4669901",
    label: "Comércio atacadista de bombas e compressores; partes e peças",
  },
  {
    value: "0311603",
    label: "Coleta de outros produtos marinhos",
  },
  {
    value: "6550200",
    label: "Planos de saúde",
  },
  {
    value: "1610201",
    label: "Serrarias com desdobramento de madeira",
  },
  {
    value: "1020102",
    label: "Fabricação de conservas de peixes, crustáceos e moluscos",
  },
  {
    value: "8690904",
    label: "Atividades de podologia",
  },
  {
    value: "2930103",
    label:
      "Fabricação de cabines, carrocerias e reboques para outros veículos automotores, exceto caminhões e ônibus",
  },
  {
    value: "1610204",
    label: "Serrarias sem desdobramento de madeira em bruto - Resseragem",
  },
  {
    value: "2790202",
    label: "Fabricação de equipamentos para sinalização e alarme",
  },
  {
    value: "2052500",
    label: "Fabricação de desinfestantes domissanitários",
  },
  {
    value: "9492800",
    label: "Atividades de organizações políticas",
  },
  {
    value: "4665600",
    label:
      "Comércio atacadista de máquinas e equipamentos para uso comercial; partes e peças",
  },
  {
    value: "1529700",
    label: "Fabricação de artefatos de couro não especificados anteriormente",
  },
  {
    value: "6463800",
    label: "Outras sociedades de participação, exceto holdings",
  },
  {
    value: "6611802",
    label: "Bolsa de mercadorias",
  },
  {
    value: "1340501",
    label:
      "Estamparia e texturização em fios, tecidos, artefatos têxteis e peças do vestuário",
  },
  {
    value: "4929903",
    label:
      "Organização de excursões em veículos rodoviários próprios, municipal",
  },
  {
    value: "1733800",
    label: "Fabricação de chapas e de embalagens de papelão ondulado",
  },
  {
    value: "3042300",
    label:
      "Fabricação de turbinas, motores e outros componentes e peças para aeronaves",
  },
  {
    value: "4930201",
    label:
      "Transporte rodoviário de carga, exceto produtos perigosos e mudanças, municipal",
  },
  {
    value: "4617600",
    label:
      "Representantes comerciais e agentes do comércio de produtos alimentícios, bebidas e fumo",
  },
  {
    value: "6821801",
    label: "Corretagem na compra e venda e avaliação de imóveis",
  },
  {
    value: "2442300",
    label: "Metalurgia dos metais preciosos",
  },
  {
    value: "4649409",
    label:
      "Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar, com atividade de fracionamento e acondicionamento associada",
  },
  {
    value: "8730102",
    label: "Albergues assistenciais",
  },
  {
    value: "8542200",
    label: "Educação profissional de nível tecnológico",
  },
  {
    value: "6630400",
    label: "Atividades de administração de fundos por contrato ou comissão",
  },
  {
    value: "4623106",
    label: "Comércio atacadista de sementes, flores, plantas e gramas",
  },
  {
    value: "2342701",
    label: "Fabricação de azulejos e pisos",
  },
  {
    value: "9313100",
    label: "Atividades de condicionamento físico",
  },
  {
    value: "9609299",
    label:
      "Outras atividades de serviços pessoais não especificadas anteriormente",
  },
  {
    value: "2910703",
    label: "Fabricação de motores para automóveis, camionetas e utilitários",
  },
  {
    value: "4399102",
    label: "Montagem e desmontagem de andaimes e outras estruturas temporárias",
  },
  {
    value: "1531902",
    label: "Acabamento de calçados de couro sob contrato",
  },
  {
    value: "4110700",
    label: "Incorporação de empreendimentos imobiliários",
  },
  {
    value: "5812300",
    label: "Edição de jornais",
  },
  {
    value: "3250709",
    label: "Serviço de laboratório óptico",
  },
  {
    value: "4724500",
    label: "Comércio varejista de hortifrutigranjeiros",
  },
  {
    value: "2831300",
    label: "Fabricação de tratores agrícolas, peças e acessórios",
  },
  {
    value: "0893200",
    label: "Extração de gemas (pedras preciosas e semipreciosas)",
  },
  {
    value: "2412100",
    label: "Produção de ferroligas",
  },
  {
    value: "2391502",
    label:
      "Aparelhamento de pedras para construção, exceto associado à extração",
  },
  {
    value: "4912402",
    label:
      "Transporte ferroviário de passageiros municipal e em região metropolitana",
  },
  {
    value: "8591100",
    label: "Ensino de esportes",
  },
  {
    value: "8711503",
    label:
      "Atividades de assistência a deficientes físicos, imunodeprimidos e convalescentes",
  },
  {
    value: "0210109",
    label: "Produção de casca de acácia-negra - florestas plantadas",
  },
  {
    value: "4744006",
    label: "Comércio varejista de pedras para revestimento",
  },
  {
    value: "2449103",
    label: "Fabricação de ânodos para galvanoplastia",
  },
  {
    value: "1053800",
    label: "Fabricação de sorvetes e outros gelados comestíveis",
  },
  {
    value: "0133401",
    label: "Cultivo de açaí",
  },
  {
    value: "8220200",
    label: "Atividades de teleatendimento",
  },
  {
    value: "4672900",
    label: "Comércio atacadista de ferragens e ferramentas",
  },
  {
    value: "1011203",
    label: "Frigorífico - abate de ovinos e caprinos",
  },
  {
    value: "1122401",
    label: "Fabricação de refrigerantes",
  },
  {
    value: "6612605",
    label: "Agentes de investimentos em aplicações financeiras",
  },
  {
    value: "8011101",
    label: "Atividades de vigilância e segurança privada",
  },
  {
    value: "7722500",
    label: "Aluguel de fitas de vídeo, DVDs e similares",
  },
  {
    value: "4541203",
    label: "Comércio a varejo de motocicletas e motonetas novas",
  },
  {
    value: "8011102",
    label: "Serviços de adestramento de cães de guarda",
  },
  {
    value: "6530800",
    label: "Resseguros",
  },
  {
    value: "4312600",
    label: "Perfurações e sondagens",
  },
  {
    value: "4221904",
    label: "Construção de estações e redes de telecomunicações",
  },
  {
    value: "8690902",
    label: "Atividades de bancos de leite humano",
  },
  {
    value: "3316302",
    label: "Manutenção de aeronaves na pista",
  },
  {
    value: "6612604",
    label: "Corretoras de contratos de mercadorias",
  },
  {
    value: "3292202",
    label:
      "Fabricação de equipamentos e acessórios para segurança pessoal e profissional",
  },
  {
    value: "2092401",
    label: "Fabricação de pólvoras, explosivos e detonantes",
  },
  {
    value: "9003500",
    label:
      "Gestão de espaços para artes cênicas, espetáculos e outras atividades artísticas",
  },
  {
    value: "3312103",
    label:
      "Manutenção e reparação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação",
  },
  {
    value: "6432800",
    label: "Bancos de investimento",
  },
  {
    value: "4511106",
    label: "Comércio por atacado de ônibus e micro-ônibus novos e usados",
  },
  {
    value: "5911102",
    label: "Produção de filmes para publicidade",
  },
  {
    value: "9609208",
    label: "Higiene e embelezamento de animais domésticos",
  },
  {
    value: "1629302",
    label:
      "Fabricação de artefatos diversos de cortiça, bambu, palha, vime e outros materiais trançados, exceto móveis",
  },
  {
    value: "1094500",
    label: "Fabricação de massas alimentícias",
  },
  {
    value: "2441502",
    label: "Produção de laminados de alumínio",
  },
  {
    value: "6611803",
    label: "Bolsa de mercadorias e futuros",
  },
  {
    value: "5091202",
    label:
      "Transporte por navegação de travessia, intermunicipal, interestadual e internacional",
  },
  {
    value: "8630506",
    label: "Serviços de vacinação e imunização humana",
  },
  {
    value: "5022002",
    label:
      "Transporte por navegação interior de passageiros em linhas regulares, intermunicipal, interestadual e internacional, exceto travessia",
  },
  {
    value: "9200302",
    label: "Exploração de apostas em corridas de cavalos",
  },
  {
    value: "3600602",
    label: "Distribuição de água por caminhões",
  },
  {
    value: "6499905",
    label: "Concessão de crédito pelas OSCIP",
  },
  {
    value: "5211701",
    label: "Armazéns gerais - emissão de warrant",
  },
  {
    value: "1099603",
    label: "Fabricação de fermentos e leveduras",
  },
  {
    value: "9521500",
    label:
      "Reparação e manutenção de equipamentos eletroeletrônicos de uso pessoal e doméstico",
  },
  {
    value: "8413200",
    label: "Regulação das atividades econômicas",
  },
  {
    value: "4711302",
    label:
      "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - supermercados",
  },
  {
    value: "4671100",
    label: "Comércio atacadista de madeira e produtos derivados",
  },
  {
    value: "4618403",
    label:
      "Representantes comerciais e agentes do comércio de jornais, revistas e outras publicações",
  },
  {
    value: "8121400",
    label: "Limpeza em prédios e em domicílios",
  },
  {
    value: "3091100",
    label: "Fabricação de motocicletas, peças e acessórios",
  },
  {
    value: "5914600",
    label: "Atividades de exibição cinematográfica",
  },
  {
    value: "4322301",
    label: "Instalações hidráulicas, sanitárias e de gás",
  },
  {
    value: "4687703",
    label: "Comércio atacadista de resíduos e sucatas metálicos",
  },
  {
    value: "7739003",
    label:
      "Aluguel de palcos, coberturas e outras estruturas de uso temporário, exceto andaimes",
  },
  {
    value: "6911702",
    label: "Atividades auxiliares da justiça",
  },
  {
    value: "8640214",
    label: "Serviços de bancos de células e tecidos humanos",
  },
  {
    value: "3012100",
    label: "Construção de embarcações para esporte e lazer",
  },
  {
    value: "8650002",
    label: "Atividades de profissionais da nutrição",
  },
  {
    value: "5229002",
    label: "Serviços de reboque de veículos",
  },
  {
    value: "4637101",
    label: "Comércio atacadista de café torrado, moído e solúvel",
  },
  {
    value: "1931400",
    label: "Fabricação de álcool",
  },
  {
    value: "3329599",
    label: "Instalação de outros equipamentos não especificados anteriormente",
  },
  {
    value: "1081301",
    label: "Beneficiamento de café",
  },
  {
    value: "4929902",
    label:
      "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, intermunicipal, interestadual e internacional",
  },
  {
    value: "0210102",
    label: "Cultivo de acácia-negra",
  },
  {
    value: "6911701",
    label: "Serviços advocatícios",
  },
  {
    value: "2815101",
    label: "Fabricação de rolamentos para fins industriais",
  },
  {
    value: "7119702",
    label: "Atividades de estudos geológicos",
  },
  {
    value: "1032501",
    label: "Fabricação de conservas de palmito",
  },
  {
    value: "8690999",
    label:
      "Outras atividades de atenção à saúde humana não especificadas anteriormente",
  },
  {
    value: "2632900",
    label:
      "Fabricação de aparelhos telefônicos e de outros equipamentos de comunicação, peças e acessórios",
  },
  {
    value: "1066000",
    label: "Fabricação de alimentos para animais",
  },
  {
    value: "0111399",
    label: "Cultivo de outros cereais não especificados anteriormente",
  },
  {
    value: "0162803",
    label: "Serviço de manejo de animais",
  },
  {
    value: "4399105",
    label: "Perfuração e construção de poços de água",
  },
  {
    value: "3822000",
    label: "Tratamento e disposição de resíduos perigosos",
  },
  {
    value: "9512600",
    label: "Reparação e manutenção de equipamentos de comunicação",
  },
  {
    value: "6612603",
    label: "Corretoras de câmbio",
  },
  {
    value: "3240003",
    label:
      "Fabricação de mesas de bilhar, de sinuca e acessórios associada à locação",
  },
  {
    value: "6520100",
    label: "Sociedade seguradora de seguros-saúde",
  },
  {
    value: "4329103",
    label:
      "Instalação, manutenção e reparação de elevadores, escadas e esteiras rolantes",
  },
  {
    value: "5920100",
    label: "Atividades de gravação de som e de edição de música",
  },
  {
    value: "5240101",
    label: "Operação dos aeroportos e campos de aterrissagem",
  },
  {
    value: "2449101",
    label: "Produção de zinco em formas primárias",
  },
  {
    value: "2864000",
    label:
      "Fabricação de máquinas e equipamentos para as indústrias do vestuário, do couro e de calçados, peças e acessórios",
  },
  {
    value: "9700500",
    label: "Serviços domésticos",
  },
  {
    value: "6141800",
    label: "Operadoras de televisão por assinatura por cabo",
  },
  {
    value: "5320202",
    label: "Serviços de entrega rápida",
  },
  {
    value: "7820500",
    label: "Locação de mão de obra temporária",
  },
  {
    value: "1061901",
    label: "Beneficiamento de arroz",
  },
  {
    value: "2019399",
    label:
      "Fabricação de outros produtos químicos inorgânicos não especificados anteriormente",
  },
  {
    value: "4712100",
    label:
      "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - minimercados, mercearias e armazéns",
  },
  {
    value: "1069400",
    label:
      "Moagem e fabricação de produtos de origem vegetal não especificados anteriormente",
  },
  {
    value: "5231102",
    label: "Atividades do Operador Portuário",
  },
  {
    value: "2863100",
    label:
      "Fabricação de máquinas e equipamentos para a indústria têxtil, peças e acessórios",
  },
  {
    value: "3839401",
    label: "Usinas de compostagem",
  },
  {
    value: "4687702",
    label:
      "Comércio atacadista de resíduos e sucatas não metálicos, exceto de papel e papelão",
  },
  {
    value: "0710302",
    label:
      "Pelotização, sinterização e outros beneficiamentos de minério de ferro",
  },
  {
    value: "0159802",
    label: "Criação de animais de estimação",
  },
  {
    value: "4744002",
    label: "Comércio varejista de madeira e artefatos",
  },
  {
    value: "4530705",
    label: "Comércio a varejo de pneumáticos e câmaras-de-ar",
  },
  {
    value: "4637199",
    label:
      "Comércio atacadista especializado em outros produtos alimentícios não especificados anteriormente",
  },
  {
    value: "5822102",
    label: "Edição integrada à impressão de jornais não diários",
  },
  {
    value: "4924800",
    label: "Transporte escolar",
  },
  {
    value: "8424800",
    label: "Segurança e ordem pública",
  },
  {
    value: "2854200",
    label:
      "Fabricação de máquinas e equipamentos para terraplenagem, pavimentação e construção, peças e acessórios, exceto tratores",
  },
  {
    value: "3314703",
    label: "Manutenção e reparação de válvulas industriais",
  },
  {
    value: "3240001",
    label: "Fabricação de jogos eletrônicos",
  },
  {
    value: "1813099",
    label: "Impressão de material para outros usos",
  },
  {
    value: "9329899",
    label:
      "Outras atividades de recreação e lazer não especificadas anteriormente",
  },
  {
    value: "4636201",
    label: "Comércio atacadista de fumo beneficiado",
  },
  {
    value: "0139303",
    label: "Cultivo de pimenta-do-reino",
  },
  {
    value: "5011402",
    label: "Transporte marítimo de cabotagem - Passageiros",
  },
  {
    value: "3314705",
    label:
      "Manutenção e reparação de equipamentos de transmissão para fins industriais",
  },
  {
    value: "3211601",
    label: "Lapidação de gemas",
  },
  {
    value: "1122499",
    label:
      "Fabricação de outras bebidas não alcoólicas não especificadas anteriormente",
  },
  {
    value: "2670101",
    label:
      "Fabricação de equipamentos e instrumentos ópticos, peças e acessórios",
  },
  {
    value: "4789002",
    label: "Comércio varejista de plantas e flores naturais",
  },
  {
    value: "2330302",
    label: "Fabricação de artefatos de cimento para uso na construção",
  },
  {
    value: "4689399",
    label:
      "Comércio atacadista especializado em outros produtos intermediários não especificados anteriormente",
  },
  {
    value: "8513900",
    label: "Ensino fundamental",
  },
  {
    value: "0322103",
    label: "Criação de ostras e mexilhões em água doce",
  },
  {
    value: "2341900",
    label: "Fabricação de produtos cerâmicos refratários",
  },
  {
    value: "4755503",
    label: "Comercio varejista de artigos de cama, mesa e banho",
  },
  {
    value: "4744099",
    label: "Comércio varejista de materiais de construção em geral",
  },
  {
    value: "9001904",
    label: "Produção de espetáculos circenses, de marionetes e similares",
  },
  {
    value: "3511502",
    label:
      "Atividades de coordenação e controle da operação da geração e transmissão de energia elétrica",
  },
  {
    value: "7119799",
    label:
      "Atividades técnicas relacionadas à engenharia e arquitetura não especificadas anteriormente",
  },
  {
    value: "2121103",
    label: "Fabricação de medicamentos fitoterápicos para uso humano",
  },
  {
    value: "4742300",
    label: "Comércio varejista de material elétrico",
  },
  {
    value: "0116401",
    label: "Cultivo de amendoim",
  },
  {
    value: "2539002",
    label: "Serviços de tratamento e revestimento em metais",
  },
  {
    value: "0892401",
    label: "Extração de sal marinho",
  },
  {
    value: "4646002",
    label: "Comércio atacadista de produtos de higiene pessoal",
  },
  {
    value: "7490103",
    label:
      "Serviços de agronomia e de consultoria às atividades agrícolas e pecuárias",
  },
  {
    value: "6022502",
    label:
      "Atividades relacionadas à televisão por assinatura, exceto programadoras",
  },
  {
    value: "4647802",
    label: "Comércio atacadista de livros, jornais e outras publicações",
  },
  {
    value: "3250704",
    label:
      "Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral, exceto sob encomenda",
  },
  {
    value: "1822901",
    label: "Serviços de encadernação e plastificação",
  },
  {
    value: "1340502",
    label:
      "Alvejamento, tingimento e torção em fios, tecidos, artefatos têxteis e peças do vestuário",
  },
  {
    value: "4649407",
    label: "Comércio atacadista de filmes, CDs, DVDs, fitas e discos",
  },
  {
    value: "9102302",
    label: "Restauração e conservação de lugares e prédios históricos",
  },
  {
    value: "2660400",
    label:
      "Fabricação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação",
  },
  {
    value: "3250707",
    label: "Fabricação de artigos ópticos",
  },
  {
    value: "6120599",
    label:
      "Serviços de telecomunicações sem fio não especificados anteriormente",
  },
  {
    value: "6499901",
    label: "Clubes de investimento",
  },
  {
    value: "0990402",
    label: "Atividades de apoio à extração de minerais metálicos não ferrosos",
  },
  {
    value: "4330404",
    label: "Serviços de pintura de edifícios em geral",
  },
  {
    value: "1071600",
    label: "Fabricação de açúcar em bruto",
  },
  {
    value: "5819100",
    label: "Edição de cadastros, listas e outros produtos gráficos",
  },
  {
    value: "8550302",
    label: "Atividades de apoio à educação, exceto caixas escolares",
  },
  {
    value: "6022501",
    label: "Programadoras",
  },
  {
    value: "9329803",
    label: "Exploração de jogos de sinuca, bilhar e similares",
  },
  {
    value: "4754702",
    label: "Comércio varejista de artigos de colchoaria",
  },
  {
    value: "7490105",
    label:
      "Agenciamento de profissionais para atividades esportivas, culturais e artísticas",
  },
  {
    value: "3211603",
    label: "Cunhagem de moedas e medalhas",
  },
  {
    value: "4649403",
    label:
      "Comércio atacadista de bicicletas, triciclos e outros veículos recreativos",
  },
  {
    value: "1621800",
    label:
      "Fabricação de madeira laminada e de chapas de madeira compensada, prensada e aglomerada",
  },
  {
    value: "8640203",
    label: "Serviços de diálise e nefrologia",
  },
  {
    value: "4761003",
    label: "Comércio varejista de artigos de papelaria",
  },
  {
    value: "2212900",
    label: "Reforma de pneumáticos usados",
  },
  {
    value: "1741902",
    label:
      "Fabricação de produtos de papel, cartolina, papel-cartão e papelão ondulado para uso comercial e de escritório",
  },
  {
    value: "4693100",
    label:
      "Comércio atacadista de mercadorias em geral, sem predominância de alimentos ou de insumos agropecuários",
  },
  {
    value: "6431000",
    label: "Bancos múltiplos, sem carteira comercial",
  },
  {
    value: "4623103",
    label: "Comércio atacadista de algodão",
  },
  {
    value: "1065101",
    label: "Fabricação de amidos e féculas de vegetais",
  },
  {
    value: "1091102",
    label:
      "Fabricação de produtos de padaria e confeitaria com predominância de produção própria",
  },
  {
    value: "0312402",
    label: "Pesca de crustáceos e moluscos em água doce",
  },
  {
    value: "5212500",
    label: "Carga e descarga",
  },
  {
    value: "0810008",
    label: "Extração de saibro e beneficiamento associado",
  },
  {
    value: "6190699",
    label:
      "Outras atividades de telecomunicações não especificadas anteriormente",
  },
  {
    value: "0162802",
    label: "Serviço de tosquiamento de ovinos",
  },
  {
    value: "1353700",
    label: "Fabricação de artefatos de cordoaria",
  },
  {
    value: "1321900",
    label: "Tecelagem de fios de algodão",
  },
  {
    value: "3313901",
    label:
      "Manutenção e reparação de geradores, transformadores e motores elétricos",
  },
  {
    value: "9511800",
    label:
      "Reparação e manutenção de computadores e de equipamentos periféricos",
  },
  {
    value: "2110600",
    label: "Fabricação de produtos farmoquímicos",
  },
  {
    value: "8592902",
    label: "Ensino de artes cênicas, exceto dança",
  },
  {
    value: "2071100",
    label: "Fabricação de tintas, vernizes, esmaltes e lacas",
  },
  {
    value: "2592602",
    label: "Fabricação de produtos de trefilados de metal, exceto padronizados",
  },
  {
    value: "0322106",
    label: "Criação de jacaré",
  },
  {
    value: "6612602",
    label: "Distribuidoras de títulos e valores mobiliários",
  },
  {
    value: "0724302",
    label: "Beneficiamento de minério de metais preciosos",
  },
  {
    value: "4637105",
    label: "Comércio atacadista de massas alimentícias",
  },
  {
    value: "2399101",
    label:
      "Decoração, lapidação, gravação, vitrificação e outros trabalhos em cerâmica, louça, vidro e cristal",
  },
  {
    value: "0729403",
    label: "Extração de minério de níquel",
  },
  {
    value: "5030102",
    label: "Navegação de apoio portuário",
  },
  {
    value: "6470101",
    label: "Fundos de investimento, exceto previdenciários e imobiliários",
  },
  {
    value: "2943300",
    label:
      "Fabricação de peças e acessórios para o sistema de freios de veículos automotores",
  },
  {
    value: "5231103",
    label: "Gestão de terminais aquaviários",
  },
  {
    value: "4721102",
    label: "Padaria e confeitaria com predominância de revenda",
  },
  {
    value: "2790299",
    label:
      "Fabricação de outros equipamentos e aparelhos elétricos não especificados anteriormente",
  },
  {
    value: "1922501",
    label: "Formulação de combustíveis",
  },
  {
    value: "0153902",
    label: "Criação de ovinos, inclusive para produção de lã",
  },
  {
    value: "9101500",
    label: "Atividades de bibliotecas e arquivos",
  },
  {
    value: "0141501",
    label:
      "Produção de sementes certificadas, exceto de forrageiras para pasto",
  },
  {
    value: "8592999",
    label: "Ensino de arte e cultura não especificado anteriormente",
  },
  {
    value: "4541202",
    label:
      "Comércio por atacado de peças e acessórios para motocicletas e motonetas",
  },
  {
    value: "9609207",
    label: "Alojamento de animais domésticos",
  },
  {
    value: "6619303",
    label: "Representações de bancos estrangeiros",
  },
  {
    value: "2811900",
    label:
      "Fabricação de motores e turbinas, peças e acessórios, exceto para aviões e veículos rodoviários",
  },
  {
    value: "1012101",
    label: "Abate de aves",
  },
  {
    value: "2930101",
    label: "Fabricação de cabines, carrocerias e reboques para caminhões",
  },
  {
    value: "8712300",
    label:
      "Atividades de fornecimento de infraestrutura de apoio e assistência a paciente no domicílio",
  },
  {
    value: "8012900",
    label: "Atividades de transporte de valores",
  },
  {
    value: "0116403",
    label: "Cultivo de mamona",
  },
  {
    value: "2094100",
    label: "Fabricação de catalisadores",
  },
  {
    value: "8650004",
    label: "Atividades de fisioterapia",
  },
  {
    value: "8430200",
    label: "Seguridade social obrigatória",
  },
  {
    value: "7319003",
    label: "Marketing direto",
  },
  {
    value: "4614100",
    label:
      "Representantes comerciais e agentes do comércio de máquinas, equipamentos, embarcações e aeronaves",
  },
  {
    value: "4221905",
    label: "Manutenção de estações e redes de telecomunicações",
  },
  {
    value: "4649499",
    label:
      "Comércio atacadista de outros equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente",
  },
  {
    value: "2531402",
    label: "Produção de forjados de metais não ferrosos e suas ligas",
  },
  {
    value: "0133408",
    label: "Cultivo de mamão",
  },
  {
    value: "4647801",
    label: "Comércio atacadista de artigos de escritório e de papelaria",
  },
  {
    value: "2211100",
    label: "Fabricação de pneumáticos e de câmaras-de-ar",
  },
  {
    value: "0133404",
    label: "Cultivo de cítricos, exceto laranja",
  },
  {
    value: "9529106",
    label: "Reparação de jóias",
  },
  {
    value: "9102301",
    label:
      "Atividades de museus e de exploração de lugares e prédios históricos e atrações similares",
  },
  {
    value: "0723501",
    label: "Extração de minério de manganês",
  },
  {
    value: "2733300",
    label: "Fabricação de fios, cabos e condutores elétricos isolados",
  },
  {
    value: "0155503",
    label: "Criação de outros galináceos, exceto para corte",
  },
  {
    value: "0119901",
    label: "Cultivo de abacaxi",
  },
  {
    value: "5223100",
    label: "Estacionamento de veículos",
  },
  {
    value: "3520401",
    label: "Produção de gás; processamento de gás natural",
  },
  {
    value: "0131800",
    label: "Cultivo de laranja",
  },
  {
    value: "4930202",
    label:
      "Transporte rodoviário de carga, exceto produtos perigosos e mudanças, intermunicipal, interestadual e internacional",
  },
  {
    value: "4912403",
    label: "Transporte metroviário",
  },
  {
    value: "1811301",
    label: "Impressão de jornais",
  },
  {
    value: "8520100",
    label: "Ensino médio",
  },
  {
    value: "1091101",
    label: "Fabricação de produtos de panificação industrial",
  },
  {
    value: "2229302",
    label: "Fabricação de artefatos de material plástico para usos industriais",
  },
  {
    value: "5911199",
    label:
      "Atividades de produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente",
  },
  {
    value: "4723700",
    label: "Comércio varejista de bebidas",
  },
  {
    value: "0111301",
    label: "Cultivo de arroz",
  },
  {
    value: "7729299",
    label:
      "Aluguel de outros objetos pessoais e domésticos não especificados anteriormente",
  },
  {
    value: "2759799",
    label:
      "Fabricação de outros aparelhos eletrodomésticos não especificados anteriormente, peças e acessórios",
  },
  {
    value: "1095300",
    label: "Fabricação de especiarias, molhos, temperos e condimentos",
  },
  {
    value: "2013402",
    label: "Fabricação de adubos e fertilizantes, exceto organo-minerais",
  },
  {
    value: "4692300",
    label:
      "Comércio atacadista de mercadorias em geral, com predominância de insumos agropecuários",
  },
  {
    value: "7319099",
    label: "Outras atividades de publicidade não especificadas anteriormente",
  },
  {
    value: "7410203",
    label: "Desing de produto",
  },
  {
    value: "5611204",
    label:
      "Bares e outros estabelecimentos especializados em servir bebidas, sem entretenimento",
  },
  {
    value: "3291400",
    label: "Fabricação de escovas, pincéis e vassouras",
  },
  {
    value: "2865800",
    label:
      "Fabricação de máquinas e equipamentos para as indústrias de celulose, papel e papelão e artefatos, peças e acessórios",
  },
  {
    value: "2652300",
    label: "Fabricação de cronômetros e relógios",
  },
  {
    value: "8219901",
    label: "Fotocópias",
  },
  {
    value: "2550102",
    label: "Fabricação de armas de fogo, outras armas e munições",
  },
  {
    value: "8690903",
    label: "Atividades de acupuntura",
  },
  {
    value: "4399103",
    label: "Obras de alvenaria",
  },
  {
    value: "9491000",
    label: "Atividades de organizações religiosas ou filosóficas",
  },
  {
    value: "7420004",
    label: "Filmagem de festas e eventos",
  },
  {
    value: "5250804",
    label: "Organização logística do transporte de carga",
  },
  {
    value: "2815102",
    label:
      "Fabricação de equipamentos de transmissão para fins industriais, exceto rolamentos",
  },
  {
    value: "0729405",
    label:
      "Beneficiamento de minérios de cobre, chumbo, zinco e outros minerais metálicos não ferrosos não especificados anteriormente",
  },
  {
    value: "4632003",
    label:
      "Comércio atacadista de cereais e leguminosas beneficiados, farinhas, amidos e féculas, com atividade de fracionamento e acondicionamento associada",
  },
  {
    value: "7731400",
    label: "Aluguel de máquinas e equipamentos agrícolas sem operador",
  },
  {
    value: "0121102",
    label: "Cultivo de morango",
  },
  {
    value: "4633802",
    label: "Comércio atacadista de aves vivas e ovos",
  },
  {
    value: "1013901",
    label: "Fabricação de produtos de carne",
  },
  {
    value: "6542100",
    label: "Previdência complementar aberta",
  },
  {
    value: "1311100",
    label: "Preparação e fiação de fibras de algodão",
  },
  {
    value: "0990403",
    label: "Atividades de apoio à extração de minerais não metálicos",
  },
  {
    value: "2599399",
    label:
      "Fabricação de outros produtos de metal não especificados anteriormente",
  },
  {
    value: "3511501",
    label: "Geração de energia elétrica",
  },
  {
    value: "0133406",
    label: "Cultivo de guaraná",
  },
  {
    value: "6612601",
    label: "Corretoras de títulos e valores mobiliários",
  },
  {
    value: "2532201",
    label: "Produção de artefatos estampados de metal",
  },
  {
    value: "0899102",
    label: "Extração de quartzo",
  },
  {
    value: "1012103",
    label: "Frigorífico - abate de suínos",
  },
  {
    value: "2740601",
    label: "Fabricação de lâmpadas",
  },
  {
    value: "4212000",
    label: "Construção de obras de arte especiais",
  },
  {
    value: "5812301",
    label: "Edição de jornais diários",
  },
  {
    value: "5211702",
    label: "Guarda-móveis",
  },
  {
    value: "7020400",
    label:
      "Atividades de consultoria em gestão empresarial, exceto consultoria técnica específica",
  },
  {
    value: "3091102",
    label: "Fabricação de peças e acessórios para motocicletas",
  },
  {
    value: "0729402",
    label: "Extração de minério de tungstênio",
  },
  {
    value: "0151201",
    label: "Criação de bovinos para corte",
  },
  {
    value: "7119703",
    label:
      "Serviços de desenho técnico relacionados à arquitetura e engenharia",
  },
  {
    value: "8640205",
    label:
      "Serviços de diagnóstico por imagem com uso de radiação ionizante, exceto tomografia",
  },
  {
    value: "3321000",
    label: "Instalação de máquinas e equipamentos industriais",
  },
  {
    value: "3312104",
    label: "Manutenção e reparação de equipamentos e instrumentos ópticos",
  },
  {
    value: "1099604",
    label: "Fabricação de gelo comum",
  },
  {
    value: "1011204",
    label: "Frigorífico - abate de bufalinos",
  },
  {
    value: "6499999",
    label:
      "Outras atividades de serviços financeiros não especificadas anteriormente",
  },
  {
    value: "5232000",
    label: "Atividades de agenciamento marítimo",
  },
  {
    value: "4645102",
    label: "Comércio atacadista de próteses e artigos de ortopedia",
  },
  {
    value: "2513600",
    label: "Fabricação de obras de caldeiraria pesada",
  },
  {
    value: "8630501",
    label:
      "Atividade médica ambulatorial com recursos para realização de procedimentos cirúrgicos",
  },
  {
    value: "4520008",
    label: "Serviços de capotaria",
  },
  {
    value: "8650001",
    label: "Atividades de enfermagem",
  },
  {
    value: "3250705",
    label: "Fabricação de materiais para medicina e odontologia",
  },
  {
    value: "6613400",
    label: "Administração de cartões de crédito",
  },
  {
    value: "3314712",
    label: "Manutenção e reparação de tratores agrícolas",
  },
  {
    value: "9609205",
    label: "Atividades de sauna e banhos",
  },
  {
    value: "6810202",
    label: "Aluguel de imóveis próprios",
  },
  {
    value: "3314717",
    label:
      "Manutenção e reparação de máquinas e equipamentos de terraplenagem, pavimentação e construção, exceto tratores",
  },
  {
    value: "4922102",
    label:
      "Transporte rodoviário coletivo de passageiros, com itinerário fixo, interestadual",
  },
  {
    value: "0724301",
    label: "Extração de minério de metais preciosos",
  },
  {
    value: "5611205",
    label:
      "Bares e outros estabelecimentos especializados em servir bebidas, com entretenimento",
  },
  {
    value: "6435201",
    label: "Sociedades de crédito imobiliário",
  },
  {
    value: "0155502",
    label: "Produção de pintos de um dia",
  },
  {
    value: "1112700",
    label: "Fabricação de vinho",
  },
  {
    value: "4771704",
    label: "Comércio varejista de medicamentos veterinários",
  },
  {
    value: "4623108",
    label:
      "Comércio atacadista de matérias-primas agrícolas com atividade de fracionamento e acondicionamento associada",
  },
  {
    value: "8030700",
    label: "Atividades de investigação particular",
  },
  {
    value: "4541207",
    label:
      "Comércio a varejo de peças e acessórios usados para motocicletas e motonetas",
  },
  {
    value: "7733100",
    label: "Aluguel de máquinas e equipamentos para escritório",
  },
  {
    value: "2330301",
    label:
      "Fabricação de estruturas pré-moldadas de concreto armado, em série e sob encomenda",
  },
  {
    value: "0723502",
    label: "Beneficiamento de minério de manganês",
  },
  {
    value: "7120100",
    label: "Testes e análises técnicas",
  },
  {
    value: "2599301",
    label: "Serviços de confecção de armações metálicas para a construção",
  },
  {
    value: "1412603",
    label: "Facção de peças do vestuário, exceto roupas íntimas",
  },
  {
    value: "0116402",
    label: "Cultivo de girassol",
  },
  {
    value: "5611203",
    label: "Lanchonetes, casas de chá, de sucos e similares",
  },
  {
    value: "4399101",
    label: "Administração de obras",
  },
  {
    value: "9001905",
    label: "Produção de espetáculos de rodeios, vaquejadas e similares",
  },
  {
    value: "2311700",
    label: "Fabricação de vidro plano e de segurança",
  },
  {
    value: "8541400",
    label: "Educação profissional de nível técnico",
  },
  {
    value: "2423701",
    label: "Produção de tubos de aço sem costura",
  },
  {
    value: "0116499",
    label:
      "Cultivo de outras oleaginosas de lavoura temporária não especificadas anteriormente",
  },
  {
    value: "8592903",
    label: "Ensino de música",
  },
  {
    value: "3031800",
    label: "Fabricação de locomotivas, vagões e outros materiais rodantes",
  },
  {
    value: "4520005",
    label:
      "Serviços de lavagem, lubrificação e polimento de veículos automotores",
  },
  {
    value: "8130300",
    label: "Atividades paisagísticas",
  },
  {
    value: "3314702",
    label:
      "Manutenção e reparação de equipamentos hidráulicos e pneumáticos, exceto válvulas",
  },
  {
    value: "2710401",
    label:
      "Fabricação de geradores de corrente contínua e alternada, peças e acessórios",
  },
  {
    value: "4322303",
    label: "Instalações de sistema de prevenção contra incêndio",
  },
  {
    value: "6424704",
    label: "Cooperativas de crédito rural",
  },
  {
    value: "4763602",
    label: "Comércio varejista de artigos esportivos",
  },
  {
    value: "1063500",
    label: "Fabricação de farinha de mandioca e derivados",
  },
  {
    value: "2411300",
    label: "Produção de ferro-gusa",
  },
  {
    value: "6143400",
    label: "Operadoras de televisão por assinatura por satélite",
  },
  {
    value: "7112000",
    label: "Serviços de engenharia",
  },
  {
    value: "7739002",
    label:
      "Aluguel de equipamentos científicos, médicos e hospitalares, sem operador",
  },
  {
    value: "1421500",
    label: "Fabricação de meias",
  },
  {
    value: "6492100",
    label: "Securitização de créditos",
  },
  {
    value: "1011205",
    label: "Matadouro - abate de reses sob contrato, exceto abate de suínos",
  },
  {
    value: "4633801",
    label:
      "Comércio atacadista de frutas, verduras, raízes, tubérculos, hortaliças e legumes frescos",
  },
  {
    value: "9609204",
    label: "Exploração de máquinas de serviços pessoais acionadas por moeda",
  },
  {
    value: "1812100",
    label: "Impressão de material de segurança",
  },
  {
    value: "0322101",
    label: "Criação de peixes em água doce",
  },
  {
    value: "1622601",
    label: "Fabricação de casas de madeira pré-fabricadas",
  },
  {
    value: "2330304",
    label: "Fabricação de casas pré-moldadas de concreto",
  },
  {
    value: "4291000",
    label: "Obras portuárias, marítimas e fluviais",
  },
  {
    value: "4520003",
    label:
      "Serviços de manutenção e reparação elétrica de veículos automotores",
  },
  {
    value: "7719501",
    label:
      "Locação de embarcações sem tripulação, exceto para fins\nrecreativos",
  },
  {
    value: "2731700",
    label:
      "Fabricação de aparelhos e equipamentos para distribuição e controle de energia elétrica",
  },
  {
    value: "2591800",
    label: "Fabricação de embalagens metálicas",
  },
  {
    value: "8640211",
    label: "Serviços de radioterapia",
  },
  {
    value: "4329101",
    label: "Instalação de painéis publicitários",
  },
  {
    value: "0312401",
    label: "Pesca de peixes em água doce",
  },
  {
    value: "8291100",
    label: "Atividades de cobrança e informações cadastrais",
  },
  {
    value: "4783102",
    label: "Comércio varejista de artigos de relojoaria",
  },
  {
    value: "3250708",
    label:
      "Fabricação de artefatos de tecido não tecido para uso odonto-médico-hospitalar",
  },
  {
    value: "1210700",
    label: "Processamento industrial do fumo",
  },
  {
    value: "2543800",
    label: "Fabricação de ferramentas",
  },
  {
    value: "5011401",
    label: "Transporte marítimo de cabotagem - Carga",
  },
  {
    value: "4930203",
    label: "Transporte rodoviário de produtos perigosos",
  },
  {
    value: "4683400",
    label:
      "Comércio atacadista de defensivos agrícolas, adubos, fertilizantes e corretivos do solo",
  },
  {
    value: "4922101",
    label:
      "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal, exceto em região metropolitana",
  },
  {
    value: "9311500",
    label: "Gestão de instalações de esportes",
  },
  {
    value: "0139301",
    label: "Cultivo de chá-da-índia",
  },
  {
    value: "6461100",
    label: "Holdings de instituições financeiras",
  },
  {
    value: "4329199",
    label:
      "Outras obras de instalações em construções não especificadas anteriormente",
  },
  {
    value: "1412601",
    label:
      "Confecção de peças do vestuário, exceto roupas íntimas e as confeccionadas sob medida",
  },
  {
    value: "8299702",
    label: "Emissão de vales-alimentação, vales-transporte e similares",
  },
  {
    value: "7410299",
    label: "Atividades de desing não especificadas anteriormente",
  },
  {
    value: "0600001",
    label: "Extração de petróleo e gás natural",
  },
  {
    value: "8630504",
    label: "Atividade odontológica",
  },
  {
    value: "4762800",
    label: "Comércio varejista de discos, CDs, DVDs e fitas",
  },
  {
    value: "3314720",
    label:
      "Manutenção e reparação de máquinas e equipamentos para a indústria têxtil, do vestuário, do couro e calçados",
  },
  {
    value: "1710900",
    label: "Fabricação de celulose e outras pastas para a fabricação de papel",
  },
  {
    value: "6619301",
    label: "Serviços de liquidação e custódia",
  },
  {
    value: "4511105",
    label: "Comércio por atacado de reboques e semireboques novos e usados",
  },
  {
    value: "3530100",
    label: "Produção e distribuição de vapor, água quente e ar condicionado",
  },
  {
    value: "2949299",
    label:
      "Fabricação de outras peças e acessórios para veículos automotores não especificadas anteriormente",
  },
  {
    value: "3091101",
    label: "Fabricação de motocicletas",
  },
  {
    value: "8411600",
    label: "Administração pública em geral",
  },
  {
    value: "4662100",
    label:
      "Comércio atacadista de máquinas, equipamentos para terraplenagem, mineração e construção; partes e peças",
  },
  {
    value: "2022300",
    label: "Fabricação de intermediários para plastificantes, resinas e fibras",
  },
  {
    value: "0152103",
    label: "Criação de asininos e muares",
  },
  {
    value: "3240002",
    label:
      "Fabricação de mesas de bilhar, de sinuca e acessórios não associada à locação",
  },
  {
    value: "1413403",
    label: "Facção de roupas profissionais",
  },
  {
    value: "0161002",
    label: "Serviço de poda de árvores para lavouras",
  },
  {
    value: "4622200",
    label: "Comércio atacadista de soja",
  },
  {
    value: "0133407",
    label: "Cultivo de maçã",
  },
  {
    value: "2821602",
    label:
      "Fabricação de estufas e fornos elétricos para fins industriais, peças e acessórios",
  },
  {
    value: "3312102",
    label:
      "Manutenção e reparação de aparelhos e instrumentos de medida, teste e controle",
  },
  {
    value: "2319200",
    label: "Fabricação de artigos de vidro",
  },
  {
    value: "3316301",
    label: "Manutenção e reparação de aeronaves, exceto a manutenção na pista",
  },
  {
    value: "6203100",
    label:
      "Desenvolvimento e licenciamento de programas de computador não customizáveis",
  },
  {
    value: "5239700",
    label:
      "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente",
  },
  {
    value: "4643502",
    label: "Comércio atacadista de bolsas, malas e artigos de viagem",
  },
  {
    value: "2824101",
    label:
      "Fabricação de aparelhos e equipamentos de ar condicionado para uso industrial",
  },
  {
    value: "9493600",
    label: "Atividades de organizações associativas ligadas à cultura e à arte",
  },
  {
    value: "4616800",
    label:
      "Representantes comerciais e agentes do comércio de têxteis, vestuário, calçados e artigos de viagem",
  },
  {
    value: "2512800",
    label: "Fabricação de esquadrias de metal",
  },
  {
    value: "6920601",
    label: "Atividades de contabilidade",
  },
  {
    value: "4541205",
    label:
      "Comércio a varejo de peças e acessórios para motocicletas e motonetas",
  },
  {
    value: "7739001",
    label:
      "Aluguel de máquinas e equipamentos para extração de minérios e petróleo, sem operador",
  },
  {
    value: "0721902",
    label: "Beneficiamento de minério de alumínio",
  },
  {
    value: "6110899",
    label:
      "Serviços de telecomunicações por fio não especificados anteriormente",
  },
  {
    value: "9002701",
    label:
      "Atividades de artistas plásticos, jornalistas independentes e\nescritores",
  },
  {
    value: "5239701",
    label: "Serviços de praticagem",
  },
  {
    value: "4664800",
    label:
      "Comércio atacadista de máquinas, aparelhos e equipamentos para uso odonto-médico-hospitalar; partes e peças",
  },
  {
    value: "4649401",
    label:
      "Comércio atacadista de equipamentos elétricos de uso pessoal e doméstico",
  },
  {
    value: "4330499",
    label: "Outras obras de acabamento da construção",
  },
  {
    value: "4618499",
    label:
      "Outros representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente",
  },
  {
    value: "5620104",
    label:
      "Fornecimento de alimentos preparados preponderantemente para consumo domiciliar",
  },
  {
    value: "5239799",
    label:
      "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente",
  },
  {
    value: "4759801",
    label: "Comércio varejista de artigos de tapeçaria, cortinas e persianas",
  },
  {
    value: "5310502",
    label: "Atividades de franqueadas e permissionárias do Correio Nacional",
  },
  {
    value: "4642701",
    label:
      "Comércio atacadista de artigos do vestuário e acessórios, exceto profissionais e de segurança",
  },
  {
    value: "7990200",
    label:
      "Serviços de reservas e outros serviços de turismo não especificados anteriormente",
  },
  {
    value: "6912500",
    label: "Cartórios",
  },
  {
    value: "4789009",
    label: "Comércio varejista de armas e munições",
  },
  {
    value: "8129000",
    label: "Atividades de limpeza não especificadas anteriormente",
  },
  {
    value: "9412000",
    label: "Atividades de organizações associativas profissionais",
  },
  {
    value: "4520006",
    label: "Serviços de borracharia para veículos automotores",
  },
  {
    value: "9609203",
    label: "Alojamento, higiene e embelezamento de animais",
  },
  {
    value: "6810203",
    label: "Loteamento de imóveis próprios",
  },
  {
    value: "3102100",
    label: "Fabricação de móveis com predominância de metal",
  },
  {
    value: "3250702",
    label:
      "Fabricação de mobiliário para uso médico, cirúrgico, odontológico e de laboratório",
  },
  {
    value: "4330405",
    label: "Aplicação de revestimentos e de resinas em interiores e exteriores",
  },
  {
    value: "9603304",
    label: "Serviços de funerárias",
  },
  {
    value: "1012102",
    label: "Abate de pequenos animais",
  },
  {
    value: "2862300",
    label:
      "Fabricação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo, peças e acessórios",
  },
  {
    value: "2349499",
    label:
      "Fabricação de produtos cerâmicos não refratários não especificados anteriormente",
  },
  {
    value: "4222701",
    label:
      "Construção de redes de abastecimento de água, coleta de esgoto e construções correlatas, exceto obras de irrigação",
  },
  {
    value: "7490101",
    label: "Serviços de tradução, interpretação e similares",
  },
  {
    value: "4755502",
    label: "Comercio varejista de artigos de armarinho",
  },
  {
    value: "4541204",
    label: "Comércio a varejo de motocicletas e motonetas usadas",
  },
  {
    value: "1051100",
    label: "Preparação do leite",
  },
  {
    value: "0810099",
    label:
      "Extração e britamento de pedras e outros materiais para construção e beneficiamento associado",
  },
  {
    value: "0133402",
    label: "Cultivo de banana",
  },
  {
    value: "0119909",
    label: "Cultivo de tomate rasteiro",
  },
  {
    value: "3511500",
    label: "Geração de energia elétrica",
  },
  {
    value: "6433600",
    label: "Bancos de desenvolvimento",
  },
  {
    value: "9601703",
    label: "Toalheiros",
  },
  {
    value: "0162899",
    label: "Atividades de apoio à pecuária não especificadas anteriormente",
  },
  {
    value: "2680900",
    label: "Fabricação de mídias virgens, magnéticas e ópticas",
  },
  {
    value: "5510803",
    label: "Motéis",
  },
  {
    value: "4684299",
    label:
      "Comércio atacadista de outros produtos químicos e petroquímicos não especificados anteriormente",
  },
  {
    value: "7319002",
    label: "Promoção de vendas",
  },
  {
    value: "4635402",
    label: "Comércio atacadista de cerveja, chope e refrigerante",
  },
  {
    value: "5231101",
    label: "Administração da infraestrutura portuária",
  },
  {
    value: "7732202",
    label: "Aluguel de andaimes",
  },
  {
    value: "4744003",
    label: "Comércio varejista de materiais hidráulicos",
  },
  {
    value: "2710403",
    label: "Fabricação de motores elétricos, peças e acessórios",
  },
  {
    value: "0133410",
    label: "Cultivo de manga",
  },
  {
    value: "0210105",
    label:
      "Cultivo de espécies madeireiras, exceto eucalipto, acácia-negra, pinus e teca",
  },
  {
    value: "1020101",
    label: "Preservação de peixes, crustáceos e moluscos",
  },
  {
    value: "0139305",
    label: "Cultivo de dendê",
  },
  {
    value: "5221400",
    label:
      "Concessionárias de rodovias, pontes, túneis e serviços relacionados",
  },
  {
    value: "2542000",
    label: "Fabricação de artigos de serralheria, exceto esquadrias",
  },
  {
    value: "0161099",
    label: "Atividades de apoio à agricultura não especificadas anteriormente",
  },
  {
    value: "1033301",
    label: "Fabricação de sucos concentrados de frutas, hortaliças e legumes",
  },
  {
    value: "4652400",
    label:
      "Comércio atacadista de componentes eletrônicos e equipamentos de telefonia e comunicação",
  },
  {
    value: "0159804",
    label: "Criação de bicho-da-seda",
  },
  {
    value: "8531700",
    label: "Educação superior - graduação",
  },
  {
    value: "4634603",
    label: "Comércio atacadista de pescados e frutos do mar",
  },
  {
    value: "2439300",
    label: "Produção de outros tubos de ferro e aço",
  },
  {
    value: "5320201",
    label: "Serviços de malote não realizados pelo Correio Nacional",
  },
  {
    value: "8299799",
    label:
      "Outras atividades de serviços prestados principalmente às empresas não especificadas anteriormente",
  },
  {
    value: "3313999",
    label:
      "Manutenção e reparação de máquinas, aparelhos e materiais elétricos não especificados anteriormente",
  },
  {
    value: "2833000",
    label:
      "Fabricação de máquinas e equipamentos para a agricultura e pecuária, peças e acessórios, exceto para irrigação",
  },
  {
    value: "8299703",
    label: "Serviços de gravação de carimbos, exceto confecção",
  },
  {
    value: "8720401",
    label: "Atividades de centros de assistência psicossocial",
  },
  {
    value: "4618402",
    label:
      "Representantes comerciais e agentes do comércio de instrumentos e materiais odonto-médico-hospitalares",
  },
  {
    value: "4299501",
    label: "Construção de instalações esportivas e recreativas",
  },
  {
    value: "0810005",
    label: "Extração de gesso e caulim",
  },
  {
    value: "6462000",
    label: "Holdings de instituições não financeiras",
  },
  {
    value: "4649406",
    label: "Comércio atacadista de lustres, luminárias e abajures",
  },
  {
    value: "4722902",
    label: "Peixaria",
  },
  {
    value: "5250805",
    label: "Operador de transporte multimodal - OTM",
  },
  {
    value: "4621400",
    label: "Comércio atacadista de café em grão",
  },
  {
    value: "4789003",
    label: "Comércio varejista de objetos de arte",
  },
  {
    value: "4763605",
    label:
      "Comércio varejista de embarcações e outros veículos recreativos; peças e acessórios",
  },
  {
    value: "3314721",
    label:
      "Manutenção e reparação de máquinas e aparelhos para a indústria de celulose, papel e papelão e artefatos",
  },
  {
    value: "3011301",
    label: "Construção de embarcações de grande porte",
  },
  {
    value: "4520004",
    label: "Serviços de alinhamento e balanceamento de veículos automotores",
  },
  {
    value: "4211101",
    label: "Construção de rodovias e ferrovias",
  },
  {
    value: "4789007",
    label: "Comércio varejista de equipamentos para escritório",
  },
  {
    value: "2392300",
    label: "Fabricação de cal e gesso",
  },
  {
    value: "4649408",
    label:
      "Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar",
  },
  {
    value: "8292000",
    label: "Envasamento e empacotamento sob contrato",
  },
  {
    value: "0600003",
    label: "Extração e beneficiamento de areias betuminosas",
  },
  {
    value: "2011800",
    label: "Fabricação de cloro e álcalis",
  },
  {
    value: "8599601",
    label: "Formação de condutores",
  },
  {
    value: "4713003",
    label: "Lojas duty free de aeroportos internacionais",
  },
  {
    value: "4646001",
    label: "Comércio atacadista de cosméticos e produtos de perfumaria",
  },
  {
    value: "1749400",
    label:
      "Fabricação de produtos de pastas celulósicas, papel, cartolina, papel-cartão e papelão ondulado não especificados anteriormente",
  },
  {
    value: "1610202",
    label: "Serrarias sem desdobramento de madeira",
  },
  {
    value: "0210101",
    label: "Cultivo de eucalipto",
  },
  {
    value: "4669999",
    label:
      "Comércio atacadista de outras máquinas e equipamentos não especificados anteriormente; partes e peças",
  },
  {
    value: "9529102",
    label: "Chaveiros",
  },
  {
    value: "3520402",
    label: "Distribuição de combustíveis gasosos por redes urbanas",
  },
  {
    value: "1921700",
    label: "Fabricação de produtos do refino de petróleo",
  },
  {
    value: "6437900",
    label: "Sociedades de crédito ao microempreendedor",
  },
  {
    value: "0161003",
    label: "Serviço de preparação de terreno, cultivo e colheita",
  },
  {
    value: "0119906",
    label: "Cultivo de mandioca",
  },
  {
    value: "7410202",
    label: "Design de interiores",
  },
  {
    value: "3092000",
    label:
      "Fabricação de bicicletas e triciclos não motorizados, peças e acessórios",
  },
  {
    value: "1510600",
    label: "Curtimento e outras preparações de couro",
  },
  {
    value: "4681802",
    label:
      "Comércio atacadista de combustíveis realizado por transportador retalhista (TRR)",
  },
  {
    value: "0119903",
    label: "Cultivo de batata-inglesa",
  },
  {
    value: "2222600",
    label: "Fabricação de embalagens de material plástico",
  },
  {
    value: "8730199",
    label:
      "Atividades de assistência social prestadas em residências coletivas e particulares não especificadas anteriormente",
  },
  {
    value: "2814302",
    label:
      "Fabricação de compressores para uso não industrial, peças e acessórios",
  },
  {
    value: "2033900",
    label: "Fabricação de elastômeros",
  },
  {
    value: "4634699",
    label: "Comércio atacadista de carnes e derivados de outros animais",
  },
  {
    value: "2751100",
    label:
      "Fabricação de fogões, refrigeradores e máquinas de lavar e secar para uso doméstico, peças e acessórios",
  },
  {
    value: "0321301",
    label: "Criação de peixes em água salgada e salobra",
  },
  {
    value: "1622602",
    label:
      "Fabricação de esquadrias de madeira e de peças de madeira para instalações industriais e comerciais",
  },
  {
    value: "4685100",
    label:
      "Comércio atacadista de produtos siderúrgicos e metalúrgicos, exceto para construção",
  },
  {
    value: "8640208",
    label:
      "Serviços de diagnóstico por registro gráfico - ECG, EEG e outros exames análogos",
  },
  {
    value: "5022001",
    label:
      "Transporte por navegação interior de passageiros em linhas regulares, municipal, exceto travessia",
  },
  {
    value: "1533500",
    label: "Fabricação de calçados de material sintético",
  },
  {
    value: "4682600",
    label: "Comércio atacadista de gás liquefeito de petróleo (GLP)",
  },
  {
    value: "0119905",
    label: "Cultivo de feijão",
  },
  {
    value: "4789099",
    label:
      "Comércio varejista de outros produtos não especificados anteriormente",
  },
  {
    value: "0810006",
    label:
      "Extração de areia, cascalho ou pedregulho e beneficiamento associado",
  },
  {
    value: "4679604",
    label:
      "Comércio atacadista especializado de materiais de construção não especificados anteriormente",
  },
  {
    value: "1220403",
    label: "Fabricação de filtros para cigarros",
  },
  {
    value: "1111902",
    label: "Fabricação de outras aguardentes e bebidas destiladas",
  },
  {
    value: "1414200",
    label:
      "Fabricação de acessórios do vestuário, exceto para segurança e proteção",
  },
  {
    value: "1093702",
    label: "Fabricação de frutas cristalizadas, balas e semelhantes",
  },
  {
    value: "0899103",
    label: "Extração de amianto",
  },
  {
    value: "2920402",
    label: "Fabricação de motores para caminhões e ônibus",
  },
  {
    value: "6434400",
    label: "Agências de fomento",
  },
  {
    value: "0230600",
    label: "Atividades de apoio à produção florestal",
  },
  {
    value: "2593400",
    label: "Fabricação de artigos de metal para uso doméstico e pessoal",
  },
  {
    value: "2391503",
    label:
      "Aparelhamento de placas e execução de trabalhos em mármore, granito, ardósia e outras pedras",
  },
  {
    value: "1011202",
    label: "Frigorífico - abate de equinos",
  },
  {
    value: "4663000",
    label:
      "Comércio atacadista de máquinas e equipamentos para uso industrial; partes e peças",
  },
  {
    value: "4221902",
    label: "Construção de estações e redes de distribuição de energia elétrica",
  },
  {
    value: "4751200",
    label:
      "Comércio varejista especializado de equipamentos e suprimentos de informática",
  },
  {
    value: "2123800",
    label: "Fabricação de preparações farmacêuticas",
  },
  {
    value: "1099606",
    label: "Fabricação de adoçantes naturais e artificiais",
  },
  {
    value: "0151202",
    label: "Criação de bovinos para leite",
  },
  {
    value: "0810009",
    label: "Extração de basalto e beneficiamento associado",
  },
  {
    value: "4789008",
    label: "Comércio varejista de artigos fotográficos e para filmagem",
  },
  {
    value: "0312404",
    label: "Atividades de apoio à pesca em água doce",
  },
  {
    value: "6499903",
    label: "Fundo garantidor de crédito",
  },
  {
    value: "2829101",
    label:
      "Fabricação de máquinas de escrever, calcular e outros equipamentos não eletrônicos para escritório, peças e acessórios",
  },
  {
    value: "0152101",
    label: "Criação de bufalinos",
  },
  {
    value: "4679601",
    label: "Comércio atacadista de tintas, vernizes e similares",
  },
  {
    value: "5812302",
    label: "Edição de jornais não diários",
  },
  {
    value: "3104700",
    label: "Fabricação de colchões",
  },
  {
    value: "8511200",
    label: "Educação infantil - creche",
  },
  {
    value: "1099605",
    label: "Fabricação de produtos para infusão (chá, mate, etc.)",
  },
  {
    value: "0892403",
    label: "Refino e outros tratamentos do sal",
  },
  {
    value: "8599605",
    label: "Cursos preparatórios para concursos",
  },
  {
    value: "2853400",
    label: "Fabricação de tratores, peças e acessórios, exceto agrícolas",
  },
  {
    value: "8599699",
    label: "Outras atividades de ensino não especificadas anteriormente",
  },
  {
    value: "4637104",
    label: "Comércio atacadista de pães, bolos, biscoitos e similares",
  },
  {
    value: "4774100",
    label: "Comércio varejista de artigos de óptica",
  },
  {
    value: "3314704",
    label: "Manutenção e reparação de compressores",
  },
  {
    value: "0111302",
    label: "Cultivo de milho",
  },
  {
    value: "0725100",
    label: "Extração de minerais radioativos",
  },
  {
    value: "1099699",
    label:
      "Fabricação de outros produtos alimentícios não especificados anteriormente",
  },
  {
    value: "0119907",
    label: "Cultivo de melão",
  },
  {
    value: "5912099",
    label:
      "Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente",
  },
  {
    value: "4634602",
    label: "Comércio atacadista de aves abatidas e derivados",
  },
  {
    value: "4619200",
    label:
      "Representantes comerciais e agentes do comércio de mercadorias em geral não especializado",
  },
  {
    value: "4512902",
    label: "Comércio sob consignação de veículos automotores",
  },
  {
    value: "1354500",
    label: "Fabricação de tecidos especiais, inclusive artefatos",
  },
  {
    value: "4783101",
    label: "Comércio varejista de artigos de joalheria",
  },
  {
    value: "8711501",
    label: "Clínicas e residências geriátricas",
  },
  {
    value: "0119908",
    label: "Cultivo de melancia",
  },
  {
    value: "8720499",
    label:
      "Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência mental e dependência química e grupos similares não especificadas anteriormente",
  },
  {
    value: "9200399",
    label:
      "Exploração de jogos de azar e apostas não especificados anteriormente",
  },
  {
    value: "4911600",
    label: "Transporte ferroviário de carga",
  },
  {
    value: "1413402",
    label: "Confecção, sob medida, de roupas profissionais",
  },
  {
    value: "0810002",
    label: "Extração de granito e beneficiamento associado",
  },
  {
    value: "0134200",
    label: "Cultivo de café",
  },
  {
    value: "5211799",
    label:
      "Depósitos de mercadorias para terceiros, exceto armazéns gerais e guarda-móveis",
  },
  {
    value: "1313800",
    label: "Fiação de fibras artificiais e sintéticas",
  },
  {
    value: "4222702",
    label: "Obras de irrigação",
  },
  {
    value: "6822600",
    label: "Gestão e administração da propriedade imobiliária",
  },
  {
    value: "4781400",
    label: "Comércio varejista de artigos do vestuário e acessórios",
  },
  {
    value: "0139302",
    label: "Cultivo de erva-mate",
  },
  {
    value: "4673700",
    label: "Comércio atacadista de material elétrico",
  },
  {
    value: "2910702",
    label:
      "Fabricação de chassis com motor para automóveis, camionetas e utilitários",
  },
  {
    value: "1359600",
    label:
      "Fabricação de outros produtos têxteis não especificados anteriormente",
  },
  {
    value: "2229303",
    label:
      "Fabricação de artefatos de material plástico para uso na construção, exceto tubos e acessórios",
  },
  {
    value: "0311601",
    label: "Pesca de peixes em água salgada",
  },
  {
    value: "9900800",
    label: "Organismos internacionais e outras instituições extraterritoriais",
  },
  {
    value: "1822900",
    label: "Serviços de acabamentos gráficos",
  },
  {
    value: "3315500",
    label: "Manutenção e reparação de veículos ferroviários",
  },
  {
    value: "1065102",
    label: "Fabricação de óleo de milho em bruto",
  },
  {
    value: "9319199",
    label: "Outras atividades esportivas não especificadas anteriormente",
  },
  {
    value: "1032599",
    label:
      "Fabricação de conservas de legumes e outros vegetais, exceto palmito",
  },
  {
    value: "2092402",
    label: "Fabricação de artigos pirotécnicos",
  },
  {
    value: "5590603",
    label: "Pensões (alojamento)",
  },
  {
    value: "3317102",
    label: "Manutenção e reparação de embarcações para esporte e lazer",
  },
  {
    value: "2550101",
    label:
      "Fabricação de equipamento bélico pesado, exceto veículos militares de combate",
  },
  {
    value: "9603301",
    label: "Gestão e manutenção de cemitérios",
  },
  {
    value: "7719599",
    label:
      "Locação de outros meios de transporte não especificados anteriormente, sem condutor",
  },
  {
    value: "4623105",
    label: "Comércio atacadista de cacau",
  },
  {
    value: "2840200",
    label: "Fabricação de máquinas-ferramenta, peças e acessórios",
  },
  {
    value: "4713001",
    label: "Lojas de departamentos ou magazines",
  },
  {
    value: "3702900",
    label: "Atividades relacionadas a esgoto, exceto a gestão de redes",
  },
  {
    value: "2451200",
    label: "Fundição de ferro e aço",
  },
  {
    value: "1031700",
    label: "Fabricação de conservas de frutas",
  },
  {
    value: "4784900",
    label: "Comércio varejista de gás liqüefeito de petróleo (GLP)",
  },
  {
    value: "4511104",
    label: "Comércio por atacado de caminhões novos e usados",
  },
  {
    value: "4292801",
    label: "Montagem de estruturas metálicas",
  },
  {
    value: "2869100",
    label:
      "Fabricação de máquinas e equipamentos para uso industrial específico não especificados anteriormente, peças e acessórios",
  },
  {
    value: "1041400",
    label: "Fabricação de óleos vegetais em bruto, exceto óleo de milho",
  },
  {
    value: "0500301",
    label: "Extração de carvão mineral",
  },
  {
    value: "8630507",
    label: "Atividades de reprodução humana assistida",
  },
  {
    value: "0121101",
    label: "Horticultura, exceto morango",
  },
  {
    value: "2422901",
    label: "Produção de laminados planos de aço ao carbono, revestidos ou não",
  },
  {
    value: "6619305",
    label: "Operadoras de cartões de débito",
  },
  {
    value: "4785799",
    label: "Comércio varejista de outros artigos usados",
  },
  {
    value: "3314707",
    label:
      "Manutenção e reparação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial",
  },
  {
    value: "8592901",
    label: "Ensino de dança",
  },
  {
    value: "9529105",
    label: "Reparação de artigos do mobiliário",
  },
  {
    value: "2945000",
    label:
      "Fabricação de material elétrico e eletrônico para veículos automotores, exceto baterias",
  },
  {
    value: "7729202",
    label:
      "Aluguel de móveis, utensílios e aparelhos de uso doméstico e pessoal; instrumentos musicais",
  },
  {
    value: "2949201",
    label: "Fabricação de bancos e estofados para veículos automotores",
  },
  {
    value: "6911703",
    label: "Agente de propriedade industrial",
  },
  {
    value: "4618401",
    label:
      "Representantes comerciais e agentes do comércio de medicamentos, cosméticos e produtos de perfumaria",
  },
  {
    value: "2019301",
    label: "Elaboração de combustíveis nucleares",
  },
  {
    value: "1220402",
    label: "Fabricação de cigarrilhas e charutos",
  },
  {
    value: "1412602",
    label:
      "Confecção, sob medida, de peças do vestuário, exceto roupas íntimas",
  },
  {
    value: "9329802",
    label: "Exploração de boliches",
  },
  {
    value: "9609206",
    label: "Serviços de tatuagem e colocação de piercing",
  },
  {
    value: "9602501",
    label: "Cabeleireiros, manicure e pedicure",
  },
  {
    value: "2040100",
    label: "Fabricação de fibras artificiais e sintéticas",
  },
  {
    value: "6201500",
    label: "Desenvolvimento de programas de computador sob encomenda",
  },
  {
    value: "4744001",
    label: "Comércio varejista de ferragens e ferramentas",
  },
  {
    value: "2229301",
    label:
      "Fabricação de artefatos de material plástico para uso pessoal e doméstico",
  },
  {
    value: "4782201",
    label: "Comércio varejista de calçados",
  },
  {
    value: "3812200",
    label: "Coleta de resíduos perigosos",
  },
  {
    value: "9603303",
    label: "Serviços de sepultamento",
  },
  {
    value: "0729404",
    label:
      "Extração de minérios de cobre, chumbo, zinco e outros minerais metálicos não ferrosos não especificados anteriormente",
  },
  {
    value: "8111700",
    label:
      "Serviços combinados para apoio a edifícios, exceto condomínios prediais",
  },
  {
    value: "7719502",
    label: "Locação de aeronaves sem tripulação",
  },
  {
    value: "4721104",
    label: "Comércio varejista de doces, balas, bombons e semelhantes",
  },
  {
    value: "6491300",
    label: "Sociedades de fomento mercantil - factoring",
  },
  {
    value: "8650003",
    label: "Atividades de psicologia e psicanálise",
  },
  {
    value: "4635499",
    label: "Comércio atacadista de bebidas não especificadas anteriormente",
  },
  {
    value: "4634601",
    label: "Comércio atacadista de carnes bovinas e suínas e derivados",
  },
  {
    value: "0210103",
    label: "Cultivo de pinus",
  },
  {
    value: "9412001",
    label: "Atividades de fiscalização profissional",
  },
  {
    value: "2825900",
    label:
      "Fabricação de máquinas e equipamentos para saneamento básico e ambiental, peças e acessórios",
  },
  {
    value: "4930204",
    label: "Transporte rodoviário de mudanças",
  },
  {
    value: "4512901",
    label:
      "Representantes comerciais e agentes do comércio de veículos automotores",
  },
  {
    value: "7410201",
    label: "Design",
  },
  {
    value: "4921301",
    label:
      "Transporte rodoviário coletivo de passageiros, com itinerário fixo, municipal",
  },
  {
    value: "1322700",
    label: "Tecelagem de fios de fibras têxteis naturais, exceto algodão",
  },
  {
    value: "3319800",
    label:
      "Manutenção e reparação de equipamentos e produtos não especificados anteriormente",
  },
  {
    value: "2449102",
    label: "Produção de laminados de zinco",
  },
  {
    value: "0220906",
    label: "Conservação de florestas nativas",
  },
  {
    value: "2822402",
    label:
      "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas, peças e acessórios",
  },
  {
    value: "1830002",
    label: "Reprodução de vídeo em qualquer suporte",
  },
  {
    value: "2342702",
    label:
      "Fabricação de artefatos de cerâmica e barro cozido para uso na construção, exceto azulejos e pisos",
  },
  {
    value: "9001906",
    label: "Atividades de sonorização e de iluminação",
  },
  {
    value: "4912401",
    label:
      "Transporte ferroviário de passageiros intermunicipal e interestadual",
  },
  {
    value: "1043100",
    label:
      "Fabricação de margarina e outras gorduras vegetais e de óleos não comestíveis de animais",
  },
  {
    value: "6421200",
    label: "Bancos comerciais",
  },
  {
    value: "2092403",
    label: "Fabricação de fósforos de segurança",
  },
  {
    value: "9529104",
    label:
      "Reparação de bicicletas, triciclos e outros veículos não motorizados",
  },
  {
    value: "5012201",
    label: "Transporte marítimo de longo curso - Carga",
  },
  {
    value: "0990401",
    label: "Atividades de apoio à extração de minério de ferro",
  },
  {
    value: "3041500",
    label: "Fabricação de aeronaves",
  },
  {
    value: "8690901",
    label:
      "Atividades de práticas integrativas e complementares em saúde humana",
  },
  {
    value: "2610800",
    label: "Fabricação de componentes eletrônicos",
  },
  {
    value: "4773300",
    label: "Comércio varejista de artigos médicos e ortopédicos",
  },
  {
    value: "3230200",
    label: "Fabricação de artefatos para pesca e esporte",
  },
  {
    value: "3032600",
    label: "Fabricação de peças e acessórios para veículos ferroviários",
  },
  {
    value: "6399200",
    label:
      "Outras atividades de prestação de serviços de informação não especificadas anteriormente",
  },
  {
    value: "4681803",
    label:
      "Comércio atacadista de combustíveis de origem vegetal, exceto álcool carburante",
  },
  {
    value: "2710402",
    label:
      "Fabricação de transformadores, indutores, conversores, sincronizadores e semelhantes, peças e acessórios",
  },
  {
    value: "5911101",
    label: "Estúdios cinematográficos",
  },
  {
    value: "4661300",
    label:
      "Comércio atacadista de máquinas, aparelhos e equipamentos para uso agropecuário; partes e peças",
  },
  {
    value: "4722901",
    label: "Comércio varejista de carnes - açougues",
  },
  {
    value: "3314715",
    label:
      "Manutenção e reparação de máquinas e equipamentos para uso na extração mineral, exceto na extração de petróleo",
  },
  {
    value: "2014200",
    label: "Fabricação de gases industriais",
  },
  {
    value: "0115600",
    label: "Cultivo de soja",
  },
  {
    value: "9001999",
    label:
      "Artes cênicas, espetáculos e atividades complementares não especificados anteriormente",
  },
  {
    value: "4530703",
    label:
      "Comércio a varejo de peças e acessórios novos para veículos automotores",
  },
  {
    value: "6110801",
    label: "Serviços de telefonia fixa comutada - STFC",
  },
  {
    value: "4645103",
    label: "Comércio atacadista de produtos odontológicos",
  },
  {
    value: "4729699",
    label:
      "Comércio varejista de produtos alimentícios em geral ou especializado em produtos alimentícios não especificados anteriormente",
  },
  {
    value: "4530704",
    label:
      "Comércio a varejo de peças e acessórios usados para veículos automotores",
  },
  {
    value: "9312300",
    label: "Clubes sociais, esportivos e similares",
  },
  {
    value: "5099899",
    label: "Outros transportes aquaviários não especificados anteriormente",
  },
  {
    value: "8630503",
    label: "Atividade médica ambulatorial restrita a consultas",
  },
  {
    value: "4643501",
    label: "Comércio atacadista de calçados",
  },
  {
    value: "8299704",
    label: "Leiloeiros independentes",
  },
  {
    value: "3821100",
    label: "Tratamento e disposição de resíduos não perigosos",
  },
  {
    value: "8640213",
    label: "Serviços de litotripsia",
  },
  {
    value: "2829199",
    label:
      "Fabricação de outras máquinas e equipamentos de uso geral não especificados anteriormente, peças e acessórios",
  },
  {
    value: "4637107",
    label:
      "Comércio atacadista de chocolates, confeitos, balas, bombons e semelhantes",
  },
  {
    value: "6424702",
    label: "Cooperativas centrais de crédito",
  },
  {
    value: "2812700",
    label:
      "Fabricação de equipamentos hidráulicos e pneumáticos, peças e acessórios, exceto válvulas",
  },
  {
    value: "3314711",
    label:
      "Manutenção e reparação de máquinas e equipamentos para agricultura e pecuária",
  },
  {
    value: "1811302",
    label: "Impressão de livros, revistas e outras publicações periódicas",
  },
  {
    value: "4755501",
    label: "Comércio varejista de tecidos",
  },
  {
    value: "7312200",
    label:
      "Agenciamento de espaços para publicidade, exceto em veículos de comunicação",
  },
  {
    value: "2422902",
    label: "Produção de laminados planos de aços especiais",
  },
  {
    value: "9603305",
    label: "Serviços de somatoconservação",
  },
  {
    value: "4691500",
    label:
      "Comércio atacadista de mercadorias em geral, com predominância de produtos alimentícios",
  },
  {
    value: "4623104",
    label: "Comércio atacadista de fumo em folha não beneficiado",
  },
  {
    value: "0322104",
    label: "Criação de peixes ornamentais em água doce",
  },
  {
    value: "0321305",
    label: "Atividades de apoio à aquicultura em água salgada e salobra",
  },
  {
    value: "7739099",
    label:
      "Aluguel de outras máquinas e equipamentos comerciais e industriais não especificados anteriormente, sem operador",
  },
  {
    value: "5111100",
    label: "Transporte aéreo de passageiros regular",
  },
  {
    value: "0210108",
    label: "Produção de carvão vegetal - florestas plantadas",
  },
  {
    value: "6621501",
    label: "Peritos e avaliadores de seguros",
  },
  {
    value: "6621502",
    label: "Auditoria e consultoria atuarial",
  },
  {
    value: "6202300",
    label:
      "Desenvolvimento e licenciamento de programas de computador customizáveis",
  },
  {
    value: "0910600",
    label: "Atividades de apoio à extração de petróleo e gás natural",
  },
  {
    value: "4743100",
    label: "Comércio varejista de vidros",
  },
  {
    value: "2851800",
    label:
      "Fabricação de máquinas e equipamentos para a prospecção e extração de petróleo, peças e acessórios",
  },
  {
    value: "5112901",
    label: "Serviço de táxi aéreo e locação de aeronaves com tripulação",
  },
  {
    value: "2822401",
    label:
      "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de pessoas, peças e acessórios",
  },
  {
    value: "9001901",
    label: "Produção teatral",
  },
  {
    value: "2423702",
    label: "Produção de laminados longos de aço, exceto tubos",
  },
  {
    value: "8599602",
    label: "Cursos de pilotagem",
  },
  {
    value: "3314709",
    label:
      "Manutenção e reparação de máquinas de escrever, calcular e de outros equipamentos não eletrônicos para escritório",
  },
  {
    value: "2441501",
    label: "Produção de alumínio e suas ligas em formas primárias",
  },
  {
    value: "0321303",
    label: "Criação de ostras e mexilhões em água salgada e salobra",
  },
  {
    value: "4732600",
    label: "Comércio varejista de lubrificantes",
  },
  {
    value: "1622699",
    label: "Fabricação de outros artigos de carpintaria para construção",
  },
  {
    value: "6424701",
    label: "Bancos cooperativos",
  },
  {
    value: "1813001",
    label: "Impressão de material para uso publicitário",
  },
  {
    value: "5021101",
    label:
      "Transporte por navegação interior de carga, municipal, exceto travessia",
  },
  {
    value: "9001903",
    label: "Produção de espetáculos de dança",
  },
  {
    value: "7912100",
    label: "Operadores turísticos",
  },
  {
    value: "0152102",
    label: "Criação de equinos",
  },
  {
    value: "6440900",
    label: "Arrendamento mercantil",
  },
  {
    value: "5310501",
    label: "Atividades do Correio Nacional",
  },
  {
    value: "1092900",
    label: "Fabricação de biscoitos e bolachas",
  },
  {
    value: "6391700",
    label: "Agências de notícias",
  },
  {
    value: "1081302",
    label: "Torrefação e moagem de café",
  },
  {
    value: "0810007",
    label: "Extração de argila e beneficiamento associado",
  },
  {
    value: "8550301",
    label: "Administração de caixas escolares",
  },
  {
    value: "1072402",
    label: "Fabricação de açúcar de cereais (dextrose) e de beterraba",
  },
  {
    value: "2012600",
    label: "Fabricação de intermediários para fertilizantes",
  },
  {
    value: "0119902",
    label: "Cultivo de alho",
  },
  {
    value: "4211102",
    label: "Pintura para sinalização em pistas rodoviárias e aeroportos",
  },
  {
    value: "1623400",
    label: "Fabricação de artefatos de tanoaria e de embalagens de madeira",
  },
  {
    value: "0899101",
    label: "Extração de grafita",
  },
  {
    value: "0722701",
    label: "Extração de minério de estanho",
  },
  {
    value: "4651602",
    label: "Comércio atacadista de suprimentos para informática",
  },
  {
    value: "0132600",
    label: "Cultivo de uva",
  },
  {
    value: "4541201",
    label: "Comércio por atacado de motocicletas e motonetas",
  },
  {
    value: "4929904",
    label:
      "Organização de excursões em veículos rodoviários próprios, intermunicipal, interestadual e internacional",
  },
  {
    value: "4751201",
    label:
      "Comércio varejista especializado de equipamentos e suprimentos de informática",
  },
  {
    value: "8640206",
    label: "Serviços de ressonância magnética",
  },
  {
    value: "2823200",
    label:
      "Fabricação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial, peças e acessórios",
  },
  {
    value: "6435203",
    label: "Companhias hipotecárias",
  },
  {
    value: "3240099",
    label:
      "Fabricação de outros brinquedos e jogos recreativos não especificados anteriormente",
  },
  {
    value: "6423900",
    label: "Caixas econômicas",
  },
  {
    value: "5120000",
    label: "Transporte aéreo de carga",
  },
  {
    value: "9609201",
    label: "Clínicas de estética e similares",
  },
  {
    value: "8412400",
    label:
      "Regulação das atividades de saúde, educação, serviços culturais e outros serviços sociais",
  },
  {
    value: "4713002",
    label: "Lojas de variedades, exceto lojas de departamentos ou magazines",
  },
  {
    value: "8423000",
    label: "Justiça",
  },
  {
    value: "5021102",
    label:
      "Transporte por navegação interior de carga, intermunicipal, interestadual e internacional, exceto travessia",
  },
  {
    value: "4681801",
    label:
      "Comércio atacadista de álcool carburante, biodiesel, gasolina e demais derivados de petróleo, exceto lubrificantes, não realizado por transportador retalhista (TRR)",
  },
  {
    value: "0810010",
    label: "Beneficiamento de gesso e caulim associado à extração",
  },
  {
    value: "7490102",
    label: "Escafandria e mergulho",
  },
  {
    value: "8211300",
    label: "Serviços combinados de escritório e apoio administrativo",
  },
  {
    value: "0119999",
    label:
      "Cultivo de outras plantas de lavoura temporária não especificadas anteriormente",
  },
  {
    value: "5813100",
    label: "Edição de revistas",
  },
  {
    value: "0139306",
    label: "Cultivo de seringueira",
  },
  {
    value: "0151203",
    label: "Criação de bovinos, exceto para corte e leite",
  },
  {
    value: "4391600",
    label: "Obras de fundações",
  },
  {
    value: "8299701",
    label: "Medição de consumo de energia elétrica, gás e água",
  },
  {
    value: "4637102",
    label: "Comércio atacadista de açúcar",
  },
  {
    value: "8640201",
    label: "Laboratórios de anatomia patológica e citológica",
  },
  {
    value: "8640207",
    label:
      "Serviços de diagnóstico por imagem sem uso de radiação ionizante, exceto ressonância magnética",
  },
  {
    value: "3299003",
    label:
      "Fabricação de letras, letreiros e placas de qualquer material, exceto luminosos",
  },
  {
    value: "2920401",
    label: "Fabricação de caminhões e ônibus",
  },
  {
    value: "0139304",
    label: "Cultivo de plantas para condimento, exceto pimenta-do-reino",
  },
  {
    value: "2539000",
    label: "Serviços de usinagem, solda, tratamento e revestimento em metais",
  },
  {
    value: "2221800",
    label: "Fabricação de laminados planos e tubulares de material plástico",
  },
  {
    value: "4689301",
    label:
      "Comércio atacadista de produtos da extração mineral, exceto combustíveis",
  },
  {
    value: "1732000",
    label: "Fabricação de embalagens de cartolina e papel-cartão",
  },
  {
    value: "7420003",
    label: "Laboratórios fotográficos",
  },
  {
    value: "0159803",
    label: "Criação de escargô",
  },
  {
    value: "2852600",
    label:
      "Fabricação de outras máquinas e equipamentos para uso na extração mineral, peças e acessórios, exceto na extração de petróleo",
  },
  {
    value: "9601702",
    label: "Tinturarias",
  },
  {
    value: "9329804",
    label: "Exploração de jogos eletrônicos recreativos",
  },
  {
    value: "4721101",
    label: "Padaria e confeitaria com predominância de produção própria",
  },
  {
    value: "0122900",
    label: "Cultivo de flores e plantas ornamentais",
  },
  {
    value: "7723300",
    label: "Aluguel de objetos do vestuário, jóias e acessórios",
  },
  {
    value: "1932200",
    label: "Fabricação de biocombustíveis, exceto álcool",
  },
  {
    value: "3101200",
    label: "Fabricação de móveis com predominância de madeira",
  },
  {
    value: "4329104",
    label:
      "Montagem e instalação de sistemas e equipamentos de iluminação e sinalização em vias públicas, portos e aeroportos",
  },
  {
    value: "9602502",
    label: "Atividades de estética e outros serviços de cuidados com a beleza",
  },
  {
    value: "1722200",
    label: "Fabricação de cartolina e papel-cartão",
  },
  {
    value: "7210000",
    label:
      "Pesquisa e desenvolvimento experimental em ciências físicas e naturais",
  },
  {
    value: "1352900",
    label: "Fabricação de artefatos de tapeçaria",
  },
  {
    value: "4721103",
    label: "Comércio varejista de laticínios e frios",
  },
  {
    value: "2330305",
    label: "Preparação de massa de concreto e argamassa para construção",
  },
  {
    value: "8640204",
    label: "Serviços de tomografia",
  },
  {
    value: "0312403",
    label: "Coleta de outros produtos aquáticos de água doce",
  },
  {
    value: "8650099",
    label:
      "Atividades de profissionais da área de saúde não especificadas anteriormente",
  },
  {
    value: "4763601",
    label: "Comércio varejista de brinquedos e artigos recreativos",
  },
  {
    value: "2541100",
    label: "Fabricação de artigos de cutelaria",
  },
  {
    value: "4530702",
    label: "Comércio por atacado de pneumáticos e câmaras-de-ar",
  },
  {
    value: "3250706",
    label: "Serviços de prótese dentária",
  },
  {
    value: "1610205",
    label: "Serviço de tratamento de madeira realizado sob contrato",
  },
  {
    value: "1830001",
    label: "Reprodução de som em qualquer suporte",
  },
  {
    value: "0162801",
    label: "Serviço de inseminação artificial em animais",
  },
  {
    value: "3317101",
    label: "Manutenção e reparação de embarcações e estruturas flutuantes",
  },
  {
    value: "5250802",
    label: "Atividades de despachantes aduaneiros",
  },
  {
    value: "3299004",
    label: "Fabricação de painéis e letreiros luminosos",
  },
  {
    value: "4330403",
    label: "Obras de acabamento em gesso e estuque",
  },
  {
    value: "3329501",
    label: "Serviços de montagem de móveis de qualquer material",
  },
  {
    value: "6190602",
    label: "Provedores de voz sobre protocolo Internet - VOIP",
  },
  {
    value: "6209100",
    label:
      "Suporte técnico, manutenção e outros serviços em tecnologia da informação",
  },
  {
    value: "1610203",
    label: "Serrarias com desdobramento de madeira em bruto",
  },
  {
    value: "2539001",
    label: "Serviços de usinagem, torneiria e solda",
  },
  {
    value: "4322302",
    label:
      "Instalação e manutenção de sistemas centrais de ar condicionado, de ventilação e refrigeração",
  },
  {
    value: "4615000",
    label:
      "Representantes comerciais e agentes do comércio de eletrodomésticos, móveis e artigos de uso doméstico",
  },
  {
    value: "2813500",
    label:
      "Fabricação de válvulas, registros e dispositivos semelhantes, peças e acessórios",
  },
  {
    value: "4923002",
    label:
      "Serviço de transporte de passageiros - locação de automóveis com motorista",
  },
  {
    value: "4757100",
    label:
      "Comércio varejista especializado de peças e acessórios para aparelhos eletroeletrônicos para uso doméstico, exceto informática e comunicação",
  },
  {
    value: "0112102",
    label: "Cultivo de juta",
  },
  {
    value: "5030101",
    label: "Navegação de apoio marítimo",
  },
  {
    value: "6190601",
    label: "Provedores de acesso às redes de comunicações",
  },
  {
    value: "0891600",
    label:
      "Extração de minerais para fabricação de adubos, fertilizantes e outros produtos químicos",
  },
  {
    value: "4929901",
    label:
      "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, municipal",
  },
  {
    value: "4221903",
    label: "Manutenção de redes de distribuição de energia elétrica",
  },
  {
    value: "8650005",
    label: "Atividades de terapia ocupacional",
  },
  {
    value: "6499904",
    label: "Caixas de financiamento de corporações",
  },
  {
    value: "6204000",
    label: "Consultoria em tecnologia da informação",
  },
  {
    value: "3314701",
    label: "Manutenção e reparação de máquinas motrizes não elétricas",
  },
  {
    value: "0810003",
    label: "Extração de mármore e beneficiamento associado",
  },
  {
    value: "7729201",
    label: "Aluguel de aparelhos de jogos eletrônicos",
  },
  {
    value: "4632002",
    label: "Comércio atacadista de farinhas, amidos e féculas",
  },
  {
    value: "5822100",
    label: "Edição integrada à impressão de jornais",
  },
  {
    value: "8711505",
    label: "Condomínios residenciais para idosos",
  },
  {
    value: "1422300",
    label:
      "Fabricação de artigos do vestuário, produzidos em malharias e tricotagens, exceto meias",
  },
  {
    value: "6021700",
    label: "Atividades de televisão aberta",
  },
  {
    value: "3314718",
    label:
      "Manutenção e reparação de máquinas para a indústria metalúrgica, exceto máquinas-ferramenta",
  },
  {
    value: "2910701",
    label: "Fabricação de automóveis, camionetas e utilitários",
  },
  {
    value: "2670102",
    label:
      "Fabricação de aparelhos fotográficos e cinematográficos, peças e acessórios",
  },
  {
    value: "7729203",
    label: "Aluguel de material médico",
  },
  {
    value: "0721901",
    label: "Extração de minério de alumínio",
  },
  {
    value: "7721700",
    label: "Aluguel de equipamentos recreativos e esportivos",
  },
  {
    value: "7311400",
    label: "Agências de publicidade",
  },
  {
    value: "8219999",
    label:
      "Preparação de documentos e serviços especializados de apoio administrativo não especificados anteriormente",
  },
  {
    value: "6319400",
    label:
      "Portais, provedores de conteúdo e outros serviços de informação na Internet",
  },
  {
    value: "5130700",
    label: "Transporte espacial",
  },
  {
    value: "0133411",
    label: "Cultivo de pêssego",
  },
  {
    value: "3099700",
    label:
      "Fabricação de equipamentos de transporte não especificados anteriormente",
  },
  {
    value: "4543900",
    label: "Manutenção e reparação de motocicletas e motonetas",
  },
  {
    value: "2622100",
    label: "Fabricação de periféricos para equipamentos de informática",
  },
  {
    value: "4649405",
    label: "Comércio atacadista de artigos de tapeçaria; persianas e cortinas",
  },
  {
    value: "9420100",
    label: "Atividades de organizações sindicais",
  },
  {
    value: "4744004",
    label: "Comércio varejista de cal, areia, pedra britada, tijolos e telhas",
  },
  {
    value: "2421100",
    label: "Produção de semiacabados de aço",
  },
  {
    value: "8020002",
    label: "Outras atividades de serviços de segurança",
  },
  {
    value: "8020000",
    label: "Atividades de monitoramento de sistemas de segurança",
  },
  {
    value: "6629100",
    label:
      "Atividades auxiliares dos seguros, da previdência complementar e dos planos de saúde não especificadas anteriormente",
  },
  {
    value: "5620102",
    label: "Serviços de alimentação para eventos e recepções - bufê",
  },
  {
    value: "1822999",
    label:
      "Serviços de acabamentos gráficos, exceto encadernação e plastificação",
  },
  {
    value: "8621602",
    label: "Serviços móveis de atendimento a urgências, exceto por UTI móvel",
  },
  {
    value: "0311604",
    label: "Atividades de apoio à pesca em água salgada",
  },
  {
    value: "4330401",
    label: "Impermeabilização em obras de engenharia civil",
  },
  {
    value: "8425600",
    label: "Defesa Civil",
  },
  {
    value: "7420005",
    label: "Serviços de microfilmagem",
  },
  {
    value: "2941700",
    label:
      "Fabricação de peças e acessórios para o sistema motor de veículos automotores",
  },
  {
    value: "8422100",
    label: "Defesa",
  },
  {
    value: "0133403",
    label: "Cultivo de caju",
  },
  {
    value: "1121600",
    label: "Fabricação de águas envasadas",
  },
  {
    value: "6611801",
    label: "Bolsa de valores",
  },
  {
    value: "4530706",
    label:
      "Representantes comerciais e agentes do comércio de peças e acessórios novos e usados para veículos automotores",
  },
  {
    value: "3103900",
    label: "Fabricação de móveis de outros materiais, exceto madeira e metal",
  },
  {
    value: "0210199",
    label:
      "Produção de produtos não madeireiros não especificados anteriormente em florestas plantadas",
  },
  {
    value: "8593700",
    label: "Ensino de idiomas",
  },
  {
    value: "4649404",
    label: "Comércio atacadista de móveis e artigos de colchoaria",
  },
  {
    value: "1532700",
    label: "Fabricação de tênis de qualquer material",
  },
  {
    value: "4789001",
    label: "Comércio varejista de suvenires, bijuterias e artesanatos",
  },
  {
    value: "3314713",
    label: "Manutenção e reparação de máquinas-ferramenta",
  },
  {
    value: "5612100",
    label: "Serviços ambulantes de alimentação",
  },
  {
    value: "0210106",
    label: "Cultivo de mudas em viveiros florestais",
  },
  {
    value: "4635401",
    label: "Comércio atacadista de água mineral",
  },
  {
    value: "2759701",
    label:
      "Fabricação de aparelhos elétricos de uso pessoal, peças e acessórios",
  },
  {
    value: "8299707",
    label: "Salas de acesso à Internet",
  },
  {
    value: "5222200",
    label: "Terminais rodoviários e ferroviários",
  },
  {
    value: "4684201",
    label: "Comércio atacadista de resinas e elastômeros",
  },
  {
    value: "7732201",
    label:
      "Aluguel de máquinas e equipamentos para construção sem operador, exceto andaimes",
  },
  {
    value: "2522500",
    label:
      "Fabricação de caldeiras geradoras de vapor, exceto para aquecimento central e para veículos",
  },
  {
    value: "1113501",
    label: "Fabricação de malte, inclusive malte uísque",
  },
  {
    value: "4713004",
    label:
      "Lojas de departamentos ou magazines, exceto lojas francas (Duty free)",
  },
  {
    value: "2330399",
    label:
      "Fabricação de outros artefatos e produtos de concreto, cimento, fibrocimento, gesso e materiais semelhantes",
  },
  {
    value: "0810001",
    label: "Extração de ardósia e beneficiamento associado",
  },
  {
    value: "9603399",
    label:
      "Atividades funerárias e serviços relacionados não especificados anteriormente",
  },
  {
    value: "6619304",
    label: "Caixas eletrônicos",
  },
  {
    value: "4754703",
    label: "Comércio varejista de artigos de iluminação",
  },
  {
    value: "6110803",
    label: "Serviços de comunicação multimídia - SCM",
  },
  {
    value: "2942500",
    label:
      "Fabricação de peças e acessórios para os sistemas de marcha e transmissão de veículos automotores",
  },
  {
    value: "5829800",
    label:
      "Edição integrada à impressão de cadastros, listas e outros produtos gráficos",
  },
  {
    value: "3314719",
    label:
      "Manutenção e reparação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo",
  },
  {
    value: "0111303",
    label: "Cultivo de trigo",
  },
  {
    value: "4940000",
    label: "Transporte dutoviário",
  },
  {
    value: "1096100",
    label: "Fabricação de alimentos e pratos prontos",
  },
  {
    value: "6450600",
    label: "Sociedades de capitalização",
  },
  {
    value: "5250803",
    label: "Agenciamento de cargas, exceto para o transporte marítimo",
  },
  {
    value: "2031200",
    label: "Fabricação de resinas termoplásticas",
  },
  {
    value: "1099602",
    label: "Fabricação de pós-alimentícios",
  },
  {
    value: "3299001",
    label: "Fabricação de guarda-chuvas e similares",
  },
  {
    value: "6120502",
    label: "Serviço móvel especializado - SME",
  },
  {
    value: "1521100",
    label:
      "Fabricação de artigos para viagem, bolsas e semelhantes de qualquer material",
  },
  {
    value: "2814301",
    label: "Fabricação de compressores para uso industrial, peças e acessórios",
  },
  {
    value: "0170900",
    label: "Caça e serviços relacionados",
  },
  {
    value: "4729601",
    label: "Tabacaria",
  },
  {
    value: "2424502",
    label:
      "Produção de relaminados, trefilados e perfilados de aço, exceto arames",
  },
  {
    value: "6619302",
    label: "Correspondentes de instituições financeiras",
  },
  {
    value: "8532500",
    label: "Educação superior - graduação e pós-graduação",
  },
  {
    value: "5099801",
    label: "Transporte aquaviário para passeios turísticos",
  },
  {
    value: "8622400",
    label:
      "Serviços de remoção de pacientes, exceto os serviços móveis de atendimento a urgências",
  },
  {
    value: "4687701",
    label: "Comércio atacadista de resíduos de papel e papelão",
  },
  {
    value: "3811400",
    label: "Coleta de resíduos não perigosos",
  },
  {
    value: "4789004",
    label:
      "Comércio varejista de animais vivos e de artigos e alimentos para animais de estimação",
  },
  {
    value: "4782202",
    label: "Comércio varejista de artigos de viagem",
  },
  {
    value: "4632001",
    label: "Comércio atacadista de cereais e leguminosas beneficiados",
  },
  {
    value: "2722801",
    label: "Fabricação de baterias e acumuladores para veículos automotores",
  },
  {
    value: "1099601",
    label: "Fabricação de vinagres",
  },
  {
    value: "4641903",
    label: "Comércio atacadista de artigos de armarinho",
  },
  {
    value: "0810004",
    label: "Extração de calcário e dolomita e beneficiamento associado",
  },
  {
    value: "3314716",
    label: "Manutenção e reparação de tratores, exceto agrícolas",
  },
  {
    value: "8421300",
    label: "Relações exteriores",
  },
  {
    value: "3314706",
    label:
      "Manutenção e reparação de máquinas, aparelhos e equipamentos para instalações térmicas",
  },
  {
    value: "5030103",
    label: "Serviço de rebocadores e empurradores",
  },
  {
    value: "5811500",
    label: "Edição de livros",
  },
  {
    value: "1220499",
    label:
      "Fabricação de outros produtos do fumo, exceto cigarros, cigarrilhas e charutos",
  },
  {
    value: "2122000",
    label: "Fabricação de medicamentos para uso veterinário",
  },
  {
    value: "0220901",
    label: "Extração de madeira em florestas nativas",
  },
  {
    value: "9002702",
    label: "Restauração de obras de arte",
  },
  {
    value: "5912001",
    label: "Serviços de dublagem",
  },
  {
    value: "1731100",
    label: "Fabricação de embalagens de papel",
  },
  {
    value: "2790201",
    label:
      "Fabricação de eletrodos, contatos e outros artigos de carvão e grafita para uso elétrico, eletroímãs e isoladores",
  },
  {
    value: "5913800",
    label: "Distribuição cinematográfica, de vídeo e de programas de televisão",
  },
  {
    value: "4623107",
    label: "Comércio atacadista de sisal",
  },
  {
    value: "4613300",
    label:
      "Representantes comerciais e agentes do comércio de madeira, material de construção e ferragens",
  },
  {
    value: "4399104",
    label:
      "Serviços de operação e fornecimento de equipamentos para transporte e elevação de cargas e pessoas para uso em obras",
  },
  {
    value: "2219600",
    label:
      "Fabricação de artefatos de borracha não especificados \nanteriormente",
  },
  {
    value: "4311802",
    label: "Preparação de canteiro e limpeza de terreno",
  },
  {
    value: "2312500",
    label: "Fabricação de embalagens de vidro",
  },
  {
    value: "1122402",
    label: "Fabricação de chá mate e outros chás prontos para consumo",
  },
  {
    value: "1113502",
    label: "Fabricação de cervejas e chopes",
  },
  {
    value: "3900500",
    label: "Descontaminação e outros serviços de gestão de resíduos",
  },
  {
    value: "2821601",
    label:
      "Fabricação de fornos industriais, aparelhos e equipamentos não elétricos para instalações térmicas, peças e acessórios",
  },
  {
    value: "8230002",
    label: "Casas de festas e eventos",
  },
  {
    value: "8599603",
    label: "Treinamento em informática",
  },
  {
    value: "0321302",
    label: "Criação de camarões em água salgada e salobra",
  },
  {
    value: "0135100",
    label: "Cultivo de cacau",
  },
  {
    value: "0729401",
    label: "Extração de minérios de nióbio e titânio",
  },
  {
    value: "9001902",
    label: "Produção musical",
  },
  {
    value: "2013401",
    label: "Fabricação de adubos e fertilizantes organo-minerais",
  },
  {
    value: "4637106",
    label: "Comércio atacadista de sorvetes",
  },
  {
    value: "4223500",
    label:
      "Construção de redes de transportes por dutos, exceto para água e esgoto",
  },
  {
    value: "0155504",
    label: "Criação de aves, exceto galináceos",
  },
  {
    value: "4644301",
    label: "Comércio atacadista de medicamentos e drogas de uso humano",
  },
  {
    value: "4633803",
    label:
      "Comércio atacadista de coelhos e outros pequenos animais vivos para alimentação",
  },
  {
    value: "2062200",
    label: "Fabricação de produtos de limpeza e polimento",
  },
  {
    value: "0153901",
    label: "Criação de caprinos",
  },
  {
    value: "2013400",
    label: "Fabricação de adubos e fertilizantes",
  },
  {
    value: "4649410",
    label:
      "Comércio atacadista de jóias, relógios e bijuterias, inclusive pedras preciosas e semipreciosas lapidadas",
  },
  {
    value: "2930102",
    label: "Fabricação de carrocerias para ônibus",
  },
  {
    value: "1099607",
    label: "Fabricação de alimentos dietéticos e complementos alimentares",
  },
  {
    value: "2832100",
    label:
      "Fabricação de equipamentos para irrigação agrícola, peças e acessórios",
  },
  {
    value: "1742701",
    label: "Fabricação de fraldas descartáveis",
  },
  {
    value: "7420001",
    label: "Atividades de produção de fotografias, exceto aérea e submarina",
  },
  {
    value: "4639701",
    label: "Comércio atacadista de produtos alimentícios em geral",
  },
  {
    value: "1821100",
    label: "Serviços de pré-impressão",
  },
  {
    value: "1065103",
    label: "Fabricação de óleo de milho refinado",
  },
  {
    value: "3512300",
    label: "Transmissão de energia elétrica",
  },
  {
    value: "2072000",
    label: "Fabricação de tintas de impressão",
  },
  {
    value: "1411801",
    label: "Confecção de roupas íntimas",
  },
  {
    value: "1011201",
    label: "Frigorífico - abate de bovinos",
  },
  {
    value: "7490199",
    label:
      "Outras atividades profissionais, científicas e técnicas não especificadas anteriormente",
  },
  {
    value: "4761002",
    label: "Comércio varejista de jornais e revistas",
  },
  {
    value: "2740602",
    label: "Fabricação de luminárias e outros equipamentos de iluminação",
  },
  {
    value: "6920602",
    label: "Atividades de consultoria e auditoria contábil e tributária",
  },
  {
    value: "4922103",
    label:
      "Transporte rodoviário coletivo de passageiros, com itinerário fixo, internacional",
  },
  {
    value: "4530701",
    label:
      "Comércio por atacado de peças e acessórios novos para veículos automotores",
  },
  {
    value: "4623102",
    label:
      "Comércio atacadista de couros, lãs, peles e outros subprodutos não comestíveis de origem animal",
  },
  {
    value: "2866600",
    label:
      "Fabricação de máquinas e equipamentos para a indústria do plástico, peças e acessórios",
  },
  {
    value: "3299006",
    label: "Fabricação de velas, inclusive decorativas",
  },
  {
    value: "4635403",
    label:
      "Comércio atacadista de bebidas com atividade de fracionamento e acondicionamento associada",
  },
  {
    value: "8512100",
    label: "Educação infantil - pré-escola",
  },
  {
    value: "6201502",
    label: "Web desing",
  },
  {
    value: "2452100",
    label: "Fundição de metais não ferrosos e suas ligas",
  },
  {
    value: "7740300",
    label: "Gestão de ativos intangíveis não financeiros",
  },
  {
    value: "1742799",
    label:
      "Fabricação de produtos de papel para uso doméstico e higiênico-sanitário não especificados anteriormente",
  },
  {
    value: "8730101",
    label: "Orfanatos",
  },
  {
    value: "3314708",
    label:
      "Manutenção e reparação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas",
  },
  {
    value: "2121102",
    label: "Fabricação de medicamentos homeopáticos para uso humano",
  },
  {
    value: "6130200",
    label: "Telecomunicações por satélite",
  },
  {
    value: "8640299",
    label:
      "Atividades de serviços de complementação diagnóstica e terapêutica não especificadas anteriormente",
  },
  {
    value: "5823900",
    label: "Edição integrada à impressão de revistas",
  },
  {
    value: "4612500",
    label:
      "Representantes comerciais e agentes do comércio de combustíveis, minerais, produtos siderúrgicos e químicos",
  },
  {
    value: "6120501",
    label: "Telefonia móvel celular",
  },
  {
    value: "2032100",
    label: "Fabricação de resinas termofixas",
  },
  {
    value: "4741500",
    label: "Comércio varejista de tintas e materiais para pintura",
  },
  {
    value: "9529199",
    label:
      "Reparação e manutenção de outros objetos e equipamentos pessoais e domésticos não especificados anteriormente",
  },
  {
    value: "6424703",
    label: "Cooperativas de crédito mútuo",
  },
  {
    value: "2732500",
    label:
      "Fabricação de material elétrico para instalações em circuito de consumo",
  },
  {
    value: "4542102",
    label: "Comércio sob consignação de motocicletas e motonetas",
  },
  {
    value: "4679603",
    label: "Comércio atacadista de vidros, espelhos e vitrais",
  },
  {
    value: "6110802",
    label: "Serviços de redes de transporte de telecomunicações - SRTT",
  },
  {
    value: "3299002",
    label: "Fabricação de canetas, lápis e outros artigos para escritório",
  },
  {
    value: "5821200",
    label: "Edição integrada à impressão de livros",
  },
  {
    value: "7319004",
    label: "Consultoria em publicidade",
  },
  {
    value: "5250801",
    label: "Comissaria de despachos",
  },
  {
    value: "4641901",
    label: "Comércio atacadista de tecidos",
  },
  {
    value: "4681805",
    label: "Comércio atacadista de lubrificantes",
  },
  {
    value: "0139399",
    label:
      "Cultivo de outras plantas de lavoura permanente não especificadas anteriormente",
  },
  {
    value: "7119701",
    label: "Serviços de cartografia, topografia e geodésia",
  },
  {
    value: "1064300",
    label: "Fabricação de farinha de milho e derivados, exceto óleos de milho",
  },
  {
    value: "3701100",
    label: "Gestão de redes de esgoto",
  },
  {
    value: "2721000",
    label:
      "Fabricação de pilhas, baterias e acumuladores elétricos, exceto para veículos automotores",
  },
  {
    value: "6422100",
    label: "Bancos múltiplos, com carteira comercial",
  },
  {
    value: "6821802",
    label: "Corretagem no aluguel de imóveis",
  },
  {
    value: "4921302",
    label:
      "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal em região metropolitana",
  },
  {
    value: "1220401",
    label: "Fabricação de cigarros",
  },
  {
    value: "6810201",
    label: "Compra e venda de imóveis próprios",
  },
  {
    value: "1013902",
    label: "Preparação de subprodutos do abate",
  },
  {
    value: "5590699",
    label: "Outros alojamentos não especificados anteriormente",
  },
  {
    value: "0220903",
    label: "Coleta de castanha-do-pará em florestas nativas",
  },
  {
    value: "9499500",
    label: "Atividades associativas não especificadas anteriormente",
  },
  {
    value: "3211602",
    label: "Fabricação de artefatos de joalheria e ourivesaria",
  },
  {
    value: "2099101",
    label:
      "Fabricação de chapas, filmes, papéis e outros materiais e produtos químicos para fotografia",
  },
  {
    value: "0112199",
    label:
      "Cultivo de outras fibras de lavoura temporária não especificadas anteriormente",
  },
  {
    value: "0710301",
    label: "Extração de minério de ferro",
  },
  {
    value: "1531901",
    label: "Fabricação de calçados de couro",
  },
  {
    value: "1910100",
    label: "Coquerias",
  },
  {
    value: "4771701",
    label:
      "Comércio varejista de produtos farmacêuticos, sem manipulação de fórmulas",
  },
  {
    value: "0220902",
    label: "Produção de carvão vegetal - florestas nativas",
  },
  {
    value: "8800600",
    label: "Serviços de assistência social sem alojamento",
  },
  {
    value: "7830200",
    label: "Fornecimento e gestão de recursos humanos para terceiros",
  },
  {
    value: "4785701",
    label: "Comércio varejista de antiguidades",
  },
  {
    value: "3314714",
    label:
      "Manutenção e reparação de máquinas e equipamentos para a prospecção e extração de petróleo",
  },
  {
    value: "4311801",
    label: "Demolição de edifícios e outras estruturas",
  },
  {
    value: "1091100",
    label: "Fabricação de produtos de panificação",
  },
  {
    value: "1741901",
    label: "Fabricação de formulários contínuos",
  },
  {
    value: "8650006",
    label: "Atividades de fonoaudiologia",
  },
  {
    value: "4329105",
    label: "Tratamentos térmicos, acústicos ou de vibração",
  },
  {
    value: "4299599",
    label: "Outras obras de engenharia civil não especificadas anteriormente",
  },
  {
    value: "8122200",
    label: "Imunização e controle de pragas urbanas",
  },
  {
    value: "2093200",
    label: "Fabricação de aditivos de uso industrial",
  },
  {
    value: "1093701",
    label: "Fabricação de produtos derivados do cacau e de chocolates",
  },
  {
    value: "7911200",
    label: "Agências de viagens",
  },
  {
    value: "5611202",
    label: "Bares e outros estabelecimentos especializados em servir bebidas",
  },
  {
    value: "4623109",
    label: "Comércio atacadista de alimentos para animais",
  },
  {
    value: "6438701",
    label: "Bancos de câmbio",
  },
  {
    value: "3600601",
    label: "Captação, tratamento e distribuição de água",
  },
  {
    value: "9411100",
    label: "Atividades de organizações associativas patronais e empresariais",
  },
  {
    value: "0155505",
    label: "Produção de ovos",
  },
  {
    value: "4636202",
    label: "Comércio atacadista de cigarros, cigarrilhas e charutos",
  },
  {
    value: "6436100",
    label: "Sociedades de crédito, financiamento e investimento - financeiras",
  },
  {
    value: "1629301",
    label: "Fabricação de artefatos diversos de madeira, exceto móveis",
  },
  {
    value: "0321399",
    label:
      "Cultivos e semicultivos da aquicultura em água salgada e salobra não especificados anteriormente",
  },
  {
    value: "9601701",
    label: "Lavanderias",
  },
  {
    value: "0500302",
    label: "Beneficiamento de carvão mineral",
  },
  {
    value: "2349401",
    label: "Fabricação de material sanitário de cerâmica",
  },
  {
    value: "3011302",
    label:
      "Construção de embarcações para uso comercial e para usos especiais, exceto de grande porte",
  },
  {
    value: "4772500",
    label:
      "Comércio varejista de cosméticos, produtos de perfumaria e de higiene pessoal",
  },
  {
    value: "6511101",
    label: "Sociedade seguradora de seguros vida",
  },
  {
    value: "1042200",
    label: "Fabricação de óleos vegetais refinados, exceto óleo de milho",
  },
  {
    value: "5590601",
    label: "Albergues, exceto assistenciais",
  },
  {
    value: "4641902",
    label: "Comércio atacadista de artigos de cama, mesa e banho",
  },
  {
    value: "1413401",
    label: "Confecção de roupas profissionais, exceto sob medida",
  },
  {
    value: "6511102",
    label: "Planos de auxílio-funeral",
  },
  {
    value: "3314799",
    label:
      "Manutenção e reparação de outras máquinas e equipamentos para usos industriais não especificados anteriormente",
  },
  {
    value: "1340599",
    label:
      "Outros serviços de acabamento em fios, tecidos, artefatos têxteis e peças do vestuário",
  },
  {
    value: "5012202",
    label: "Transporte marítimo de longo curso - Passageiros",
  },
  {
    value: "4649402",
    label:
      "Comércio atacadista de aparelhos eletrônicos de uso pessoal e doméstico",
  },
  {
    value: "2061400",
    label: "Fabricação de sabões e detergentes sintéticos",
  },
  {
    value: "4611700",
    label:
      "Representantes comerciais e agentes do comércio de matérias-primas agrícolas e animais vivos",
  },
  {
    value: "8640210",
    label: "Serviços de quimioterapia",
  },
  {
    value: "2651500",
    label: "Fabricação de aparelhos e equipamentos de medida, teste e controle",
  },
  {
    value: "1312000",
    label: "Preparação e fiação de fibras têxteis naturais, exceto algodão",
  },
  {
    value: "1540800",
    label: "Fabricação de partes para calçados, de qualquer material",
  },
  {
    value: "9321200",
    label: "Parques de diversão e parques temáticos",
  },
  {
    value: "4637103",
    label: "Comércio atacadista de óleos e gorduras",
  },
  {
    value: "2223400",
    label:
      "Fabricação de tubos e acessórios de material plástico para uso na construção",
  },
  {
    value: "0322107",
    label: "Atividades de apoio à aquicultura em água doce",
  },
  {
    value: "8640209",
    label:
      "Serviços de diagnóstico por métodos ópticos - endoscopia e outros exames análogos",
  },
  {
    value: "4744005",
    label:
      "Comércio varejista de materiais de construção não especificados anteriormente",
  },
  {
    value: "4399199",
    label:
      "Serviços especializados para construção não especificados anteriormente",
  },
  {
    value: "0113000",
    label: "Cultivo de cana-de-açúcar",
  },
  {
    value: "8711504",
    label: "Centros de apoio a pacientes com câncer e com AIDS",
  },
  {
    value: "4763604",
    label: "Comércio varejista de artigos de caça, pesca e camping",
  },
  {
    value: "2073800",
    label: "Fabricação de impermeabilizantes, solventes e produtos afins",
  },
  {
    value: "8640212",
    label: "Serviços de hemoterapia",
  },
  {
    value: "4213800",
    label: "Obras de urbanização - ruas, praças e calçadas",
  },
  {
    value: "1411802",
    label: "Facção de roupas íntimas",
  },
];

export const subclasseSelect: formatJson[] = [
    {
        value: "0161001",
        label: "Serviço de pulverização e controle de pragas agrícolas"
    },
    {
        value: "2121101",
        label: "Fabricação de medicamentos alopáticos para uso humano"
    },
    {
        value: "7320300",
        label: "Pesquisas de mercado e de opinião pública"
    },
    {
        value: "3313902",
        label: "Manutenção e reparação de baterias e acumuladores elétricos, exceto para veículos"
    },
    {
        value: "7111100",
        label: "Serviços de arquitetura"
    },
    {
        value: "8640202",
        label: "Laboratórios clínicos"
    },
    {
        value: "0163600",
        label: "Atividades de pós-colheita"
    },
    {
        value: "8299706",
        label: "Casas lotéricas"
    },
    {
        value: "8599604",
        label: "Treinamento em desenvolvimento profissional e gerencial"
    },
    {
        value: "5822101",
        label: "Edição integrada à impressão de jornais diários"
    },
    {
        value: "2592601",
        label: "Fabricação de produtos de trefilados de metal padronizados"
    },
    {
        value: "4713005",
        label: "Lojas francas (Duty Free) de aeroportos, portos e em fronteiras terrestres"
    },
    {
        value: "0133499",
        label: "Cultivo de frutas de lavoura permanente não especificadas anteriormente"
    },
    {
        value: "4923001",
        label: "Serviço de táxi"
    },
    {
        value: "5590602",
        label: "Campings"
    },
    {
        value: "4679602",
        label: "Comércio atacadista de mármores e granitos"
    },
    {
        value: "4642702",
        label: "Comércio atacadista de roupas e acessórios para uso profissional e de segurança do trabalho"
    },
    {
        value: "6311900",
        label: "Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na Internet"
    },
    {
        value: "4771703",
        label: "Comércio varejista de produtos farmacêuticos homeopáticos"
    },
    {
        value: "7500100",
        label: "Atividades veterinárias"
    },
    {
        value: "9603302",
        label: "Serviços de cremação"
    },
    {
        value: "6201501",
        label: "Desenvolvimento de programas de computador sob encomenda"
    },
    {
        value: "2521700",
        label: "Fabricação de tanques, reservatórios metálicos e caldeiras para aquecimento central"
    },
    {
        value: "2431800",
        label: "Produção de tubos de aço com costura"
    },
    {
        value: "9319101",
        label: "Produção e promoção de eventos esportivos"
    },
    {
        value: "3299005",
        label: "Fabricação de aviamentos para costura"
    },
    {
        value: "3212400",
        label: "Fabricação de bijuterias e artefatos semelhantes"
    },
    {
        value: "1111901",
        label: "Fabricação de aguardente de cana-de-açúcar"
    },
    {
        value: "4120400",
        label: "Construção de edifícios"
    },
    {
        value: "0322105",
        label: "Ranicultura"
    },
    {
        value: "4520001",
        label: "Serviços de manutenção e reparação mecânica de veículos automotores"
    },
    {
        value: "2424501",
        label: "Produção de arames de aço"
    },
    {
        value: "4711301",
        label: "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - hipermercados"
    },
    {
        value: "0141502",
        label: "Produção de sementes certificadas de forrageiras para formação de pasto"
    },
    {
        value: "5620103",
        label: "Cantinas - serviços de alimentação privativos"
    },
    {
        value: "6541300",
        label: "Previdência complementar fechada"
    },
    {
        value: "0220905",
        label: "Coleta de palmito em florestas nativas"
    },
    {
        value: "4681804",
        label: "Comércio atacadista de combustíveis de origem mineral em bruto"
    },
    {
        value: "4761001",
        label: "Comércio varejista de livros"
    },
    {
        value: "4754701",
        label: "Comércio varejista de móveis"
    },
    {
        value: "4950700",
        label: "Trens turísticos, teleféricos e similares"
    },
    {
        value: "2029100",
        label: "Fabricação de produtos químicos orgânicos não especificados anteriormente"
    },
    {
        value: "6142600",
        label: "Operadoras de televisão por assinatura por micro-ondas"
    },
    {
        value: "7119704",
        label: "Serviços de perícia técnica relacionados à segurança do trabalho"
    },
    {
        value: "4511103",
        label: "Comércio por atacado de automóveis, camionetas e utilitários novos e usados"
    },
    {
        value: "4686901",
        label: "Comércio atacadista de papel e papelão em bruto"
    },
    {
        value: "5510802",
        label: "Apart-hotéis"
    },
    {
        value: "4520002",
        label: "Serviços de lanternagem ou funilaria e pintura de veículos automotores"
    },
    {
        value: "0133405",
        label: "Cultivo de coco-da-baía"
    },
    {
        value: "7711000",
        label: "Locação de automóveis sem condutor"
    },
    {
        value: "5620101",
        label: "Fornecimento de alimentos preparados preponderantemente para empresas"
    },
    {
        value: "4319300",
        label: "Serviços de preparação do terreno não especificados anteriormente"
    },
    {
        value: "4511102",
        label: "Comércio a varejo de automóveis, camionetas e utilitários usados"
    },
    {
        value: "4679699",
        label: "Comércio atacadista de materiais de construção em geral"
    },
    {
        value: "2511000",
        label: "Fabricação de estruturas metálicas"
    },
    {
        value: "8533300",
        label: "Educação superior - pós-graduação e extensão"
    },
    {
        value: "7420002",
        label: "Atividades de produção de fotografias aéreas e submarinas"
    },
    {
        value: "6493000",
        label: "Administração de consórcios para aquisição de bens e direitos"
    },
    {
        value: "2399199",
        label: "Fabricação de outros produtos de minerais não metálicos não especificados anteriormente"
    },
    {
        value: "3832700",
        label: "Recuperação de materiais plásticos"
    },
    {
        value: "2443100",
        label: "Metalurgia do cobre"
    },
    {
        value: "4329102",
        label: "Instalação de equipamentos para orientação à navegação marítima, fluvial e lacustre"
    },
    {
        value: "4623199",
        label: "Comércio atacadista de matérias-primas agrícolas não especificadas anteriormente"
    },
    {
        value: "3514000",
        label: "Distribuição de energia elétrica"
    },
    {
        value: "0322102",
        label: "Criação de camarões em água doce"
    },
    {
        value: "1122404",
        label: "Fabricação de bebidas isotônicas"
    },
    {
        value: "4771702",
        label: "Comércio varejista de produtos farmacêuticos, com manipulação de fórmulas"
    },
    {
        value: "0154700",
        label: "Criação de suínos"
    },
    {
        value: "6438799",
        label: "Outras instituições de intermediação não monetária não especificadas anteriormente"
    },
    {
        value: "1721400",
        label: "Fabricação de papel"
    },
    {
        value: "3831999",
        label: "Recuperação de materiais metálicos, exceto alumínio"
    },
    {
        value: "0722702",
        label: "Beneficiamento de minério de estanho"
    },
    {
        value: "6619399",
        label: "Outras atividades auxiliares dos serviços financeiros não especificadas anteriormente"
    },
    {
        value: "0600002",
        label: "Extração e beneficiamento de xisto"
    },
    {
        value: "6512000",
        label: "Sociedade seguradora de seguros não vida"
    },
    {
        value: "9329801",
        label: "Discotecas, danceterias, salões de dança e similares"
    },
    {
        value: "8610102",
        label: "Atividades de atendimento em pronto-socorro e unidades hospitalares para atendimento a urgências"
    },
    {
        value: "2631100",
        label: "Fabricação de equipamentos transmissores de comunicação, peças e acessórios"
    },
    {
        value: "8660700",
        label: "Atividades de apoio à gestão de saúde"
    },
    {
        value: "2051700",
        label: "Fabricação de defensivos agrícolas"
    },
    {
        value: "2950600",
        label: "Recondicionamento e recuperação de motores para veículos automotores"
    },
    {
        value: "8112500",
        label: "Condomínios prediais"
    },
    {
        value: "3831901",
        label: "Recuperação de sucatas de alumínio"
    },
    {
        value: "5611201",
        label: "Restaurantes e similares"
    },
    {
        value: "6010100",
        label: "Atividades de rádio"
    },
    {
        value: "2021500",
        label: "Fabricação de produtos petroquímicos básicos"
    },
    {
        value: "0119904",
        label: "Cultivo de cebola"
    },
    {
        value: "5240199",
        label: "Atividades auxiliares dos transportes aéreos, exceto operação dos aeroportos e campos de aterrissagem"
    },
    {
        value: "0159899",
        label: "Criação de outros animais não especificados anteriormente"
    },
    {
        value: "6410700",
        label: "Banco Central"
    },
    {
        value: "4645101",
        label: "Comércio atacadista de instrumentos e materiais para uso médico, cirúrgico, hospitalar e de laboratórios"
    },
    {
        value: "5112999",
        label: "Outros serviços de transporte aéreo de passageiros não regular"
    },
    {
        value: "0210104",
        label: "Cultivo de teca"
    },
    {
        value: "3299099",
        label: "Fabricação de produtos diversos não especificados anteriormente"
    },
    {
        value: "9200301",
        label: "Casas de bingo"
    },
    {
        value: "1122403",
        label: "Fabricação de refrescos, xaropes e pós para refrescos, exceto refrescos de frutas"
    },
    {
        value: "4684202",
        label: "Comércio atacadista de solventes"
    },
    {
        value: "3513100",
        label: "Comércio atacadista de energia elétrica"
    },
    {
        value: "3314722",
        label: "Manutenção e reparação de máquinas e aparelhos para a indústria do plástico"
    },
    {
        value: "1072401",
        label: "Fabricação de açúcar de cana refinado"
    },
    {
        value: "0155501",
        label: "Criação de frangos para corte"
    },
    {
        value: "4929999",
        label: "Outros transportes rodoviários de passageiros não especificados anteriormente"
    },
    {
        value: "2449199",
        label: "Metalurgia de outros metais não ferrosos e suas ligas não especificados anteriormente"
    },
    {
        value: "7319001",
        label: "Criação de estandes para feiras e exposições"
    },
    {
        value: "1330800",
        label: "Fabricação de tecidos de malha"
    },
    {
        value: "1922599",
        label: "Fabricação de outros produtos derivados do petróleo, exceto produtos do refino"
    },
    {
        value: "4221901",
        label: "Construção de barragens e represas para geração de energia \nelétrica"
    },
    {
        value: "1539400",
        label: "Fabricação de calçados de materiais não especificados\nanteriormente"
    },
    {
        value: "3220500",
        label: "Fabricação de instrumentos musicais, peças e acessórios"
    },
    {
        value: "9412099",
        label: "Outras atividades associativas profissionais"
    },
    {
        value: "0220904",
        label: "Coleta de látex em florestas nativas"
    },
    {
        value: "4313400",
        label: "Obras de terraplenagem"
    },
    {
        value: "2399102",
        label: "Fabricação de abrasivos"
    },
    {
        value: "7220700",
        label: "Pesquisa e desenvolvimento experimental em ciências sociais e humanas"
    },
    {
        value: "8230001",
        label: "Serviços de organização de feiras, congressos, exposições e festas"
    },
    {
        value: "0112101",
        label: "Cultivo de algodão herbáceo"
    },
    {
        value: "8630599",
        label: "Atividades de atenção ambulatorial não especificadas anteriormente"
    },
    {
        value: "6435202",
        label: "Associações de poupança e empréstimo"
    },
    {
        value: "3311200",
        label: "Manutenção e reparação de tanques, reservatórios metálicos e caldeiras, exceto para veículos"
    },
    {
        value: "8711502",
        label: "Instituições de longa permanência para idosos"
    },
    {
        value: "0311602",
        label: "Pesca de crustáceos e moluscos em água salgada"
    },
    {
        value: "4752100",
        label: "Comércio varejista especializado de equipamentos de telefonia e comunicação"
    },
    {
        value: "8630502",
        label: "Atividade médica ambulatorial com recursos para realização de exames complementares"
    },
    {
        value: "4731800",
        label: "Comércio varejista de combustíveis para veículos automotores"
    },
    {
        value: "1052000",
        label: "Fabricação de laticínios"
    },
    {
        value: "2091600",
        label: "Fabricação de adesivos e selantes"
    },
    {
        value: "1742702",
        label: "Fabricação de absorventes higiênicos"
    },
    {
        value: "0159801",
        label: "Apicultura"
    },
    {
        value: "8621601",
        label: "UTI móvel"
    },
    {
        value: "1351100",
        label: "Fabricação de artefatos têxteis para uso doméstico"
    },
    {
        value: "8299705",
        label: "Serviços de levantamento de fundos sob contrato"
    },
    {
        value: "4631100",
        label: "Comércio atacadista de leite e laticínios"
    },
    {
        value: "2532202",
        label: "Metalurgia do pó"
    },
    {
        value: "4292802",
        label: "Obras de montagem industrial"
    },
    {
        value: "2621300",
        label: "Fabricação de equipamentos de informática"
    },
    {
        value: "1830003",
        label: "Reprodução de software em qualquer suporte"
    },
    {
        value: "6470103",
        label: "Fundos de investimento imobiliários"
    },
    {
        value: "4753900",
        label: "Comércio varejista especializado de eletrodomésticos e equipamentos de áudio e vídeo"
    },
    {
        value: "4511101",
        label: "Comércio a varejo de automóveis, camionetas e utilitários novos"
    },
    {
        value: "2063100",
        label: "Fabricação de cosméticos, produtos de perfumaria e de higiene pessoal"
    },
    {
        value: "0142300",
        label: "Produção de mudas e outras formas de propagação vegetal, certificadas"
    },
    {
        value: "4756300",
        label: "Comércio varejista especializado de instrumentos musicais e acessórios"
    },
    {
        value: "9430800",
        label: "Atividades de associações de defesa de direitos sociais"
    },
    {
        value: "4321500",
        label: "Instalação e manutenção elétrica"
    },
    {
        value: "2099199",
        label: "Fabricação de outros produtos químicos não especificados anteriormente"
    },
    {
        value: "2391501",
        label: "Britamento de pedras, exceto associado à extração"
    },
    {
        value: "9529103",
        label: "Reparação de relógios"
    },
    {
        value: "6470102",
        label: "Fundos de investimento previdenciários"
    },
    {
        value: "4763603",
        label: "Comércio varejista de bicicletas e triciclos; peças e acessórios"
    },
    {
        value: "4651601",
        label: "Comércio atacadista de equipamentos de informática"
    },
    {
        value: "3250701",
        label: "Fabricação de instrumentos não eletrônicos e utensílios para uso médico, cirúrgico, odontológico e de laboratório"
    },
    {
        value: "0220999",
        label: "Coleta de produtos não madeireiros não especificados anteriormente em florestas nativas"
    },
    {
        value: "2531401",
        label: "Produção de forjados de aço"
    },
    {
        value: "0892402",
        label: "Extração de sal-gema"
    },
    {
        value: "6499902",
        label: "Sociedades de investimento"
    },
    {
        value: "1012104",
        label: "Matadouro - abate de suínos sob contrato"
    },
    {
        value: "3050400",
        label: "Fabricação de veículos militares de combate"
    },
    {
        value: "5510801",
        label: "Hotéis"
    },
    {
        value: "8020001",
        label: "Atividades de monitoramento de sistemas de segurança eletrônico"
    },
    {
        value: "4686902",
        label: "Comércio atacadista de embalagens"
    },
    {
        value: "4759899",
        label: "Comércio varejista de outros artigos de uso doméstico não especificados anteriormente"
    },
    {
        value: "4751202",
        label: "Recarga de cartuchos para equipamentos de informática"
    },
    {
        value: "1062700",
        label: "Moagem de trigo e fabricação de derivados"
    },
    {
        value: "5091201",
        label: "Transporte por navegação de travessia, municipal"
    },
    {
        value: "3250703",
        label: "Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral sob encomenda"
    },
    {
        value: "5229001",
        label: "Serviços de apoio ao transporte por táxi, inclusive centrais de chamada"
    },
    {
        value: "9103100",
        label: "Atividades de jardins botânicos, zoológicos, parques nacionais, reservas ecológicas e áreas de proteção ambiental"
    },
    {
        value: "4330402",
        label: "Instalação de portas, janelas, tetos, divisórias e armários embutidos de qualquer material"
    },
    {
        value: "2320600",
        label: "Fabricação de cimento"
    },
    {
        value: "3839499",
        label: "Recuperação de materiais não especificados anteriormente"
    },
    {
        value: "1082100",
        label: "Fabricação de produtos à base de café"
    },
    {
        value: "0321304",
        label: "Criação de peixes ornamentais em água salgada e salobra"
    },
    {
        value: "4789005",
        label: "Comércio varejista de produtos saneantes domissanitários"
    },
    {
        value: "4729602",
        label: "Comércio varejista de mercadorias em lojas de conveniência"
    },
    {
        value: "4542101",
        label: "Representantes comerciais e agentes do comércio de motocicletas e motonetas, peças e acessórios"
    },
    {
        value: "4520007",
        label: "Serviços de instalação, manutenção e reparação de acessórios para veículos automotores"
    },
    {
        value: "1033302",
        label: "Fabricação de sucos de frutas, hortaliças e legumes, exceto concentrados"
    },
    {
        value: "7810800",
        label: "Seleção e agenciamento de mão de obra"
    },
    {
        value: "6622300",
        label: "Corretores e agentes de seguros, de planos de previdência complementar e de saúde"
    },
    {
        value: "2599302",
        label: "Serviço de corte e dobra de metais"
    },
    {
        value: "2640000",
        label: "Fabricação de aparelhos de recepção, reprodução, gravação e amplificação de áudio e vídeo"
    },
    {
        value: "2330303",
        label: "Fabricação de artefatos de fibrocimento para uso na construção"
    },
    {
        value: "0899199",
        label: "Extração de outros minerais não metálicos não especificados anteriormente"
    },
    {
        value: "3314710",
        label: "Manutenção e reparação de máquinas e equipamentos para uso geral não especificados anteriormente"
    },
    {
        value: "5912002",
        label: "Serviços de mixagem sonora em produção audiovisual"
    },
    {
        value: "8650007",
        label: "Atividades de terapia de nutrição enteral e parenteral"
    },
    {
        value: "0133409",
        label: "Cultivo de maracujá"
    },
    {
        value: "7490104",
        label: "Atividades de intermediação e agenciamento de serviços e negócios em geral, exceto imobiliários"
    },
    {
        value: "4623101",
        label: "Comércio atacadista de animais vivos"
    },
    {
        value: "2944100",
        label: "Fabricação de peças e acessórios para o sistema de direção e suspensão de veículos automotores"
    },
    {
        value: "0322199",
        label: "Cultivos e semicultivos da aquicultura em água doce não especificados anteriormente"
    },
    {
        value: "9529101",
        label: "Reparação de calçados, bolsas e artigos de viagem"
    },
    {
        value: "2824102",
        label: "Fabricação de aparelhos e equipamentos de ar condicionado para uso não industrial"
    },
    {
        value: "3292201",
        label: "Fabricação de roupas de proteção e segurança e resistentes a fogo"
    },
    {
        value: "5229099",
        label: "Outras atividades auxiliares dos transportes terrestres não especificadas anteriormente"
    },
    {
        value: "1061902",
        label: "Fabricação de produtos do arroz"
    },
    {
        value: "4639702",
        label: "Comércio atacadista de produtos alimentícios em geral, com atividade de fracionamento e acondicionamento associada"
    },
    {
        value: "4541206",
        label: "Comércio a varejo de peças e acessórios novos para motocicletas e motonetas"
    },
    {
        value: "1922502",
        label: "Rerrefino de óleos lubrificantes"
    },
    {
        value: "1323500",
        label: "Tecelagem de fios de fibras artificiais e sintéticas"
    },
    {
        value: "4689302",
        label: "Comércio atacadista de fios e fibras beneficiados"
    },
    {
        value: "2229399",
        label: "Fabricação de artefatos de material plástico para outros usos não especificados anteriormente"
    },
    {
        value: "1314600",
        label: "Fabricação de linhas para costurar e bordar"
    },
    {
        value: "4674500",
        label: "Comércio atacadista de cimento"
    },
    {
        value: "8610101",
        label: "Atividades de atendimento hospitalar, exceto pronto-socorro e unidades para atendimento a urgências"
    },
    {
        value: "9609202",
        label: "Agências matrimoniais"
    },
    {
        value: "4644302",
        label: "Comércio atacadista de medicamentos e drogas de uso veterinário"
    },
    {
        value: "4789006",
        label: "Comércio varejista de fogos de artifício e artigos pirotécnicos"
    },
    {
        value: "0210107",
        label: "Extração de madeira em florestas plantadas"
    },
    {
        value: "0114800",
        label: "Cultivo de fumo"
    },
    {
        value: "6611804",
        label: "Administração de mercados de balcão organizados"
    },
    {
        value: "2861500",
        label: "Fabricação de máquinas para a indústria metalúrgica, peças e acessórios, exceto máquinas-ferramenta"
    },
    {
        value: "2722802",
        label: "Recondicionamento de baterias e acumuladores para veículos automotores"
    },
    {
        value: "4669901",
        label: "Comércio atacadista de bombas e compressores; partes e peças"
    },
    {
        value: "0311603",
        label: "Coleta de outros produtos marinhos"
    },
    {
        value: "6550200",
        label: "Planos de saúde"
    },
    {
        value: "1610201",
        label: "Serrarias com desdobramento de madeira"
    },
    {
        value: "1020102",
        label: "Fabricação de conservas de peixes, crustáceos e moluscos"
    },
    {
        value: "8690904",
        label: "Atividades de podologia"
    },
    {
        value: "2930103",
        label: "Fabricação de cabines, carrocerias e reboques para outros veículos automotores, exceto caminhões e ônibus"
    },
    {
        value: "1610204",
        label: "Serrarias sem desdobramento de madeira em bruto - Resseragem"
    },
    {
        value: "2790202",
        label: "Fabricação de equipamentos para sinalização e alarme"
    },
    {
        value: "2052500",
        label: "Fabricação de desinfestantes domissanitários"
    },
    {
        value: "9492800",
        label: "Atividades de organizações políticas"
    },
    {
        value: "4665600",
        label: "Comércio atacadista de máquinas e equipamentos para uso comercial; partes e peças"
    },
    {
        value: "1529700",
        label: "Fabricação de artefatos de couro não especificados anteriormente"
    },
    {
        value: "6463800",
        label: "Outras sociedades de participação, exceto holdings"
    },
    {
        value: "6611802",
        label: "Bolsa de mercadorias"
    },
    {
        value: "1340501",
        label: "Estamparia e texturização em fios, tecidos, artefatos têxteis e peças do vestuário"
    },
    {
        value: "4929903",
        label: "Organização de excursões em veículos rodoviários próprios, municipal"
    },
    {
        value: "1733800",
        label: "Fabricação de chapas e de embalagens de papelão ondulado"
    },
    {
        value: "3042300",
        label: "Fabricação de turbinas, motores e outros componentes e peças para aeronaves"
    },
    {
        value: "4930201",
        label: "Transporte rodoviário de carga, exceto produtos perigosos e mudanças, municipal"
    },
    {
        value: "4617600",
        label: "Representantes comerciais e agentes do comércio de produtos alimentícios, bebidas e fumo"
    },
    {
        value: "6821801",
        label: "Corretagem na compra e venda e avaliação de imóveis"
    },
    {
        value: "2442300",
        label: "Metalurgia dos metais preciosos"
    },
    {
        value: "4649409",
        label: "Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar, com atividade de fracionamento e acondicionamento associada"
    },
    {
        value: "8730102",
        label: "Albergues assistenciais"
    },
    {
        value: "8542200",
        label: "Educação profissional de nível tecnológico"
    },
    {
        value: "6630400",
        label: "Atividades de administração de fundos por contrato ou comissão"
    },
    {
        value: "4623106",
        label: "Comércio atacadista de sementes, flores, plantas e gramas"
    },
    {
        value: "2342701",
        label: "Fabricação de azulejos e pisos"
    },
    {
        value: "9313100",
        label: "Atividades de condicionamento físico"
    },
    {
        value: "9609299",
        label: "Outras atividades de serviços pessoais não especificadas anteriormente"
    },
    {
        value: "2910703",
        label: "Fabricação de motores para automóveis, camionetas e utilitários"
    },
    {
        value: "4399102",
        label: "Montagem e desmontagem de andaimes e outras estruturas temporárias"
    },
    {
        value: "1531902",
        label: "Acabamento de calçados de couro sob contrato"
    },
    {
        value: "4110700",
        label: "Incorporação de empreendimentos imobiliários"
    },
    {
        value: "5812300",
        label: "Edição de jornais"
    },
    {
        value: "3250709",
        label: "Serviço de laboratório óptico"
    },
    {
        value: "4724500",
        label: "Comércio varejista de hortifrutigranjeiros"
    },
    {
        value: "2831300",
        label: "Fabricação de tratores agrícolas, peças e acessórios"
    },
    {
        value: "0893200",
        label: "Extração de gemas (pedras preciosas e semipreciosas)"
    },
    {
        value: "2412100",
        label: "Produção de ferroligas"
    },
    {
        value: "2391502",
        label: "Aparelhamento de pedras para construção, exceto associado à extração"
    },
    {
        value: "4912402",
        label: "Transporte ferroviário de passageiros municipal e em região metropolitana"
    },
    {
        value: "8591100",
        label: "Ensino de esportes"
    },
    {
        value: "8711503",
        label: "Atividades de assistência a deficientes físicos, imunodeprimidos e convalescentes"
    },
    {
        value: "0210109",
        label: "Produção de casca de acácia-negra - florestas plantadas"
    },
    {
        value: "4744006",
        label: "Comércio varejista de pedras para revestimento"
    },
    {
        value: "2449103",
        label: "Fabricação de ânodos para galvanoplastia"
    },
    {
        value: "1053800",
        label: "Fabricação de sorvetes e outros gelados comestíveis"
    },
    {
        value: "0133401",
        label: "Cultivo de açaí"
    },
    {
        value: "8220200",
        label: "Atividades de teleatendimento"
    },
    {
        value: "4672900",
        label: "Comércio atacadista de ferragens e ferramentas"
    },
    {
        value: "1011203",
        label: "Frigorífico - abate de ovinos e caprinos"
    },
    {
        value: "1122401",
        label: "Fabricação de refrigerantes"
    },
    {
        value: "6612605",
        label: "Agentes de investimentos em aplicações financeiras"
    },
    {
        value: "8011101",
        label: "Atividades de vigilância e segurança privada"
    },
    {
        value: "7722500",
        label: "Aluguel de fitas de vídeo, DVDs e similares"
    },
    {
        value: "4541203",
        label: "Comércio a varejo de motocicletas e motonetas novas"
    },
    {
        value: "8011102",
        label: "Serviços de adestramento de cães de guarda"
    },
    {
        value: "6530800",
        label: "Resseguros"
    },
    {
        value: "4312600",
        label: "Perfurações e sondagens"
    },
    {
        value: "4221904",
        label: "Construção de estações e redes de telecomunicações"
    },
    {
        value: "8690902",
        label: "Atividades de bancos de leite humano"
    },
    {
        value: "3316302",
        label: "Manutenção de aeronaves na pista"
    },
    {
        value: "6612604",
        label: "Corretoras de contratos de mercadorias"
    },
    {
        value: "3292202",
        label: "Fabricação de equipamentos e acessórios para segurança pessoal e profissional"
    },
    {
        value: "2092401",
        label: "Fabricação de pólvoras, explosivos e detonantes"
    },
    {
        value: "9003500",
        label: "Gestão de espaços para artes cênicas, espetáculos e outras atividades artísticas"
    },
    {
        value: "3312103",
        label: "Manutenção e reparação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação"
    },
    {
        value: "6432800",
        label: "Bancos de investimento"
    },
    {
        value: "4511106",
        label: "Comércio por atacado de ônibus e micro-ônibus novos e usados"
    },
    {
        value: "5911102",
        label: "Produção de filmes para publicidade"
    },
    {
        value: "9609208",
        label: "Higiene e embelezamento de animais domésticos"
    },
    {
        value: "1629302",
        label: "Fabricação de artefatos diversos de cortiça, bambu, palha, vime e outros materiais trançados, exceto móveis"
    },
    {
        value: "1094500",
        label: "Fabricação de massas alimentícias"
    },
    {
        value: "2441502",
        label: "Produção de laminados de alumínio"
    },
    {
        value: "6611803",
        label: "Bolsa de mercadorias e futuros"
    },
    {
        value: "5091202",
        label: "Transporte por navegação de travessia, intermunicipal, interestadual e internacional"
    },
    {
        value: "8630506",
        label: "Serviços de vacinação e imunização humana"
    },
    {
        value: "5022002",
        label: "Transporte por navegação interior de passageiros em linhas regulares, intermunicipal, interestadual e internacional, exceto travessia"
    },
    {
        value: "9200302",
        label: "Exploração de apostas em corridas de cavalos"
    },
    {
        value: "3600602",
        label: "Distribuição de água por caminhões"
    },
    {
        value: "6499905",
        label: "Concessão de crédito pelas OSCIP"
    },
    {
        value: "5211701",
        label: "Armazéns gerais - emissão de warrant"
    },
    {
        value: "1099603",
        label: "Fabricação de fermentos e leveduras"
    },
    {
        value: "9521500",
        label: "Reparação e manutenção de equipamentos eletroeletrônicos de uso pessoal e doméstico"
    },
    {
        value: "8413200",
        label: "Regulação das atividades econômicas"
    },
    {
        value: "4711302",
        label: "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - supermercados"
    },
    {
        value: "4671100",
        label: "Comércio atacadista de madeira e produtos derivados"
    },
    {
        value: "4618403",
        label: "Representantes comerciais e agentes do comércio de jornais, revistas e outras publicações"
    },
    {
        value: "8121400",
        label: "Limpeza em prédios e em domicílios"
    },
    {
        value: "3091100",
        label: "Fabricação de motocicletas, peças e acessórios"
    },
    {
        value: "5914600",
        label: "Atividades de exibição cinematográfica"
    },
    {
        value: "4322301",
        label: "Instalações hidráulicas, sanitárias e de gás"
    },
    {
        value: "4687703",
        label: "Comércio atacadista de resíduos e sucatas metálicos"
    },
    {
        value: "7739003",
        label: "Aluguel de palcos, coberturas e outras estruturas de uso temporário, exceto andaimes"
    },
    {
        value: "6911702",
        label: "Atividades auxiliares da justiça"
    },
    {
        value: "8640214",
        label: "Serviços de bancos de células e tecidos humanos"
    },
    {
        value: "3012100",
        label: "Construção de embarcações para esporte e lazer"
    },
    {
        value: "8650002",
        label: "Atividades de profissionais da nutrição"
    },
    {
        value: "5229002",
        label: "Serviços de reboque de veículos"
    },
    {
        value: "4637101",
        label: "Comércio atacadista de café torrado, moído e solúvel"
    },
    {
        value: "1931400",
        label: "Fabricação de álcool"
    },
    {
        value: "3329599",
        label: "Instalação de outros equipamentos não especificados anteriormente"
    },
    {
        value: "1081301",
        label: "Beneficiamento de café"
    },
    {
        value: "4929902",
        label: "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, intermunicipal, interestadual e internacional"
    },
    {
        value: "0210102",
        label: "Cultivo de acácia-negra"
    },
    {
        value: "6911701",
        label: "Serviços advocatícios"
    },
    {
        value: "2815101",
        label: "Fabricação de rolamentos para fins industriais"
    },
    {
        value: "7119702",
        label: "Atividades de estudos geológicos"
    },
    {
        value: "1032501",
        label: "Fabricação de conservas de palmito"
    },
    {
        value: "8690999",
        label: "Outras atividades de atenção à saúde humana não especificadas anteriormente"
    },
    {
        value: "2632900",
        label: "Fabricação de aparelhos telefônicos e de outros equipamentos de comunicação, peças e acessórios"
    },
    {
        value: "1066000",
        label: "Fabricação de alimentos para animais"
    },
    {
        value: "0111399",
        label: "Cultivo de outros cereais não especificados anteriormente"
    },
    {
        value: "0162803",
        label: "Serviço de manejo de animais"
    },
    {
        value: "4399105",
        label: "Perfuração e construção de poços de água"
    },
    {
        value: "3822000",
        label: "Tratamento e disposição de resíduos perigosos"
    },
    {
        value: "9512600",
        label: "Reparação e manutenção de equipamentos de comunicação"
    },
    {
        value: "6612603",
        label: "Corretoras de câmbio"
    },
    {
        value: "3240003",
        label: "Fabricação de mesas de bilhar, de sinuca e acessórios associada à locação"
    },
    {
        value: "6520100",
        label: "Sociedade seguradora de seguros-saúde"
    },
    {
        value: "4329103",
        label: "Instalação, manutenção e reparação de elevadores, escadas e esteiras rolantes"
    },
    {
        value: "5920100",
        label: "Atividades de gravação de som e de edição de música"
    },
    {
        value: "5240101",
        label: "Operação dos aeroportos e campos de aterrissagem"
    },
    {
        value: "2449101",
        label: "Produção de zinco em formas primárias"
    },
    {
        value: "2864000",
        label: "Fabricação de máquinas e equipamentos para as indústrias do vestuário, do couro e de calçados, peças e acessórios"
    },
    {
        value: "9700500",
        label: "Serviços domésticos"
    },
    {
        value: "6141800",
        label: "Operadoras de televisão por assinatura por cabo"
    },
    {
        value: "5320202",
        label: "Serviços de entrega rápida"
    },
    {
        value: "7820500",
        label: "Locação de mão de obra temporária"
    },
    {
        value: "1061901",
        label: "Beneficiamento de arroz"
    },
    {
        value: "2019399",
        label: "Fabricação de outros produtos químicos inorgânicos não especificados anteriormente"
    },
    {
        value: "4712100",
        label: "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - minimercados, mercearias e armazéns"
    },
    {
        value: "1069400",
        label: "Moagem e fabricação de produtos de origem vegetal não especificados anteriormente"
    },
    {
        value: "5231102",
        label: "Atividades do Operador Portuário"
    },
    {
        value: "2863100",
        label: "Fabricação de máquinas e equipamentos para a indústria têxtil, peças e acessórios"
    },
    {
        value: "3839401",
        label: "Usinas de compostagem"
    },
    {
        value: "4687702",
        label: "Comércio atacadista de resíduos e sucatas não metálicos, exceto de papel e papelão"
    },
    {
        value: "0710302",
        label: "Pelotização, sinterização e outros beneficiamentos de minério de ferro"
    },
    {
        value: "0159802",
        label: "Criação de animais de estimação"
    },
    {
        value: "4744002",
        label: "Comércio varejista de madeira e artefatos"
    },
    {
        value: "4530705",
        label: "Comércio a varejo de pneumáticos e câmaras-de-ar"
    },
    {
        value: "4637199",
        label: "Comércio atacadista especializado em outros produtos alimentícios não especificados anteriormente"
    },
    {
        value: "5822102",
        label: "Edição integrada à impressão de jornais não diários"
    },
    {
        value: "4924800",
        label: "Transporte escolar"
    },
    {
        value: "8424800",
        label: "Segurança e ordem pública"
    },
    {
        value: "2854200",
        label: "Fabricação de máquinas e equipamentos para terraplenagem, pavimentação e construção, peças e acessórios, exceto tratores"
    },
    {
        value: "3314703",
        label: "Manutenção e reparação de válvulas industriais"
    },
    {
        value: "3240001",
        label: "Fabricação de jogos eletrônicos"
    },
    {
        value: "1813099",
        label: "Impressão de material para outros usos"
    },
    {
        value: "9329899",
        label: "Outras atividades de recreação e lazer não especificadas anteriormente"
    },
    {
        value: "4636201",
        label: "Comércio atacadista de fumo beneficiado"
    },
    {
        value: "0139303",
        label: "Cultivo de pimenta-do-reino"
    },
    {
        value: "5011402",
        label: "Transporte marítimo de cabotagem - Passageiros"
    },
    {
        value: "3314705",
        label: "Manutenção e reparação de equipamentos de transmissão para fins industriais"
    },
    {
        value: "3211601",
        label: "Lapidação de gemas"
    },
    {
        value: "1122499",
        label: "Fabricação de outras bebidas não alcoólicas não especificadas anteriormente"
    },
    {
        value: "2670101",
        label: "Fabricação de equipamentos e instrumentos ópticos, peças e acessórios"
    },
    {
        value: "4789002",
        label: "Comércio varejista de plantas e flores naturais"
    },
    {
        value: "2330302",
        label: "Fabricação de artefatos de cimento para uso na construção"
    },
    {
        value: "4689399",
        label: "Comércio atacadista especializado em outros produtos intermediários não especificados anteriormente"
    },
    {
        value: "8513900",
        label: "Ensino fundamental"
    },
    {
        value: "0322103",
        label: "Criação de ostras e mexilhões em água doce"
    },
    {
        value: "2341900",
        label: "Fabricação de produtos cerâmicos refratários"
    },
    {
        value: "4755503",
        label: "Comercio varejista de artigos de cama, mesa e banho"
    },
    {
        value: "4744099",
        label: "Comércio varejista de materiais de construção em geral"
    },
    {
        value: "9001904",
        label: "Produção de espetáculos circenses, de marionetes e similares"
    },
    {
        value: "3511502",
        label: "Atividades de coordenação e controle da operação da geração e transmissão de energia elétrica"
    },
    {
        value: "7119799",
        label: "Atividades técnicas relacionadas à engenharia e arquitetura não especificadas anteriormente"
    },
    {
        value: "2121103",
        label: "Fabricação de medicamentos fitoterápicos para uso humano"
    },
    {
        value: "4742300",
        label: "Comércio varejista de material elétrico"
    },
    {
        value: "0116401",
        label: "Cultivo de amendoim"
    },
    {
        value: "2539002",
        label: "Serviços de tratamento e revestimento em metais"
    },
    {
        value: "0892401",
        label: "Extração de sal marinho"
    },
    {
        value: "4646002",
        label: "Comércio atacadista de produtos de higiene pessoal"
    },
    {
        value: "7490103",
        label: "Serviços de agronomia e de consultoria às atividades agrícolas e pecuárias"
    },
    {
        value: "6022502",
        label: "Atividades relacionadas à televisão por assinatura, exceto programadoras"
    },
    {
        value: "4647802",
        label: "Comércio atacadista de livros, jornais e outras publicações"
    },
    {
        value: "3250704",
        label: "Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral, exceto sob encomenda"
    },
    {
        value: "1822901",
        label: "Serviços de encadernação e plastificação"
    },
    {
        value: "1340502",
        label: "Alvejamento, tingimento e torção em fios, tecidos, artefatos têxteis e peças do vestuário"
    },
    {
        value: "4649407",
        label: "Comércio atacadista de filmes, CDs, DVDs, fitas e discos"
    },
    {
        value: "9102302",
        label: "Restauração e conservação de lugares e prédios históricos"
    },
    {
        value: "2660400",
        label: "Fabricação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação"
    },
    {
        value: "3250707",
        label: "Fabricação de artigos ópticos"
    },
    {
        value: "6120599",
        label: "Serviços de telecomunicações sem fio não especificados anteriormente"
    },
    {
        value: "6499901",
        label: "Clubes de investimento"
    },
    {
        value: "0990402",
        label: "Atividades de apoio à extração de minerais metálicos não ferrosos"
    },
    {
        value: "4330404",
        label: "Serviços de pintura de edifícios em geral"
    },
    {
        value: "1071600",
        label: "Fabricação de açúcar em bruto"
    },
    {
        value: "5819100",
        label: "Edição de cadastros, listas e outros produtos gráficos"
    },
    {
        value: "8550302",
        label: "Atividades de apoio à educação, exceto caixas escolares"
    },
    {
        value: "6022501",
        label: "Programadoras"
    },
    {
        value: "9329803",
        label: "Exploração de jogos de sinuca, bilhar e similares"
    },
    {
        value: "4754702",
        label: "Comércio varejista de artigos de colchoaria"
    },
    {
        value: "7490105",
        label: "Agenciamento de profissionais para atividades esportivas, culturais e artísticas"
    },
    {
        value: "3211603",
        label: "Cunhagem de moedas e medalhas"
    },
    {
        value: "4649403",
        label: "Comércio atacadista de bicicletas, triciclos e outros veículos recreativos"
    },
    {
        value: "1621800",
        label: "Fabricação de madeira laminada e de chapas de madeira compensada, prensada e aglomerada"
    },
    {
        value: "8640203",
        label: "Serviços de diálise e nefrologia"
    },
    {
        value: "4761003",
        label: "Comércio varejista de artigos de papelaria"
    },
    {
        value: "2212900",
        label: "Reforma de pneumáticos usados"
    },
    {
        value: "1741902",
        label: "Fabricação de produtos de papel, cartolina, papel-cartão e papelão ondulado para uso comercial e de escritório"
    },
    {
        value: "4693100",
        label: "Comércio atacadista de mercadorias em geral, sem predominância de alimentos ou de insumos agropecuários"
    },
    {
        value: "6431000",
        label: "Bancos múltiplos, sem carteira comercial"
    },
    {
        value: "4623103",
        label: "Comércio atacadista de algodão"
    },
    {
        value: "1065101",
        label: "Fabricação de amidos e féculas de vegetais"
    },
    {
        value: "1091102",
        label: "Fabricação de produtos de padaria e confeitaria com predominância de produção própria"
    },
    {
        value: "0312402",
        label: "Pesca de crustáceos e moluscos em água doce"
    },
    {
        value: "5212500",
        label: "Carga e descarga"
    },
    {
        value: "0810008",
        label: "Extração de saibro e beneficiamento associado"
    },
    {
        value: "6190699",
        label: "Outras atividades de telecomunicações não especificadas anteriormente"
    },
    {
        value: "0162802",
        label: "Serviço de tosquiamento de ovinos"
    },
    {
        value: "1353700",
        label: "Fabricação de artefatos de cordoaria"
    },
    {
        value: "1321900",
        label: "Tecelagem de fios de algodão"
    },
    {
        value: "3313901",
        label: "Manutenção e reparação de geradores, transformadores e motores elétricos"
    },
    {
        value: "9511800",
        label: "Reparação e manutenção de computadores e de equipamentos periféricos"
    },
    {
        value: "2110600",
        label: "Fabricação de produtos farmoquímicos"
    },
    {
        value: "8592902",
        label: "Ensino de artes cênicas, exceto dança"
    },
    {
        value: "2071100",
        label: "Fabricação de tintas, vernizes, esmaltes e lacas"
    },
    {
        value: "2592602",
        label: "Fabricação de produtos de trefilados de metal, exceto padronizados"
    },
    {
        value: "0322106",
        label: "Criação de jacaré"
    },
    {
        value: "6612602",
        label: "Distribuidoras de títulos e valores mobiliários"
    },
    {
        value: "0724302",
        label: "Beneficiamento de minério de metais preciosos"
    },
    {
        value: "4637105",
        label: "Comércio atacadista de massas alimentícias"
    },
    {
        value: "2399101",
        label: "Decoração, lapidação, gravação, vitrificação e outros trabalhos em cerâmica, louça, vidro e cristal"
    },
    {
        value: "0729403",
        label: "Extração de minério de níquel"
    },
    {
        value: "5030102",
        label: "Navegação de apoio portuário"
    },
    {
        value: "6470101",
        label: "Fundos de investimento, exceto previdenciários e imobiliários"
    },
    {
        value: "2943300",
        label: "Fabricação de peças e acessórios para o sistema de freios de veículos automotores"
    },
    {
        value: "5231103",
        label: "Gestão de terminais aquaviários"
    },
    {
        value: "4721102",
        label: "Padaria e confeitaria com predominância de revenda"
    },
    {
        value: "2790299",
        label: "Fabricação de outros equipamentos e aparelhos elétricos não especificados anteriormente"
    },
    {
        value: "1922501",
        label: "Formulação de combustíveis"
    },
    {
        value: "0153902",
        label: "Criação de ovinos, inclusive para produção de lã"
    },
    {
        value: "9101500",
        label: "Atividades de bibliotecas e arquivos"
    },
    {
        value: "0141501",
        label: "Produção de sementes certificadas, exceto de forrageiras para pasto"
    },
    {
        value: "8592999",
        label: "Ensino de arte e cultura não especificado anteriormente"
    },
    {
        value: "4541202",
        label: "Comércio por atacado de peças e acessórios para motocicletas e motonetas"
    },
    {
        value: "9609207",
        label: "Alojamento de animais domésticos"
    },
    {
        value: "6619303",
        label: "Representações de bancos estrangeiros"
    },
    {
        value: "2811900",
        label: "Fabricação de motores e turbinas, peças e acessórios, exceto para aviões e veículos rodoviários"
    },
    {
        value: "1012101",
        label: "Abate de aves"
    },
    {
        value: "2930101",
        label: "Fabricação de cabines, carrocerias e reboques para caminhões"
    },
    {
        value: "8712300",
        label: "Atividades de fornecimento de infraestrutura de apoio e assistência a paciente no domicílio"
    },
    {
        value: "8012900",
        label: "Atividades de transporte de valores"
    },
    {
        value: "0116403",
        label: "Cultivo de mamona"
    },
    {
        value: "2094100",
        label: "Fabricação de catalisadores"
    },
    {
        value: "8650004",
        label: "Atividades de fisioterapia"
    },
    {
        value: "8430200",
        label: "Seguridade social obrigatória"
    },
    {
        value: "7319003",
        label: "Marketing direto"
    },
    {
        value: "4614100",
        label: "Representantes comerciais e agentes do comércio de máquinas, equipamentos, embarcações e aeronaves"
    },
    {
        value: "4221905",
        label: "Manutenção de estações e redes de telecomunicações"
    },
    {
        value: "4649499",
        label: "Comércio atacadista de outros equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
    },
    {
        value: "2531402",
        label: "Produção de forjados de metais não ferrosos e suas ligas"
    },
    {
        value: "0133408",
        label: "Cultivo de mamão"
    },
    {
        value: "4647801",
        label: "Comércio atacadista de artigos de escritório e de papelaria"
    },
    {
        value: "2211100",
        label: "Fabricação de pneumáticos e de câmaras-de-ar"
    },
    {
        value: "0133404",
        label: "Cultivo de cítricos, exceto laranja"
    },
    {
        value: "9529106",
        label: "Reparação de jóias"
    },
    {
        value: "9102301",
        label: "Atividades de museus e de exploração de lugares e prédios históricos e atrações similares"
    },
    {
        value: "0723501",
        label: "Extração de minério de manganês"
    },
    {
        value: "2733300",
        label: "Fabricação de fios, cabos e condutores elétricos isolados"
    },
    {
        value: "0155503",
        label: "Criação de outros galináceos, exceto para corte"
    },
    {
        value: "0119901",
        label: "Cultivo de abacaxi"
    },
    {
        value: "5223100",
        label: "Estacionamento de veículos"
    },
    {
        value: "3520401",
        label: "Produção de gás; processamento de gás natural"
    },
    {
        value: "0131800",
        label: "Cultivo de laranja"
    },
    {
        value: "4930202",
        label: "Transporte rodoviário de carga, exceto produtos perigosos e mudanças, intermunicipal, interestadual e internacional"
    },
    {
        value: "4912403",
        label: "Transporte metroviário"
    },
    {
        value: "1811301",
        label: "Impressão de jornais"
    },
    {
        value: "8520100",
        label: "Ensino médio"
    },
    {
        value: "1091101",
        label: "Fabricação de produtos de panificação industrial"
    },
    {
        value: "2229302",
        label: "Fabricação de artefatos de material plástico para usos industriais"
    },
    {
        value: "5911199",
        label: "Atividades de produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente"
    },
    {
        value: "4723700",
        label: "Comércio varejista de bebidas"
    },
    {
        value: "0111301",
        label: "Cultivo de arroz"
    },
    {
        value: "7729299",
        label: "Aluguel de outros objetos pessoais e domésticos não especificados anteriormente"
    },
    {
        value: "2759799",
        label: "Fabricação de outros aparelhos eletrodomésticos não especificados anteriormente, peças e acessórios"
    },
    {
        value: "1095300",
        label: "Fabricação de especiarias, molhos, temperos e condimentos"
    },
    {
        value: "2013402",
        label: "Fabricação de adubos e fertilizantes, exceto organo-minerais"
    },
    {
        value: "4692300",
        label: "Comércio atacadista de mercadorias em geral, com predominância de insumos agropecuários"
    },
    {
        value: "7319099",
        label: "Outras atividades de publicidade não especificadas anteriormente"
    },
    {
        value: "7410203",
        label: "Desing de produto"
    },
    {
        value: "5611204",
        label: "Bares e outros estabelecimentos especializados em servir bebidas, sem entretenimento"
    },
    {
        value: "3291400",
        label: "Fabricação de escovas, pincéis e vassouras"
    },
    {
        value: "2865800",
        label: "Fabricação de máquinas e equipamentos para as indústrias de celulose, papel e papelão e artefatos, peças e acessórios"
    },
    {
        value: "2652300",
        label: "Fabricação de cronômetros e relógios"
    },
    {
        value: "8219901",
        label: "Fotocópias"
    },
    {
        value: "2550102",
        label: "Fabricação de armas de fogo, outras armas e munições"
    },
    {
        value: "8690903",
        label: "Atividades de acupuntura"
    },
    {
        value: "4399103",
        label: "Obras de alvenaria"
    },
    {
        value: "9491000",
        label: "Atividades de organizações religiosas ou filosóficas"
    },
    {
        value: "7420004",
        label: "Filmagem de festas e eventos"
    },
    {
        value: "5250804",
        label: "Organização logística do transporte de carga"
    },
    {
        value: "2815102",
        label: "Fabricação de equipamentos de transmissão para fins industriais, exceto rolamentos"
    },
    {
        value: "0729405",
        label: "Beneficiamento de minérios de cobre, chumbo, zinco e outros minerais metálicos não ferrosos não especificados anteriormente"
    },
    {
        value: "4632003",
        label: "Comércio atacadista de cereais e leguminosas beneficiados, farinhas, amidos e féculas, com atividade de fracionamento e acondicionamento associada"
    },
    {
        value: "7731400",
        label: "Aluguel de máquinas e equipamentos agrícolas sem operador"
    },
    {
        value: "0121102",
        label: "Cultivo de morango"
    },
    {
        value: "4633802",
        label: "Comércio atacadista de aves vivas e ovos"
    },
    {
        value: "1013901",
        label: "Fabricação de produtos de carne"
    },
    {
        value: "6542100",
        label: "Previdência complementar aberta"
    },
    {
        value: "1311100",
        label: "Preparação e fiação de fibras de algodão"
    },
    {
        value: "0990403",
        label: "Atividades de apoio à extração de minerais não metálicos"
    },
    {
        value: "2599399",
        label: "Fabricação de outros produtos de metal não especificados anteriormente"
    },
    {
        value: "3511501",
        label: "Geração de energia elétrica"
    },
    {
        value: "0133406",
        label: "Cultivo de guaraná"
    },
    {
        value: "6612601",
        label: "Corretoras de títulos e valores mobiliários"
    },
    {
        value: "2532201",
        label: "Produção de artefatos estampados de metal"
    },
    {
        value: "0899102",
        label: "Extração de quartzo"
    },
    {
        value: "1012103",
        label: "Frigorífico - abate de suínos"
    },
    {
        value: "2740601",
        label: "Fabricação de lâmpadas"
    },
    {
        value: "4212000",
        label: "Construção de obras de arte especiais"
    },
    {
        value: "5812301",
        label: "Edição de jornais diários"
    },
    {
        value: "5211702",
        label: "Guarda-móveis"
    },
    {
        value: "7020400",
        label: "Atividades de consultoria em gestão empresarial, exceto consultoria técnica específica"
    },
    {
        value: "3091102",
        label: "Fabricação de peças e acessórios para motocicletas"
    },
    {
        value: "0729402",
        label: "Extração de minério de tungstênio"
    },
    {
        value: "0151201",
        label: "Criação de bovinos para corte"
    },
    {
        value: "7119703",
        label: "Serviços de desenho técnico relacionados à arquitetura e engenharia"
    },
    {
        value: "8640205",
        label: "Serviços de diagnóstico por imagem com uso de radiação ionizante, exceto tomografia"
    },
    {
        value: "3321000",
        label: "Instalação de máquinas e equipamentos industriais"
    },
    {
        value: "3312104",
        label: "Manutenção e reparação de equipamentos e instrumentos ópticos"
    },
    {
        value: "1099604",
        label: "Fabricação de gelo comum"
    },
    {
        value: "1011204",
        label: "Frigorífico - abate de bufalinos"
    },
    {
        value: "6499999",
        label: "Outras atividades de serviços financeiros não especificadas anteriormente"
    },
    {
        value: "5232000",
        label: "Atividades de agenciamento marítimo"
    },
    {
        value: "4645102",
        label: "Comércio atacadista de próteses e artigos de ortopedia"
    },
    {
        value: "2513600",
        label: "Fabricação de obras de caldeiraria pesada"
    },
    {
        value: "8630501",
        label: "Atividade médica ambulatorial com recursos para realização de procedimentos cirúrgicos"
    },
    {
        value: "4520008",
        label: "Serviços de capotaria"
    },
    {
        value: "8650001",
        label: "Atividades de enfermagem"
    },
    {
        value: "3250705",
        label: "Fabricação de materiais para medicina e odontologia"
    },
    {
        value: "6613400",
        label: "Administração de cartões de crédito"
    },
    {
        value: "3314712",
        label: "Manutenção e reparação de tratores agrícolas"
    },
    {
        value: "9609205",
        label: "Atividades de sauna e banhos"
    },
    {
        value: "6810202",
        label: "Aluguel de imóveis próprios"
    },
    {
        value: "3314717",
        label: "Manutenção e reparação de máquinas e equipamentos de terraplenagem, pavimentação e construção, exceto tratores"
    },
    {
        value: "4922102",
        label: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, interestadual"
    },
    {
        value: "0724301",
        label: "Extração de minério de metais preciosos"
    },
    {
        value: "5611205",
        label: "Bares e outros estabelecimentos especializados em servir bebidas, com entretenimento"
    },
    {
        value: "6435201",
        label: "Sociedades de crédito imobiliário"
    },
    {
        value: "0155502",
        label: "Produção de pintos de um dia"
    },
    {
        value: "1112700",
        label: "Fabricação de vinho"
    },
    {
        value: "4771704",
        label: "Comércio varejista de medicamentos veterinários"
    },
    {
        value: "4623108",
        label: "Comércio atacadista de matérias-primas agrícolas com atividade de fracionamento e acondicionamento associada"
    },
    {
        value: "8030700",
        label: "Atividades de investigação particular"
    },
    {
        value: "4541207",
        label: "Comércio a varejo de peças e acessórios usados para motocicletas e motonetas"
    },
    {
        value: "7733100",
        label: "Aluguel de máquinas e equipamentos para escritório"
    },
    {
        value: "2330301",
        label: "Fabricação de estruturas pré-moldadas de concreto armado, em série e sob encomenda"
    },
    {
        value: "0723502",
        label: "Beneficiamento de minério de manganês"
    },
    {
        value: "7120100",
        label: "Testes e análises técnicas"
    },
    {
        value: "2599301",
        label: "Serviços de confecção de armações metálicas para a construção"
    },
    {
        value: "1412603",
        label: "Facção de peças do vestuário, exceto roupas íntimas"
    },
    {
        value: "0116402",
        label: "Cultivo de girassol"
    },
    {
        value: "5611203",
        label: "Lanchonetes, casas de chá, de sucos e similares"
    },
    {
        value: "4399101",
        label: "Administração de obras"
    },
    {
        value: "9001905",
        label: "Produção de espetáculos de rodeios, vaquejadas e similares"
    },
    {
        value: "2311700",
        label: "Fabricação de vidro plano e de segurança"
    },
    {
        value: "8541400",
        label: "Educação profissional de nível técnico"
    },
    {
        value: "2423701",
        label: "Produção de tubos de aço sem costura"
    },
    {
        value: "0116499",
        label: "Cultivo de outras oleaginosas de lavoura temporária não especificadas anteriormente"
    },
    {
        value: "8592903",
        label: "Ensino de música"
    },
    {
        value: "3031800",
        label: "Fabricação de locomotivas, vagões e outros materiais rodantes"
    },
    {
        value: "4520005",
        label: "Serviços de lavagem, lubrificação e polimento de veículos automotores"
    },
    {
        value: "8130300",
        label: "Atividades paisagísticas"
    },
    {
        value: "3314702",
        label: "Manutenção e reparação de equipamentos hidráulicos e pneumáticos, exceto válvulas"
    },
    {
        value: "2710401",
        label: "Fabricação de geradores de corrente contínua e alternada, peças e acessórios"
    },
    {
        value: "4322303",
        label: "Instalações de sistema de prevenção contra incêndio"
    },
    {
        value: "6424704",
        label: "Cooperativas de crédito rural"
    },
    {
        value: "4763602",
        label: "Comércio varejista de artigos esportivos"
    },
    {
        value: "1063500",
        label: "Fabricação de farinha de mandioca e derivados"
    },
    {
        value: "2411300",
        label: "Produção de ferro-gusa"
    },
    {
        value: "6143400",
        label: "Operadoras de televisão por assinatura por satélite"
    },
    {
        value: "7112000",
        label: "Serviços de engenharia"
    },
    {
        value: "7739002",
        label: "Aluguel de equipamentos científicos, médicos e hospitalares, sem operador"
    },
    {
        value: "1421500",
        label: "Fabricação de meias"
    },
    {
        value: "6492100",
        label: "Securitização de créditos"
    },
    {
        value: "1011205",
        label: "Matadouro - abate de reses sob contrato, exceto abate de suínos"
    },
    {
        value: "4633801",
        label: "Comércio atacadista de frutas, verduras, raízes, tubérculos, hortaliças e legumes frescos"
    },
    {
        value: "9609204",
        label: "Exploração de máquinas de serviços pessoais acionadas por moeda"
    },
    {
        value: "1812100",
        label: "Impressão de material de segurança"
    },
    {
        value: "0322101",
        label: "Criação de peixes em água doce"
    },
    {
        value: "1622601",
        label: "Fabricação de casas de madeira pré-fabricadas"
    },
    {
        value: "2330304",
        label: "Fabricação de casas pré-moldadas de concreto"
    },
    {
        value: "4291000",
        label: "Obras portuárias, marítimas e fluviais"
    },
    {
        value: "4520003",
        label: "Serviços de manutenção e reparação elétrica de veículos automotores"
    },
    {
        value: "7719501",
        label: "Locação de embarcações sem tripulação, exceto para fins\nrecreativos"
    },
    {
        value: "2731700",
        label: "Fabricação de aparelhos e equipamentos para distribuição e controle de energia elétrica"
    },
    {
        value: "2591800",
        label: "Fabricação de embalagens metálicas"
    },
    {
        value: "8640211",
        label: "Serviços de radioterapia"
    },
    {
        value: "4329101",
        label: "Instalação de painéis publicitários"
    },
    {
        value: "0312401",
        label: "Pesca de peixes em água doce"
    },
    {
        value: "8291100",
        label: "Atividades de cobrança e informações cadastrais"
    },
    {
        value: "4783102",
        label: "Comércio varejista de artigos de relojoaria"
    },
    {
        value: "3250708",
        label: "Fabricação de artefatos de tecido não tecido para uso odonto-médico-hospitalar"
    },
    {
        value: "1210700",
        label: "Processamento industrial do fumo"
    },
    {
        value: "2543800",
        label: "Fabricação de ferramentas"
    },
    {
        value: "5011401",
        label: "Transporte marítimo de cabotagem - Carga"
    },
    {
        value: "4930203",
        label: "Transporte rodoviário de produtos perigosos"
    },
    {
        value: "4683400",
        label: "Comércio atacadista de defensivos agrícolas, adubos, fertilizantes e corretivos do solo"
    },
    {
        value: "4922101",
        label: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal, exceto em região metropolitana"
    },
    {
        value: "9311500",
        label: "Gestão de instalações de esportes"
    },
    {
        value: "0139301",
        label: "Cultivo de chá-da-índia"
    },
    {
        value: "6461100",
        label: "Holdings de instituições financeiras"
    },
    {
        value: "4329199",
        label: "Outras obras de instalações em construções não especificadas anteriormente"
    },
    {
        value: "1412601",
        label: "Confecção de peças do vestuário, exceto roupas íntimas e as confeccionadas sob medida"
    },
    {
        value: "8299702",
        label: "Emissão de vales-alimentação, vales-transporte e similares"
    },
    {
        value: "7410299",
        label: "Atividades de desing não especificadas anteriormente"
    },
    {
        value: "0600001",
        label: "Extração de petróleo e gás natural"
    },
    {
        value: "8630504",
        label: "Atividade odontológica"
    },
    {
        value: "4762800",
        label: "Comércio varejista de discos, CDs, DVDs e fitas"
    },
    {
        value: "3314720",
        label: "Manutenção e reparação de máquinas e equipamentos para a indústria têxtil, do vestuário, do couro e calçados"
    },
    {
        value: "1710900",
        label: "Fabricação de celulose e outras pastas para a fabricação de papel"
    },
    {
        value: "6619301",
        label: "Serviços de liquidação e custódia"
    },
    {
        value: "4511105",
        label: "Comércio por atacado de reboques e semireboques novos e usados"
    },
    {
        value: "3530100",
        label: "Produção e distribuição de vapor, água quente e ar condicionado"
    },
    {
        value: "2949299",
        label: "Fabricação de outras peças e acessórios para veículos automotores não especificadas anteriormente"
    },
    {
        value: "3091101",
        label: "Fabricação de motocicletas"
    },
    {
        value: "8411600",
        label: "Administração pública em geral"
    },
    {
        value: "4662100",
        label: "Comércio atacadista de máquinas, equipamentos para terraplenagem, mineração e construção; partes e peças"
    },
    {
        value: "2022300",
        label: "Fabricação de intermediários para plastificantes, resinas e fibras"
    },
    {
        value: "0152103",
        label: "Criação de asininos e muares"
    },
    {
        value: "3240002",
        label: "Fabricação de mesas de bilhar, de sinuca e acessórios não associada à locação"
    },
    {
        value: "1413403",
        label: "Facção de roupas profissionais"
    },
    {
        value: "0161002",
        label: "Serviço de poda de árvores para lavouras"
    },
    {
        value: "4622200",
        label: "Comércio atacadista de soja"
    },
    {
        value: "0133407",
        label: "Cultivo de maçã"
    },
    {
        value: "2821602",
        label: "Fabricação de estufas e fornos elétricos para fins industriais, peças e acessórios"
    },
    {
        value: "3312102",
        label: "Manutenção e reparação de aparelhos e instrumentos de medida, teste e controle"
    },
    {
        value: "2319200",
        label: "Fabricação de artigos de vidro"
    },
    {
        value: "3316301",
        label: "Manutenção e reparação de aeronaves, exceto a manutenção na pista"
    },
    {
        value: "6203100",
        label: "Desenvolvimento e licenciamento de programas de computador não customizáveis"
    },
    {
        value: "5239700",
        label: "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente"
    },
    {
        value: "4643502",
        label: "Comércio atacadista de bolsas, malas e artigos de viagem"
    },
    {
        value: "2824101",
        label: "Fabricação de aparelhos e equipamentos de ar condicionado para uso industrial"
    },
    {
        value: "9493600",
        label: "Atividades de organizações associativas ligadas à cultura e à arte"
    },
    {
        value: "4616800",
        label: "Representantes comerciais e agentes do comércio de têxteis, vestuário, calçados e artigos de viagem"
    },
    {
        value: "2512800",
        label: "Fabricação de esquadrias de metal"
    },
    {
        value: "6920601",
        label: "Atividades de contabilidade"
    },
    {
        value: "4541205",
        label: "Comércio a varejo de peças e acessórios para motocicletas e motonetas"
    },
    {
        value: "7739001",
        label: "Aluguel de máquinas e equipamentos para extração de minérios e petróleo, sem operador"
    },
    {
        value: "0721902",
        label: "Beneficiamento de minério de alumínio"
    },
    {
        value: "6110899",
        label: "Serviços de telecomunicações por fio não especificados anteriormente"
    },
    {
        value: "9002701",
        label: "Atividades de artistas plásticos, jornalistas independentes e\nescritores"
    },
    {
        value: "5239701",
        label: "Serviços de praticagem"
    },
    {
        value: "4664800",
        label: "Comércio atacadista de máquinas, aparelhos e equipamentos para uso odonto-médico-hospitalar; partes e peças"
    },
    {
        value: "4649401",
        label: "Comércio atacadista de equipamentos elétricos de uso pessoal e doméstico"
    },
    {
        value: "4330499",
        label: "Outras obras de acabamento da construção"
    },
    {
        value: "4618499",
        label: "Outros representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente"
    },
    {
        value: "5620104",
        label: "Fornecimento de alimentos preparados preponderantemente para consumo domiciliar"
    },
    {
        value: "5239799",
        label: "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente"
    },
    {
        value: "4759801",
        label: "Comércio varejista de artigos de tapeçaria, cortinas e persianas"
    },
    {
        value: "5310502",
        label: "Atividades de franqueadas e permissionárias do Correio Nacional"
    },
    {
        value: "4642701",
        label: "Comércio atacadista de artigos do vestuário e acessórios, exceto profissionais e de segurança"
    },
    {
        value: "7990200",
        label: "Serviços de reservas e outros serviços de turismo não especificados anteriormente"
    },
    {
        value: "6912500",
        label: "Cartórios"
    },
    {
        value: "4789009",
        label: "Comércio varejista de armas e munições"
    },
    {
        value: "8129000",
        label: "Atividades de limpeza não especificadas anteriormente"
    },
    {
        value: "9412000",
        label: "Atividades de organizações associativas profissionais"
    },
    {
        value: "4520006",
        label: "Serviços de borracharia para veículos automotores"
    },
    {
        value: "9609203",
        label: "Alojamento, higiene e embelezamento de animais"
    },
    {
        value: "6810203",
        label: "Loteamento de imóveis próprios"
    },
    {
        value: "3102100",
        label: "Fabricação de móveis com predominância de metal"
    },
    {
        value: "3250702",
        label: "Fabricação de mobiliário para uso médico, cirúrgico, odontológico e de laboratório"
    },
    {
        value: "4330405",
        label: "Aplicação de revestimentos e de resinas em interiores e exteriores"
    },
    {
        value: "9603304",
        label: "Serviços de funerárias"
    },
    {
        value: "1012102",
        label: "Abate de pequenos animais"
    },
    {
        value: "2862300",
        label: "Fabricação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo, peças e acessórios"
    },
    {
        value: "2349499",
        label: "Fabricação de produtos cerâmicos não refratários não especificados anteriormente"
    },
    {
        value: "4222701",
        label: "Construção de redes de abastecimento de água, coleta de esgoto e construções correlatas, exceto obras de irrigação"
    },
    {
        value: "7490101",
        label: "Serviços de tradução, interpretação e similares"
    },
    {
        value: "4755502",
        label: "Comercio varejista de artigos de armarinho"
    },
    {
        value: "4541204",
        label: "Comércio a varejo de motocicletas e motonetas usadas"
    },
    {
        value: "1051100",
        label: "Preparação do leite"
    },
    {
        value: "0810099",
        label: "Extração e britamento de pedras e outros materiais para construção e beneficiamento associado"
    },
    {
        value: "0133402",
        label: "Cultivo de banana"
    },
    {
        value: "0119909",
        label: "Cultivo de tomate rasteiro"
    },
    {
        value: "3511500",
        label: "Geração de energia elétrica"
    },
    {
        value: "6433600",
        label: "Bancos de desenvolvimento"
    },
    {
        value: "9601703",
        label: "Toalheiros"
    },
    {
        value: "0162899",
        label: "Atividades de apoio à pecuária não especificadas anteriormente"
    },
    {
        value: "2680900",
        label: "Fabricação de mídias virgens, magnéticas e ópticas"
    },
    {
        value: "5510803",
        label: "Motéis"
    },
    {
        value: "4684299",
        label: "Comércio atacadista de outros produtos químicos e petroquímicos não especificados anteriormente"
    },
    {
        value: "7319002",
        label: "Promoção de vendas"
    },
    {
        value: "4635402",
        label: "Comércio atacadista de cerveja, chope e refrigerante"
    },
    {
        value: "5231101",
        label: "Administração da infraestrutura portuária"
    },
    {
        value: "7732202",
        label: "Aluguel de andaimes"
    },
    {
        value: "4744003",
        label: "Comércio varejista de materiais hidráulicos"
    },
    {
        value: "2710403",
        label: "Fabricação de motores elétricos, peças e acessórios"
    },
    {
        value: "0133410",
        label: "Cultivo de manga"
    },
    {
        value: "0210105",
        label: "Cultivo de espécies madeireiras, exceto eucalipto, acácia-negra, pinus e teca"
    },
    {
        value: "1020101",
        label: "Preservação de peixes, crustáceos e moluscos"
    },
    {
        value: "0139305",
        label: "Cultivo de dendê"
    },
    {
        value: "5221400",
        label: "Concessionárias de rodovias, pontes, túneis e serviços relacionados"
    },
    {
        value: "2542000",
        label: "Fabricação de artigos de serralheria, exceto esquadrias"
    },
    {
        value: "0161099",
        label: "Atividades de apoio à agricultura não especificadas anteriormente"
    },
    {
        value: "1033301",
        label: "Fabricação de sucos concentrados de frutas, hortaliças e legumes"
    },
    {
        value: "4652400",
        label: "Comércio atacadista de componentes eletrônicos e equipamentos de telefonia e comunicação"
    },
    {
        value: "0159804",
        label: "Criação de bicho-da-seda"
    },
    {
        value: "8531700",
        label: "Educação superior - graduação"
    },
    {
        value: "4634603",
        label: "Comércio atacadista de pescados e frutos do mar"
    },
    {
        value: "2439300",
        label: "Produção de outros tubos de ferro e aço"
    },
    {
        value: "5320201",
        label: "Serviços de malote não realizados pelo Correio Nacional"
    },
    {
        value: "8299799",
        label: "Outras atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
    },
    {
        value: "3313999",
        label: "Manutenção e reparação de máquinas, aparelhos e materiais elétricos não especificados anteriormente"
    },
    {
        value: "2833000",
        label: "Fabricação de máquinas e equipamentos para a agricultura e pecuária, peças e acessórios, exceto para irrigação"
    },
    {
        value: "8299703",
        label: "Serviços de gravação de carimbos, exceto confecção"
    },
    {
        value: "8720401",
        label: "Atividades de centros de assistência psicossocial"
    },
    {
        value: "4618402",
        label: "Representantes comerciais e agentes do comércio de instrumentos e materiais odonto-médico-hospitalares"
    },
    {
        value: "4299501",
        label: "Construção de instalações esportivas e recreativas"
    },
    {
        value: "0810005",
        label: "Extração de gesso e caulim"
    },
    {
        value: "6462000",
        label: "Holdings de instituições não financeiras"
    },
    {
        value: "4649406",
        label: "Comércio atacadista de lustres, luminárias e abajures"
    },
    {
        value: "4722902",
        label: "Peixaria"
    },
    {
        value: "5250805",
        label: "Operador de transporte multimodal - OTM"
    },
    {
        value: "4621400",
        label: "Comércio atacadista de café em grão"
    },
    {
        value: "4789003",
        label: "Comércio varejista de objetos de arte"
    },
    {
        value: "4763605",
        label: "Comércio varejista de embarcações e outros veículos recreativos; peças e acessórios"
    },
    {
        value: "3314721",
        label: "Manutenção e reparação de máquinas e aparelhos para a indústria de celulose, papel e papelão e artefatos"
    },
    {
        value: "3011301",
        label: "Construção de embarcações de grande porte"
    },
    {
        value: "4520004",
        label: "Serviços de alinhamento e balanceamento de veículos automotores"
    },
    {
        value: "4211101",
        label: "Construção de rodovias e ferrovias"
    },
    {
        value: "4789007",
        label: "Comércio varejista de equipamentos para escritório"
    },
    {
        value: "2392300",
        label: "Fabricação de cal e gesso"
    },
    {
        value: "4649408",
        label: "Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar"
    },
    {
        value: "8292000",
        label: "Envasamento e empacotamento sob contrato"
    },
    {
        value: "0600003",
        label: "Extração e beneficiamento de areias betuminosas"
    },
    {
        value: "2011800",
        label: "Fabricação de cloro e álcalis"
    },
    {
        value: "8599601",
        label: "Formação de condutores"
    },
    {
        value: "4713003",
        label: "Lojas duty free de aeroportos internacionais"
    },
    {
        value: "4646001",
        label: "Comércio atacadista de cosméticos e produtos de perfumaria"
    },
    {
        value: "1749400",
        label: "Fabricação de produtos de pastas celulósicas, papel, cartolina, papel-cartão e papelão ondulado não especificados anteriormente"
    },
    {
        value: "1610202",
        label: "Serrarias sem desdobramento de madeira"
    },
    {
        value: "0210101",
        label: "Cultivo de eucalipto"
    },
    {
        value: "4669999",
        label: "Comércio atacadista de outras máquinas e equipamentos não especificados anteriormente; partes e peças"
    },
    {
        value: "9529102",
        label: "Chaveiros"
    },
    {
        value: "3520402",
        label: "Distribuição de combustíveis gasosos por redes urbanas"
    },
    {
        value: "1921700",
        label: "Fabricação de produtos do refino de petróleo"
    },
    {
        value: "6437900",
        label: "Sociedades de crédito ao microempreendedor"
    },
    {
        value: "0161003",
        label: "Serviço de preparação de terreno, cultivo e colheita"
    },
    {
        value: "0119906",
        label: "Cultivo de mandioca"
    },
    {
        value: "7410202",
        label: "Design de interiores"
    },
    {
        value: "3092000",
        label: "Fabricação de bicicletas e triciclos não motorizados, peças e acessórios"
    },
    {
        value: "1510600",
        label: "Curtimento e outras preparações de couro"
    },
    {
        value: "4681802",
        label: "Comércio atacadista de combustíveis realizado por transportador retalhista (TRR)"
    },
    {
        value: "0119903",
        label: "Cultivo de batata-inglesa"
    },
    {
        value: "2222600",
        label: "Fabricação de embalagens de material plástico"
    },
    {
        value: "8730199",
        label: "Atividades de assistência social prestadas em residências coletivas e particulares não especificadas anteriormente"
    },
    {
        value: "2814302",
        label: "Fabricação de compressores para uso não industrial, peças e acessórios"
    },
    {
        value: "2033900",
        label: "Fabricação de elastômeros"
    },
    {
        value: "4634699",
        label: "Comércio atacadista de carnes e derivados de outros animais"
    },
    {
        value: "2751100",
        label: "Fabricação de fogões, refrigeradores e máquinas de lavar e secar para uso doméstico, peças e acessórios"
    },
    {
        value: "0321301",
        label: "Criação de peixes em água salgada e salobra"
    },
    {
        value: "1622602",
        label: "Fabricação de esquadrias de madeira e de peças de madeira para instalações industriais e comerciais"
    },
    {
        value: "4685100",
        label: "Comércio atacadista de produtos siderúrgicos e metalúrgicos, exceto para construção"
    },
    {
        value: "8640208",
        label: "Serviços de diagnóstico por registro gráfico - ECG, EEG e outros exames análogos"
    },
    {
        value: "5022001",
        label: "Transporte por navegação interior de passageiros em linhas regulares, municipal, exceto travessia"
    },
    {
        value: "1533500",
        label: "Fabricação de calçados de material sintético"
    },
    {
        value: "4682600",
        label: "Comércio atacadista de gás liquefeito de petróleo (GLP)"
    },
    {
        value: "0119905",
        label: "Cultivo de feijão"
    },
    {
        value: "4789099",
        label: "Comércio varejista de outros produtos não especificados anteriormente"
    },
    {
        value: "0810006",
        label: "Extração de areia, cascalho ou pedregulho e beneficiamento associado"
    },
    {
        value: "4679604",
        label: "Comércio atacadista especializado de materiais de construção não especificados anteriormente"
    },
    {
        value: "1220403",
        label: "Fabricação de filtros para cigarros"
    },
    {
        value: "1111902",
        label: "Fabricação de outras aguardentes e bebidas destiladas"
    },
    {
        value: "1414200",
        label: "Fabricação de acessórios do vestuário, exceto para segurança e proteção"
    },
    {
        value: "1093702",
        label: "Fabricação de frutas cristalizadas, balas e semelhantes"
    },
    {
        value: "0899103",
        label: "Extração de amianto"
    },
    {
        value: "2920402",
        label: "Fabricação de motores para caminhões e ônibus"
    },
    {
        value: "6434400",
        label: "Agências de fomento"
    },
    {
        value: "0230600",
        label: "Atividades de apoio à produção florestal"
    },
    {
        value: "2593400",
        label: "Fabricação de artigos de metal para uso doméstico e pessoal"
    },
    {
        value: "2391503",
        label: "Aparelhamento de placas e execução de trabalhos em mármore, granito, ardósia e outras pedras"
    },
    {
        value: "1011202",
        label: "Frigorífico - abate de equinos"
    },
    {
        value: "4663000",
        label: "Comércio atacadista de máquinas e equipamentos para uso industrial; partes e peças"
    },
    {
        value: "4221902",
        label: "Construção de estações e redes de distribuição de energia elétrica"
    },
    {
        value: "4751200",
        label: "Comércio varejista especializado de equipamentos e suprimentos de informática"
    },
    {
        value: "2123800",
        label: "Fabricação de preparações farmacêuticas"
    },
    {
        value: "1099606",
        label: "Fabricação de adoçantes naturais e artificiais"
    },
    {
        value: "0151202",
        label: "Criação de bovinos para leite"
    },
    {
        value: "0810009",
        label: "Extração de basalto e beneficiamento associado"
    },
    {
        value: "4789008",
        label: "Comércio varejista de artigos fotográficos e para filmagem"
    },
    {
        value: "0312404",
        label: "Atividades de apoio à pesca em água doce"
    },
    {
        value: "6499903",
        label: "Fundo garantidor de crédito"
    },
    {
        value: "2829101",
        label: "Fabricação de máquinas de escrever, calcular e outros equipamentos não eletrônicos para escritório, peças e acessórios"
    },
    {
        value: "0152101",
        label: "Criação de bufalinos"
    },
    {
        value: "4679601",
        label: "Comércio atacadista de tintas, vernizes e similares"
    },
    {
        value: "5812302",
        label: "Edição de jornais não diários"
    },
    {
        value: "3104700",
        label: "Fabricação de colchões"
    },
    {
        value: "8511200",
        label: "Educação infantil - creche"
    },
    {
        value: "1099605",
        label: "Fabricação de produtos para infusão (chá, mate, etc.)"
    },
    {
        value: "0892403",
        label: "Refino e outros tratamentos do sal"
    },
    {
        value: "8599605",
        label: "Cursos preparatórios para concursos"
    },
    {
        value: "2853400",
        label: "Fabricação de tratores, peças e acessórios, exceto agrícolas"
    },
    {
        value: "8599699",
        label: "Outras atividades de ensino não especificadas anteriormente"
    },
    {
        value: "4637104",
        label: "Comércio atacadista de pães, bolos, biscoitos e similares"
    },
    {
        value: "4774100",
        label: "Comércio varejista de artigos de óptica"
    },
    {
        value: "3314704",
        label: "Manutenção e reparação de compressores"
    },
    {
        value: "0111302",
        label: "Cultivo de milho"
    },
    {
        value: "0725100",
        label: "Extração de minerais radioativos"
    },
    {
        value: "1099699",
        label: "Fabricação de outros produtos alimentícios não especificados anteriormente"
    },
    {
        value: "0119907",
        label: "Cultivo de melão"
    },
    {
        value: "5912099",
        label: "Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente"
    },
    {
        value: "4634602",
        label: "Comércio atacadista de aves abatidas e derivados"
    },
    {
        value: "4619200",
        label: "Representantes comerciais e agentes do comércio de mercadorias em geral não especializado"
    },
    {
        value: "4512902",
        label: "Comércio sob consignação de veículos automotores"
    },
    {
        value: "1354500",
        label: "Fabricação de tecidos especiais, inclusive artefatos"
    },
    {
        value: "4783101",
        label: "Comércio varejista de artigos de joalheria"
    },
    {
        value: "8711501",
        label: "Clínicas e residências geriátricas"
    },
    {
        value: "0119908",
        label: "Cultivo de melancia"
    },
    {
        value: "8720499",
        label: "Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência mental e dependência química e grupos similares não especificadas anteriormente"
    },
    {
        value: "9200399",
        label: "Exploração de jogos de azar e apostas não especificados anteriormente"
    },
    {
        value: "4911600",
        label: "Transporte ferroviário de carga"
    },
    {
        value: "1413402",
        label: "Confecção, sob medida, de roupas profissionais"
    },
    {
        value: "0810002",
        label: "Extração de granito e beneficiamento associado"
    },
    {
        value: "0134200",
        label: "Cultivo de café"
    },
    {
        value: "5211799",
        label: "Depósitos de mercadorias para terceiros, exceto armazéns gerais e guarda-móveis"
    },
    {
        value: "1313800",
        label: "Fiação de fibras artificiais e sintéticas"
    },
    {
        value: "4222702",
        label: "Obras de irrigação"
    },
    {
        value: "6822600",
        label: "Gestão e administração da propriedade imobiliária"
    },
    {
        value: "4781400",
        label: "Comércio varejista de artigos do vestuário e acessórios"
    },
    {
        value: "0139302",
        label: "Cultivo de erva-mate"
    },
    {
        value: "4673700",
        label: "Comércio atacadista de material elétrico"
    },
    {
        value: "2910702",
        label: "Fabricação de chassis com motor para automóveis, camionetas e utilitários"
    },
    {
        value: "1359600",
        label: "Fabricação de outros produtos têxteis não especificados anteriormente"
    },
    {
        value: "2229303",
        label: "Fabricação de artefatos de material plástico para uso na construção, exceto tubos e acessórios"
    },
    {
        value: "0311601",
        label: "Pesca de peixes em água salgada"
    },
    {
        value: "9900800",
        label: "Organismos internacionais e outras instituições extraterritoriais"
    },
    {
        value: "1822900",
        label: "Serviços de acabamentos gráficos"
    },
    {
        value: "3315500",
        label: "Manutenção e reparação de veículos ferroviários"
    },
    {
        value: "1065102",
        label: "Fabricação de óleo de milho em bruto"
    },
    {
        value: "9319199",
        label: "Outras atividades esportivas não especificadas anteriormente"
    },
    {
        value: "1032599",
        label: "Fabricação de conservas de legumes e outros vegetais, exceto palmito"
    },
    {
        value: "2092402",
        label: "Fabricação de artigos pirotécnicos"
    },
    {
        value: "5590603",
        label: "Pensões (alojamento)"
    },
    {
        value: "3317102",
        label: "Manutenção e reparação de embarcações para esporte e lazer"
    },
    {
        value: "2550101",
        label: "Fabricação de equipamento bélico pesado, exceto veículos militares de combate"
    },
    {
        value: "9603301",
        label: "Gestão e manutenção de cemitérios"
    },
    {
        value: "7719599",
        label: "Locação de outros meios de transporte não especificados anteriormente, sem condutor"
    },
    {
        value: "4623105",
        label: "Comércio atacadista de cacau"
    },
    {
        value: "2840200",
        label: "Fabricação de máquinas-ferramenta, peças e acessórios"
    },
    {
        value: "4713001",
        label: "Lojas de departamentos ou magazines"
    },
    {
        value: "3702900",
        label: "Atividades relacionadas a esgoto, exceto a gestão de redes"
    },
    {
        value: "2451200",
        label: "Fundição de ferro e aço"
    },
    {
        value: "1031700",
        label: "Fabricação de conservas de frutas"
    },
    {
        value: "4784900",
        label: "Comércio varejista de gás liqüefeito de petróleo (GLP)"
    },
    {
        value: "4511104",
        label: "Comércio por atacado de caminhões novos e usados"
    },
    {
        value: "4292801",
        label: "Montagem de estruturas metálicas"
    },
    {
        value: "2869100",
        label: "Fabricação de máquinas e equipamentos para uso industrial específico não especificados anteriormente, peças e acessórios"
    },
    {
        value: "1041400",
        label: "Fabricação de óleos vegetais em bruto, exceto óleo de milho"
    },
    {
        value: "0500301",
        label: "Extração de carvão mineral"
    },
    {
        value: "8630507",
        label: "Atividades de reprodução humana assistida"
    },
    {
        value: "0121101",
        label: "Horticultura, exceto morango"
    },
    {
        value: "2422901",
        label: "Produção de laminados planos de aço ao carbono, revestidos ou não"
    },
    {
        value: "6619305",
        label: "Operadoras de cartões de débito"
    },
    {
        value: "4785799",
        label: "Comércio varejista de outros artigos usados"
    },
    {
        value: "3314707",
        label: "Manutenção e reparação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial"
    },
    {
        value: "8592901",
        label: "Ensino de dança"
    },
    {
        value: "9529105",
        label: "Reparação de artigos do mobiliário"
    },
    {
        value: "2945000",
        label: "Fabricação de material elétrico e eletrônico para veículos automotores, exceto baterias"
    },
    {
        value: "7729202",
        label: "Aluguel de móveis, utensílios e aparelhos de uso doméstico e pessoal; instrumentos musicais"
    },
    {
        value: "2949201",
        label: "Fabricação de bancos e estofados para veículos automotores"
    },
    {
        value: "6911703",
        label: "Agente de propriedade industrial"
    },
    {
        value: "4618401",
        label: "Representantes comerciais e agentes do comércio de medicamentos, cosméticos e produtos de perfumaria"
    },
    {
        value: "2019301",
        label: "Elaboração de combustíveis nucleares"
    },
    {
        value: "1220402",
        label: "Fabricação de cigarrilhas e charutos"
    },
    {
        value: "1412602",
        label: "Confecção, sob medida, de peças do vestuário, exceto roupas íntimas"
    },
    {
        value: "9329802",
        label: "Exploração de boliches"
    },
    {
        value: "9609206",
        label: "Serviços de tatuagem e colocação de piercing"
    },
    {
        value: "9602501",
        label: "Cabeleireiros, manicure e pedicure"
    },
    {
        value: "2040100",
        label: "Fabricação de fibras artificiais e sintéticas"
    },
    {
        value: "6201500",
        label: "Desenvolvimento de programas de computador sob encomenda"
    },
    {
        value: "4744001",
        label: "Comércio varejista de ferragens e ferramentas"
    },
    {
        value: "2229301",
        label: "Fabricação de artefatos de material plástico para uso pessoal e doméstico"
    },
    {
        value: "4782201",
        label: "Comércio varejista de calçados"
    },
    {
        value: "3812200",
        label: "Coleta de resíduos perigosos"
    },
    {
        value: "9603303",
        label: "Serviços de sepultamento"
    },
    {
        value: "0729404",
        label: "Extração de minérios de cobre, chumbo, zinco e outros minerais metálicos não ferrosos não especificados anteriormente"
    },
    {
        value: "8111700",
        label: "Serviços combinados para apoio a edifícios, exceto condomínios prediais"
    },
    {
        value: "7719502",
        label: "Locação de aeronaves sem tripulação"
    },
    {
        value: "4721104",
        label: "Comércio varejista de doces, balas, bombons e semelhantes"
    },
    {
        value: "6491300",
        label: "Sociedades de fomento mercantil - factoring"
    },
    {
        value: "8650003",
        label: "Atividades de psicologia e psicanálise"
    },
    {
        value: "4635499",
        label: "Comércio atacadista de bebidas não especificadas anteriormente"
    },
    {
        value: "4634601",
        label: "Comércio atacadista de carnes bovinas e suínas e derivados"
    },
    {
        value: "0210103",
        label: "Cultivo de pinus"
    },
    {
        value: "9412001",
        label: "Atividades de fiscalização profissional"
    },
    {
        value: "2825900",
        label: "Fabricação de máquinas e equipamentos para saneamento básico e ambiental, peças e acessórios"
    },
    {
        value: "4930204",
        label: "Transporte rodoviário de mudanças"
    },
    {
        value: "4512901",
        label: "Representantes comerciais e agentes do comércio de veículos automotores"
    },
    {
        value: "7410201",
        label: "Design"
    },
    {
        value: "4921301",
        label: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, municipal"
    },
    {
        value: "1322700",
        label: "Tecelagem de fios de fibras têxteis naturais, exceto algodão"
    },
    {
        value: "3319800",
        label: "Manutenção e reparação de equipamentos e produtos não especificados anteriormente"
    },
    {
        value: "2449102",
        label: "Produção de laminados de zinco"
    },
    {
        value: "0220906",
        label: "Conservação de florestas nativas"
    },
    {
        value: "2822402",
        label: "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas, peças e acessórios"
    },
    {
        value: "1830002",
        label: "Reprodução de vídeo em qualquer suporte"
    },
    {
        value: "2342702",
        label: "Fabricação de artefatos de cerâmica e barro cozido para uso na construção, exceto azulejos e pisos"
    },
    {
        value: "9001906",
        label: "Atividades de sonorização e de iluminação"
    },
    {
        value: "4912401",
        label: "Transporte ferroviário de passageiros intermunicipal e interestadual"
    },
    {
        value: "1043100",
        label: "Fabricação de margarina e outras gorduras vegetais e de óleos não comestíveis de animais"
    },
    {
        value: "6421200",
        label: "Bancos comerciais"
    },
    {
        value: "2092403",
        label: "Fabricação de fósforos de segurança"
    },
    {
        value: "9529104",
        label: "Reparação de bicicletas, triciclos e outros veículos não motorizados"
    },
    {
        value: "5012201",
        label: "Transporte marítimo de longo curso - Carga"
    },
    {
        value: "0990401",
        label: "Atividades de apoio à extração de minério de ferro"
    },
    {
        value: "3041500",
        label: "Fabricação de aeronaves"
    },
    {
        value: "8690901",
        label: "Atividades de práticas integrativas e complementares em saúde humana"
    },
    {
        value: "2610800",
        label: "Fabricação de componentes eletrônicos"
    },
    {
        value: "4773300",
        label: "Comércio varejista de artigos médicos e ortopédicos"
    },
    {
        value: "3230200",
        label: "Fabricação de artefatos para pesca e esporte"
    },
    {
        value: "3032600",
        label: "Fabricação de peças e acessórios para veículos ferroviários"
    },
    {
        value: "6399200",
        label: "Outras atividades de prestação de serviços de informação não especificadas anteriormente"
    },
    {
        value: "4681803",
        label: "Comércio atacadista de combustíveis de origem vegetal, exceto álcool carburante"
    },
    {
        value: "2710402",
        label: "Fabricação de transformadores, indutores, conversores, sincronizadores e semelhantes, peças e acessórios"
    },
    {
        value: "5911101",
        label: "Estúdios cinematográficos"
    },
    {
        value: "4661300",
        label: "Comércio atacadista de máquinas, aparelhos e equipamentos para uso agropecuário; partes e peças"
    },
    {
        value: "4722901",
        label: "Comércio varejista de carnes - açougues"
    },
    {
        value: "3314715",
        label: "Manutenção e reparação de máquinas e equipamentos para uso na extração mineral, exceto na extração de petróleo"
    },
    {
        value: "2014200",
        label: "Fabricação de gases industriais"
    },
    {
        value: "0115600",
        label: "Cultivo de soja"
    },
    {
        value: "9001999",
        label: "Artes cênicas, espetáculos e atividades complementares não especificados anteriormente"
    },
    {
        value: "4530703",
        label: "Comércio a varejo de peças e acessórios novos para veículos automotores"
    },
    {
        value: "6110801",
        label: "Serviços de telefonia fixa comutada - STFC"
    },
    {
        value: "4645103",
        label: "Comércio atacadista de produtos odontológicos"
    },
    {
        value: "4729699",
        label: "Comércio varejista de produtos alimentícios em geral ou especializado em produtos alimentícios não especificados anteriormente"
    },
    {
        value: "4530704",
        label: "Comércio a varejo de peças e acessórios usados para veículos automotores"
    },
    {
        value: "9312300",
        label: "Clubes sociais, esportivos e similares"
    },
    {
        value: "5099899",
        label: "Outros transportes aquaviários não especificados anteriormente"
    },
    {
        value: "8630503",
        label: "Atividade médica ambulatorial restrita a consultas"
    },
    {
        value: "4643501",
        label: "Comércio atacadista de calçados"
    },
    {
        value: "8299704",
        label: "Leiloeiros independentes"
    },
    {
        value: "3821100",
        label: "Tratamento e disposição de resíduos não perigosos"
    },
    {
        value: "8640213",
        label: "Serviços de litotripsia"
    },
    {
        value: "2829199",
        label: "Fabricação de outras máquinas e equipamentos de uso geral não especificados anteriormente, peças e acessórios"
    },
    {
        value: "4637107",
        label: "Comércio atacadista de chocolates, confeitos, balas, bombons e semelhantes"
    },
    {
        value: "6424702",
        label: "Cooperativas centrais de crédito"
    },
    {
        value: "2812700",
        label: "Fabricação de equipamentos hidráulicos e pneumáticos, peças e acessórios, exceto válvulas"
    },
    {
        value: "3314711",
        label: "Manutenção e reparação de máquinas e equipamentos para agricultura e pecuária"
    },
    {
        value: "1811302",
        label: "Impressão de livros, revistas e outras publicações periódicas"
    },
    {
        value: "4755501",
        label: "Comércio varejista de tecidos"
    },
    {
        value: "7312200",
        label: "Agenciamento de espaços para publicidade, exceto em veículos de comunicação"
    },
    {
        value: "2422902",
        label: "Produção de laminados planos de aços especiais"
    },
    {
        value: "9603305",
        label: "Serviços de somatoconservação"
    },
    {
        value: "4691500",
        label: "Comércio atacadista de mercadorias em geral, com predominância de produtos alimentícios"
    },
    {
        value: "4623104",
        label: "Comércio atacadista de fumo em folha não beneficiado"
    },
    {
        value: "0322104",
        label: "Criação de peixes ornamentais em água doce"
    },
    {
        value: "0321305",
        label: "Atividades de apoio à aquicultura em água salgada e salobra"
    },
    {
        value: "7739099",
        label: "Aluguel de outras máquinas e equipamentos comerciais e industriais não especificados anteriormente, sem operador"
    },
    {
        value: "5111100",
        label: "Transporte aéreo de passageiros regular"
    },
    {
        value: "0210108",
        label: "Produção de carvão vegetal - florestas plantadas"
    },
    {
        value: "6621501",
        label: "Peritos e avaliadores de seguros"
    },
    {
        value: "6621502",
        label: "Auditoria e consultoria atuarial"
    },
    {
        value: "6202300",
        label: "Desenvolvimento e licenciamento de programas de computador customizáveis"
    },
    {
        value: "0910600",
        label: "Atividades de apoio à extração de petróleo e gás natural"
    },
    {
        value: "4743100",
        label: "Comércio varejista de vidros"
    },
    {
        value: "2851800",
        label: "Fabricação de máquinas e equipamentos para a prospecção e extração de petróleo, peças e acessórios"
    },
    {
        value: "5112901",
        label: "Serviço de táxi aéreo e locação de aeronaves com tripulação"
    },
    {
        value: "2822401",
        label: "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de pessoas, peças e acessórios"
    },
    {
        value: "9001901",
        label: "Produção teatral"
    },
    {
        value: "2423702",
        label: "Produção de laminados longos de aço, exceto tubos"
    },
    {
        value: "8599602",
        label: "Cursos de pilotagem"
    },
    {
        value: "3314709",
        label: "Manutenção e reparação de máquinas de escrever, calcular e de outros equipamentos não eletrônicos para escritório"
    },
    {
        value: "2441501",
        label: "Produção de alumínio e suas ligas em formas primárias"
    },
    {
        value: "0321303",
        label: "Criação de ostras e mexilhões em água salgada e salobra"
    },
    {
        value: "4732600",
        label: "Comércio varejista de lubrificantes"
    },
    {
        value: "1622699",
        label: "Fabricação de outros artigos de carpintaria para construção"
    },
    {
        value: "6424701",
        label: "Bancos cooperativos"
    },
    {
        value: "1813001",
        label: "Impressão de material para uso publicitário"
    },
    {
        value: "5021101",
        label: "Transporte por navegação interior de carga, municipal, exceto travessia"
    },
    {
        value: "9001903",
        label: "Produção de espetáculos de dança"
    },
    {
        value: "7912100",
        label: "Operadores turísticos"
    },
    {
        value: "0152102",
        label: "Criação de equinos"
    },
    {
        value: "6440900",
        label: "Arrendamento mercantil"
    },
    {
        value: "5310501",
        label: "Atividades do Correio Nacional"
    },
    {
        value: "1092900",
        label: "Fabricação de biscoitos e bolachas"
    },
    {
        value: "6391700",
        label: "Agências de notícias"
    },
    {
        value: "1081302",
        label: "Torrefação e moagem de café"
    },
    {
        value: "0810007",
        label: "Extração de argila e beneficiamento associado"
    },
    {
        value: "8550301",
        label: "Administração de caixas escolares"
    },
    {
        value: "1072402",
        label: "Fabricação de açúcar de cereais (dextrose) e de beterraba"
    },
    {
        value: "2012600",
        label: "Fabricação de intermediários para fertilizantes"
    },
    {
        value: "0119902",
        label: "Cultivo de alho"
    },
    {
        value: "4211102",
        label: "Pintura para sinalização em pistas rodoviárias e aeroportos"
    },
    {
        value: "1623400",
        label: "Fabricação de artefatos de tanoaria e de embalagens de madeira"
    },
    {
        value: "0899101",
        label: "Extração de grafita"
    },
    {
        value: "0722701",
        label: "Extração de minério de estanho"
    },
    {
        value: "4651602",
        label: "Comércio atacadista de suprimentos para informática"
    },
    {
        value: "0132600",
        label: "Cultivo de uva"
    },
    {
        value: "4541201",
        label: "Comércio por atacado de motocicletas e motonetas"
    },
    {
        value: "4929904",
        label: "Organização de excursões em veículos rodoviários próprios, intermunicipal, interestadual e internacional"
    },
    {
        value: "4751201",
        label: "Comércio varejista especializado de equipamentos e suprimentos de informática"
    },
    {
        value: "8640206",
        label: "Serviços de ressonância magnética"
    },
    {
        value: "2823200",
        label: "Fabricação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial, peças e acessórios"
    },
    {
        value: "6435203",
        label: "Companhias hipotecárias"
    },
    {
        value: "3240099",
        label: "Fabricação de outros brinquedos e jogos recreativos não especificados anteriormente"
    },
    {
        value: "6423900",
        label: "Caixas econômicas"
    },
    {
        value: "5120000",
        label: "Transporte aéreo de carga"
    },
    {
        value: "9609201",
        label: "Clínicas de estética e similares"
    },
    {
        value: "8412400",
        label: "Regulação das atividades de saúde, educação, serviços culturais e outros serviços sociais"
    },
    {
        value: "4713002",
        label: "Lojas de variedades, exceto lojas de departamentos ou magazines"
    },
    {
        value: "8423000",
        label: "Justiça"
    },
    {
        value: "5021102",
        label: "Transporte por navegação interior de carga, intermunicipal, interestadual e internacional, exceto travessia"
    },
    {
        value: "4681801",
        label: "Comércio atacadista de álcool carburante, biodiesel, gasolina e demais derivados de petróleo, exceto lubrificantes, não realizado por transportador retalhista (TRR)"
    },
    {
        value: "0810010",
        label: "Beneficiamento de gesso e caulim associado à extração"
    },
    {
        value: "7490102",
        label: "Escafandria e mergulho"
    },
    {
        value: "8211300",
        label: "Serviços combinados de escritório e apoio administrativo"
    },
    {
        value: "0119999",
        label: "Cultivo de outras plantas de lavoura temporária não especificadas anteriormente"
    },
    {
        value: "5813100",
        label: "Edição de revistas"
    },
    {
        value: "0139306",
        label: "Cultivo de seringueira"
    },
    {
        value: "0151203",
        label: "Criação de bovinos, exceto para corte e leite"
    },
    {
        value: "4391600",
        label: "Obras de fundações"
    },
    {
        value: "8299701",
        label: "Medição de consumo de energia elétrica, gás e água"
    },
    {
        value: "4637102",
        label: "Comércio atacadista de açúcar"
    },
    {
        value: "8640201",
        label: "Laboratórios de anatomia patológica e citológica"
    },
    {
        value: "8640207",
        label: "Serviços de diagnóstico por imagem sem uso de radiação ionizante, exceto ressonância magnética"
    },
    {
        value: "3299003",
        label: "Fabricação de letras, letreiros e placas de qualquer material, exceto luminosos"
    },
    {
        value: "2920401",
        label: "Fabricação de caminhões e ônibus"
    },
    {
        value: "0139304",
        label: "Cultivo de plantas para condimento, exceto pimenta-do-reino"
    },
    {
        value: "2539000",
        label: "Serviços de usinagem, solda, tratamento e revestimento em metais"
    },
    {
        value: "2221800",
        label: "Fabricação de laminados planos e tubulares de material plástico"
    },
    {
        value: "4689301",
        label: "Comércio atacadista de produtos da extração mineral, exceto combustíveis"
    },
    {
        value: "1732000",
        label: "Fabricação de embalagens de cartolina e papel-cartão"
    },
    {
        value: "7420003",
        label: "Laboratórios fotográficos"
    },
    {
        value: "0159803",
        label: "Criação de escargô"
    },
    {
        value: "2852600",
        label: "Fabricação de outras máquinas e equipamentos para uso na extração mineral, peças e acessórios, exceto na extração de petróleo"
    },
    {
        value: "9601702",
        label: "Tinturarias"
    },
    {
        value: "9329804",
        label: "Exploração de jogos eletrônicos recreativos"
    },
    {
        value: "4721101",
        label: "Padaria e confeitaria com predominância de produção própria"
    },
    {
        value: "0122900",
        label: "Cultivo de flores e plantas ornamentais"
    },
    {
        value: "7723300",
        label: "Aluguel de objetos do vestuário, jóias e acessórios"
    },
    {
        value: "1932200",
        label: "Fabricação de biocombustíveis, exceto álcool"
    },
    {
        value: "3101200",
        label: "Fabricação de móveis com predominância de madeira"
    },
    {
        value: "4329104",
        label: "Montagem e instalação de sistemas e equipamentos de iluminação e sinalização em vias públicas, portos e aeroportos"
    },
    {
        value: "9602502",
        label: "Atividades de estética e outros serviços de cuidados com a beleza"
    },
    {
        value: "1722200",
        label: "Fabricação de cartolina e papel-cartão"
    },
    {
        value: "7210000",
        label: "Pesquisa e desenvolvimento experimental em ciências físicas e naturais"
    },
    {
        value: "1352900",
        label: "Fabricação de artefatos de tapeçaria"
    },
    {
        value: "4721103",
        label: "Comércio varejista de laticínios e frios"
    },
    {
        value: "2330305",
        label: "Preparação de massa de concreto e argamassa para construção"
    },
    {
        value: "8640204",
        label: "Serviços de tomografia"
    },
    {
        value: "0312403",
        label: "Coleta de outros produtos aquáticos de água doce"
    },
    {
        value: "8650099",
        label: "Atividades de profissionais da área de saúde não especificadas anteriormente"
    },
    {
        value: "4763601",
        label: "Comércio varejista de brinquedos e artigos recreativos"
    },
    {
        value: "2541100",
        label: "Fabricação de artigos de cutelaria"
    },
    {
        value: "4530702",
        label: "Comércio por atacado de pneumáticos e câmaras-de-ar"
    },
    {
        value: "3250706",
        label: "Serviços de prótese dentária"
    },
    {
        value: "1610205",
        label: "Serviço de tratamento de madeira realizado sob contrato"
    },
    {
        value: "1830001",
        label: "Reprodução de som em qualquer suporte"
    },
    {
        value: "0162801",
        label: "Serviço de inseminação artificial em animais"
    },
    {
        value: "3317101",
        label: "Manutenção e reparação de embarcações e estruturas flutuantes"
    },
    {
        value: "5250802",
        label: "Atividades de despachantes aduaneiros"
    },
    {
        value: "3299004",
        label: "Fabricação de painéis e letreiros luminosos"
    },
    {
        value: "4330403",
        label: "Obras de acabamento em gesso e estuque"
    },
    {
        value: "3329501",
        label: "Serviços de montagem de móveis de qualquer material"
    },
    {
        value: "6190602",
        label: "Provedores de voz sobre protocolo Internet - VOIP"
    },
    {
        value: "6209100",
        label: "Suporte técnico, manutenção e outros serviços em tecnologia da informação"
    },
    {
        value: "1610203",
        label: "Serrarias com desdobramento de madeira em bruto"
    },
    {
        value: "2539001",
        label: "Serviços de usinagem, torneiria e solda"
    },
    {
        value: "4322302",
        label: "Instalação e manutenção de sistemas centrais de ar condicionado, de ventilação e refrigeração"
    },
    {
        value: "4615000",
        label: "Representantes comerciais e agentes do comércio de eletrodomésticos, móveis e artigos de uso doméstico"
    },
    {
        value: "2813500",
        label: "Fabricação de válvulas, registros e dispositivos semelhantes, peças e acessórios"
    },
    {
        value: "4923002",
        label: "Serviço de transporte de passageiros - locação de automóveis com motorista"
    },
    {
        value: "4757100",
        label: "Comércio varejista especializado de peças e acessórios para aparelhos eletroeletrônicos para uso doméstico, exceto informática e comunicação"
    },
    {
        value: "0112102",
        label: "Cultivo de juta"
    },
    {
        value: "5030101",
        label: "Navegação de apoio marítimo"
    },
    {
        value: "6190601",
        label: "Provedores de acesso às redes de comunicações"
    },
    {
        value: "0891600",
        label: "Extração de minerais para fabricação de adubos, fertilizantes e outros produtos químicos"
    },
    {
        value: "4929901",
        label: "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, municipal"
    },
    {
        value: "4221903",
        label: "Manutenção de redes de distribuição de energia elétrica"
    },
    {
        value: "8650005",
        label: "Atividades de terapia ocupacional"
    },
    {
        value: "6499904",
        label: "Caixas de financiamento de corporações"
    },
    {
        value: "6204000",
        label: "Consultoria em tecnologia da informação"
    },
    {
        value: "3314701",
        label: "Manutenção e reparação de máquinas motrizes não elétricas"
    },
    {
        value: "0810003",
        label: "Extração de mármore e beneficiamento associado"
    },
    {
        value: "7729201",
        label: "Aluguel de aparelhos de jogos eletrônicos"
    },
    {
        value: "4632002",
        label: "Comércio atacadista de farinhas, amidos e féculas"
    },
    {
        value: "5822100",
        label: "Edição integrada à impressão de jornais"
    },
    {
        value: "8711505",
        label: "Condomínios residenciais para idosos"
    },
    {
        value: "1422300",
        label: "Fabricação de artigos do vestuário, produzidos em malharias e tricotagens, exceto meias"
    },
    {
        value: "6021700",
        label: "Atividades de televisão aberta"
    },
    {
        value: "3314718",
        label: "Manutenção e reparação de máquinas para a indústria metalúrgica, exceto máquinas-ferramenta"
    },
    {
        value: "2910701",
        label: "Fabricação de automóveis, camionetas e utilitários"
    },
    {
        value: "2670102",
        label: "Fabricação de aparelhos fotográficos e cinematográficos, peças e acessórios"
    },
    {
        value: "7729203",
        label: "Aluguel de material médico"
    },
    {
        value: "0721901",
        label: "Extração de minério de alumínio"
    },
    {
        value: "7721700",
        label: "Aluguel de equipamentos recreativos e esportivos"
    },
    {
        value: "7311400",
        label: "Agências de publicidade"
    },
    {
        value: "8219999",
        label: "Preparação de documentos e serviços especializados de apoio administrativo não especificados anteriormente"
    },
    {
        value: "6319400",
        label: "Portais, provedores de conteúdo e outros serviços de informação na Internet"
    },
    {
        value: "5130700",
        label: "Transporte espacial"
    },
    {
        value: "0133411",
        label: "Cultivo de pêssego"
    },
    {
        value: "3099700",
        label: "Fabricação de equipamentos de transporte não especificados anteriormente"
    },
    {
        value: "4543900",
        label: "Manutenção e reparação de motocicletas e motonetas"
    },
    {
        value: "2622100",
        label: "Fabricação de periféricos para equipamentos de informática"
    },
    {
        value: "4649405",
        label: "Comércio atacadista de artigos de tapeçaria; persianas e cortinas"
    },
    {
        value: "9420100",
        label: "Atividades de organizações sindicais"
    },
    {
        value: "4744004",
        label: "Comércio varejista de cal, areia, pedra britada, tijolos e telhas"
    },
    {
        value: "2421100",
        label: "Produção de semiacabados de aço"
    },
    {
        value: "8020002",
        label: "Outras atividades de serviços de segurança"
    },
    {
        value: "8020000",
        label: "Atividades de monitoramento de sistemas de segurança"
    },
    {
        value: "6629100",
        label: "Atividades auxiliares dos seguros, da previdência complementar e dos planos de saúde não especificadas anteriormente"
    },
    {
        value: "5620102",
        label: "Serviços de alimentação para eventos e recepções - bufê"
    },
    {
        value: "1822999",
        label: "Serviços de acabamentos gráficos, exceto encadernação e plastificação"
    },
    {
        value: "8621602",
        label: "Serviços móveis de atendimento a urgências, exceto por UTI móvel"
    },
    {
        value: "0311604",
        label: "Atividades de apoio à pesca em água salgada"
    },
    {
        value: "4330401",
        label: "Impermeabilização em obras de engenharia civil"
    },
    {
        value: "8425600",
        label: "Defesa Civil"
    },
    {
        value: "7420005",
        label: "Serviços de microfilmagem"
    },
    {
        value: "2941700",
        label: "Fabricação de peças e acessórios para o sistema motor de veículos automotores"
    },
    {
        value: "8422100",
        label: "Defesa"
    },
    {
        value: "0133403",
        label: "Cultivo de caju"
    },
    {
        value: "1121600",
        label: "Fabricação de águas envasadas"
    },
    {
        value: "6611801",
        label: "Bolsa de valores"
    },
    {
        value: "4530706",
        label: "Representantes comerciais e agentes do comércio de peças e acessórios novos e usados para veículos automotores"
    },
    {
        value: "3103900",
        label: "Fabricação de móveis de outros materiais, exceto madeira e metal"
    },
    {
        value: "0210199",
        label: "Produção de produtos não madeireiros não especificados anteriormente em florestas plantadas"
    },
    {
        value: "8593700",
        label: "Ensino de idiomas"
    },
    {
        value: "4649404",
        label: "Comércio atacadista de móveis e artigos de colchoaria"
    },
    {
        value: "1532700",
        label: "Fabricação de tênis de qualquer material"
    },
    {
        value: "4789001",
        label: "Comércio varejista de suvenires, bijuterias e artesanatos"
    },
    {
        value: "3314713",
        label: "Manutenção e reparação de máquinas-ferramenta"
    },
    {
        value: "5612100",
        label: "Serviços ambulantes de alimentação"
    },
    {
        value: "0210106",
        label: "Cultivo de mudas em viveiros florestais"
    },
    {
        value: "4635401",
        label: "Comércio atacadista de água mineral"
    },
    {
        value: "2759701",
        label: "Fabricação de aparelhos elétricos de uso pessoal, peças e acessórios"
    },
    {
        value: "8299707",
        label: "Salas de acesso à Internet"
    },
    {
        value: "5222200",
        label: "Terminais rodoviários e ferroviários"
    },
    {
        value: "4684201",
        label: "Comércio atacadista de resinas e elastômeros"
    },
    {
        value: "7732201",
        label: "Aluguel de máquinas e equipamentos para construção sem operador, exceto andaimes"
    },
    {
        value: "2522500",
        label: "Fabricação de caldeiras geradoras de vapor, exceto para aquecimento central e para veículos"
    },
    {
        value: "1113501",
        label: "Fabricação de malte, inclusive malte uísque"
    },
    {
        value: "4713004",
        label: "Lojas de departamentos ou magazines, exceto lojas francas (Duty free)"
    },
    {
        value: "2330399",
        label: "Fabricação de outros artefatos e produtos de concreto, cimento, fibrocimento, gesso e materiais semelhantes"
    },
    {
        value: "0810001",
        label: "Extração de ardósia e beneficiamento associado"
    },
    {
        value: "9603399",
        label: "Atividades funerárias e serviços relacionados não especificados anteriormente"
    },
    {
        value: "6619304",
        label: "Caixas eletrônicos"
    },
    {
        value: "4754703",
        label: "Comércio varejista de artigos de iluminação"
    },
    {
        value: "6110803",
        label: "Serviços de comunicação multimídia - SCM"
    },
    {
        value: "2942500",
        label: "Fabricação de peças e acessórios para os sistemas de marcha e transmissão de veículos automotores"
    },
    {
        value: "5829800",
        label: "Edição integrada à impressão de cadastros, listas e outros produtos gráficos"
    },
    {
        value: "3314719",
        label: "Manutenção e reparação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo"
    },
    {
        value: "0111303",
        label: "Cultivo de trigo"
    },
    {
        value: "4940000",
        label: "Transporte dutoviário"
    },
    {
        value: "1096100",
        label: "Fabricação de alimentos e pratos prontos"
    },
    {
        value: "6450600",
        label: "Sociedades de capitalização"
    },
    {
        value: "5250803",
        label: "Agenciamento de cargas, exceto para o transporte marítimo"
    },
    {
        value: "2031200",
        label: "Fabricação de resinas termoplásticas"
    },
    {
        value: "1099602",
        label: "Fabricação de pós-alimentícios"
    },
    {
        value: "3299001",
        label: "Fabricação de guarda-chuvas e similares"
    },
    {
        value: "6120502",
        label: "Serviço móvel especializado - SME"
    },
    {
        value: "1521100",
        label: "Fabricação de artigos para viagem, bolsas e semelhantes de qualquer material"
    },
    {
        value: "2814301",
        label: "Fabricação de compressores para uso industrial, peças e acessórios"
    },
    {
        value: "0170900",
        label: "Caça e serviços relacionados"
    },
    {
        value: "4729601",
        label: "Tabacaria"
    },
    {
        value: "2424502",
        label: "Produção de relaminados, trefilados e perfilados de aço, exceto arames"
    },
    {
        value: "6619302",
        label: "Correspondentes de instituições financeiras"
    },
    {
        value: "8532500",
        label: "Educação superior - graduação e pós-graduação"
    },
    {
        value: "5099801",
        label: "Transporte aquaviário para passeios turísticos"
    },
    {
        value: "8622400",
        label: "Serviços de remoção de pacientes, exceto os serviços móveis de atendimento a urgências"
    },
    {
        value: "4687701",
        label: "Comércio atacadista de resíduos de papel e papelão"
    },
    {
        value: "3811400",
        label: "Coleta de resíduos não perigosos"
    },
    {
        value: "4789004",
        label: "Comércio varejista de animais vivos e de artigos e alimentos para animais de estimação"
    },
    {
        value: "4782202",
        label: "Comércio varejista de artigos de viagem"
    },
    {
        value: "4632001",
        label: "Comércio atacadista de cereais e leguminosas beneficiados"
    },
    {
        value: "2722801",
        label: "Fabricação de baterias e acumuladores para veículos automotores"
    },
    {
        value: "1099601",
        label: "Fabricação de vinagres"
    },
    {
        value: "4641903",
        label: "Comércio atacadista de artigos de armarinho"
    },
    {
        value: "0810004",
        label: "Extração de calcário e dolomita e beneficiamento associado"
    },
    {
        value: "3314716",
        label: "Manutenção e reparação de tratores, exceto agrícolas"
    },
    {
        value: "8421300",
        label: "Relações exteriores"
    },
    {
        value: "3314706",
        label: "Manutenção e reparação de máquinas, aparelhos e equipamentos para instalações térmicas"
    },
    {
        value: "5030103",
        label: "Serviço de rebocadores e empurradores"
    },
    {
        value: "5811500",
        label: "Edição de livros"
    },
    {
        value: "1220499",
        label: "Fabricação de outros produtos do fumo, exceto cigarros, cigarrilhas e charutos"
    },
    {
        value: "2122000",
        label: "Fabricação de medicamentos para uso veterinário"
    },
    {
        value: "0220901",
        label: "Extração de madeira em florestas nativas"
    },
    {
        value: "9002702",
        label: "Restauração de obras de arte"
    },
    {
        value: "5912001",
        label: "Serviços de dublagem"
    },
    {
        value: "1731100",
        label: "Fabricação de embalagens de papel"
    },
    {
        value: "2790201",
        label: "Fabricação de eletrodos, contatos e outros artigos de carvão e grafita para uso elétrico, eletroímãs e isoladores"
    },
    {
        value: "5913800",
        label: "Distribuição cinematográfica, de vídeo e de programas de televisão"
    },
    {
        value: "4623107",
        label: "Comércio atacadista de sisal"
    },
    {
        value: "4613300",
        label: "Representantes comerciais e agentes do comércio de madeira, material de construção e ferragens"
    },
    {
        value: "4399104",
        label: "Serviços de operação e fornecimento de equipamentos para transporte e elevação de cargas e pessoas para uso em obras"
    },
    {
        value: "2219600",
        label: "Fabricação de artefatos de borracha não especificados \nanteriormente"
    },
    {
        value: "4311802",
        label: "Preparação de canteiro e limpeza de terreno"
    },
    {
        value: "2312500",
        label: "Fabricação de embalagens de vidro"
    },
    {
        value: "1122402",
        label: "Fabricação de chá mate e outros chás prontos para consumo"
    },
    {
        value: "1113502",
        label: "Fabricação de cervejas e chopes"
    },
    {
        value: "3900500",
        label: "Descontaminação e outros serviços de gestão de resíduos"
    },
    {
        value: "2821601",
        label: "Fabricação de fornos industriais, aparelhos e equipamentos não elétricos para instalações térmicas, peças e acessórios"
    },
    {
        value: "8230002",
        label: "Casas de festas e eventos"
    },
    {
        value: "8599603",
        label: "Treinamento em informática"
    },
    {
        value: "0321302",
        label: "Criação de camarões em água salgada e salobra"
    },
    {
        value: "0135100",
        label: "Cultivo de cacau"
    },
    {
        value: "0729401",
        label: "Extração de minérios de nióbio e titânio"
    },
    {
        value: "9001902",
        label: "Produção musical"
    },
    {
        value: "2013401",
        label: "Fabricação de adubos e fertilizantes organo-minerais"
    },
    {
        value: "4637106",
        label: "Comércio atacadista de sorvetes"
    },
    {
        value: "4223500",
        label: "Construção de redes de transportes por dutos, exceto para água e esgoto"
    },
    {
        value: "0155504",
        label: "Criação de aves, exceto galináceos"
    },
    {
        value: "4644301",
        label: "Comércio atacadista de medicamentos e drogas de uso humano"
    },
    {
        value: "4633803",
        label: "Comércio atacadista de coelhos e outros pequenos animais vivos para alimentação"
    },
    {
        value: "2062200",
        label: "Fabricação de produtos de limpeza e polimento"
    },
    {
        value: "0153901",
        label: "Criação de caprinos"
    },
    {
        value: "2013400",
        label: "Fabricação de adubos e fertilizantes"
    },
    {
        value: "4649410",
        label: "Comércio atacadista de jóias, relógios e bijuterias, inclusive pedras preciosas e semipreciosas lapidadas"
    },
    {
        value: "2930102",
        label: "Fabricação de carrocerias para ônibus"
    },
    {
        value: "1099607",
        label: "Fabricação de alimentos dietéticos e complementos alimentares"
    },
    {
        value: "2832100",
        label: "Fabricação de equipamentos para irrigação agrícola, peças e acessórios"
    },
    {
        value: "1742701",
        label: "Fabricação de fraldas descartáveis"
    },
    {
        value: "7420001",
        label: "Atividades de produção de fotografias, exceto aérea e submarina"
    },
    {
        value: "4639701",
        label: "Comércio atacadista de produtos alimentícios em geral"
    },
    {
        value: "1821100",
        label: "Serviços de pré-impressão"
    },
    {
        value: "1065103",
        label: "Fabricação de óleo de milho refinado"
    },
    {
        value: "3512300",
        label: "Transmissão de energia elétrica"
    },
    {
        value: "2072000",
        label: "Fabricação de tintas de impressão"
    },
    {
        value: "1411801",
        label: "Confecção de roupas íntimas"
    },
    {
        value: "1011201",
        label: "Frigorífico - abate de bovinos"
    },
    {
        value: "7490199",
        label: "Outras atividades profissionais, científicas e técnicas não especificadas anteriormente"
    },
    {
        value: "4761002",
        label: "Comércio varejista de jornais e revistas"
    },
    {
        value: "2740602",
        label: "Fabricação de luminárias e outros equipamentos de iluminação"
    },
    {
        value: "6920602",
        label: "Atividades de consultoria e auditoria contábil e tributária"
    },
    {
        value: "4922103",
        label: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, internacional"
    },
    {
        value: "4530701",
        label: "Comércio por atacado de peças e acessórios novos para veículos automotores"
    },
    {
        value: "4623102",
        label: "Comércio atacadista de couros, lãs, peles e outros subprodutos não comestíveis de origem animal"
    },
    {
        value: "2866600",
        label: "Fabricação de máquinas e equipamentos para a indústria do plástico, peças e acessórios"
    },
    {
        value: "3299006",
        label: "Fabricação de velas, inclusive decorativas"
    },
    {
        value: "4635403",
        label: "Comércio atacadista de bebidas com atividade de fracionamento e acondicionamento associada"
    },
    {
        value: "8512100",
        label: "Educação infantil - pré-escola"
    },
    {
        value: "6201502",
        label: "Web desing"
    },
    {
        value: "2452100",
        label: "Fundição de metais não ferrosos e suas ligas"
    },
    {
        value: "7740300",
        label: "Gestão de ativos intangíveis não financeiros"
    },
    {
        value: "1742799",
        label: "Fabricação de produtos de papel para uso doméstico e higiênico-sanitário não especificados anteriormente"
    },
    {
        value: "8730101",
        label: "Orfanatos"
    },
    {
        value: "3314708",
        label: "Manutenção e reparação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas"
    },
    {
        value: "2121102",
        label: "Fabricação de medicamentos homeopáticos para uso humano"
    },
    {
        value: "6130200",
        label: "Telecomunicações por satélite"
    },
    {
        value: "8640299",
        label: "Atividades de serviços de complementação diagnóstica e terapêutica não especificadas anteriormente"
    },
    {
        value: "5823900",
        label: "Edição integrada à impressão de revistas"
    },
    {
        value: "4612500",
        label: "Representantes comerciais e agentes do comércio de combustíveis, minerais, produtos siderúrgicos e químicos"
    },
    {
        value: "6120501",
        label: "Telefonia móvel celular"
    },
    {
        value: "2032100",
        label: "Fabricação de resinas termofixas"
    },
    {
        value: "4741500",
        label: "Comércio varejista de tintas e materiais para pintura"
    },
    {
        value: "9529199",
        label: "Reparação e manutenção de outros objetos e equipamentos pessoais e domésticos não especificados anteriormente"
    },
    {
        value: "6424703",
        label: "Cooperativas de crédito mútuo"
    },
    {
        value: "2732500",
        label: "Fabricação de material elétrico para instalações em circuito de consumo"
    },
    {
        value: "4542102",
        label: "Comércio sob consignação de motocicletas e motonetas"
    },
    {
        value: "4679603",
        label: "Comércio atacadista de vidros, espelhos e vitrais"
    },
    {
        value: "6110802",
        label: "Serviços de redes de transporte de telecomunicações - SRTT"
    },
    {
        value: "3299002",
        label: "Fabricação de canetas, lápis e outros artigos para escritório"
    },
    {
        value: "5821200",
        label: "Edição integrada à impressão de livros"
    },
    {
        value: "7319004",
        label: "Consultoria em publicidade"
    },
    {
        value: "5250801",
        label: "Comissaria de despachos"
    },
    {
        value: "4641901",
        label: "Comércio atacadista de tecidos"
    },
    {
        value: "4681805",
        label: "Comércio atacadista de lubrificantes"
    },
    {
        value: "0139399",
        label: "Cultivo de outras plantas de lavoura permanente não especificadas anteriormente"
    },
    {
        value: "7119701",
        label: "Serviços de cartografia, topografia e geodésia"
    },
    {
        value: "1064300",
        label: "Fabricação de farinha de milho e derivados, exceto óleos de milho"
    },
    {
        value: "3701100",
        label: "Gestão de redes de esgoto"
    },
    {
        value: "2721000",
        label: "Fabricação de pilhas, baterias e acumuladores elétricos, exceto para veículos automotores"
    },
    {
        value: "6422100",
        label: "Bancos múltiplos, com carteira comercial"
    },
    {
        value: "6821802",
        label: "Corretagem no aluguel de imóveis"
    },
    {
        value: "4921302",
        label: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal em região metropolitana"
    },
    {
        value: "1220401",
        label: "Fabricação de cigarros"
    },
    {
        value: "6810201",
        label: "Compra e venda de imóveis próprios"
    },
    {
        value: "1013902",
        label: "Preparação de subprodutos do abate"
    },
    {
        value: "5590699",
        label: "Outros alojamentos não especificados anteriormente"
    },
    {
        value: "0220903",
        label: "Coleta de castanha-do-pará em florestas nativas"
    },
    {
        value: "9499500",
        label: "Atividades associativas não especificadas anteriormente"
    },
    {
        value: "3211602",
        label: "Fabricação de artefatos de joalheria e ourivesaria"
    },
    {
        value: "2099101",
        label: "Fabricação de chapas, filmes, papéis e outros materiais e produtos químicos para fotografia"
    },
    {
        value: "0112199",
        label: "Cultivo de outras fibras de lavoura temporária não especificadas anteriormente"
    },
    {
        value: "0710301",
        label: "Extração de minério de ferro"
    },
    {
        value: "1531901",
        label: "Fabricação de calçados de couro"
    },
    {
        value: "1910100",
        label: "Coquerias"
    },
    {
        value: "4771701",
        label: "Comércio varejista de produtos farmacêuticos, sem manipulação de fórmulas"
    },
    {
        value: "0220902",
        label: "Produção de carvão vegetal - florestas nativas"
    },
    {
        value: "8800600",
        label: "Serviços de assistência social sem alojamento"
    },
    {
        value: "7830200",
        label: "Fornecimento e gestão de recursos humanos para terceiros"
    },
    {
        value: "4785701",
        label: "Comércio varejista de antiguidades"
    },
    {
        value: "3314714",
        label: "Manutenção e reparação de máquinas e equipamentos para a prospecção e extração de petróleo"
    },
    {
        value: "4311801",
        label: "Demolição de edifícios e outras estruturas"
    },
    {
        value: "1091100",
        label: "Fabricação de produtos de panificação"
    },
    {
        value: "1741901",
        label: "Fabricação de formulários contínuos"
    },
    {
        value: "8650006",
        label: "Atividades de fonoaudiologia"
    },
    {
        value: "4329105",
        label: "Tratamentos térmicos, acústicos ou de vibração"
    },
    {
        value: "4299599",
        label: "Outras obras de engenharia civil não especificadas anteriormente"
    },
    {
        value: "8122200",
        label: "Imunização e controle de pragas urbanas"
    },
    {
        value: "2093200",
        label: "Fabricação de aditivos de uso industrial"
    },
    {
        value: "1093701",
        label: "Fabricação de produtos derivados do cacau e de chocolates"
    },
    {
        value: "7911200",
        label: "Agências de viagens"
    },
    {
        value: "5611202",
        label: "Bares e outros estabelecimentos especializados em servir bebidas"
    },
    {
        value: "4623109",
        label: "Comércio atacadista de alimentos para animais"
    },
    {
        value: "6438701",
        label: "Bancos de câmbio"
    },
    {
        value: "3600601",
        label: "Captação, tratamento e distribuição de água"
    },
    {
        value: "9411100",
        label: "Atividades de organizações associativas patronais e empresariais"
    },
    {
        value: "0155505",
        label: "Produção de ovos"
    },
    {
        value: "4636202",
        label: "Comércio atacadista de cigarros, cigarrilhas e charutos"
    },
    {
        value: "6436100",
        label: "Sociedades de crédito, financiamento e investimento - financeiras"
    },
    {
        value: "1629301",
        label: "Fabricação de artefatos diversos de madeira, exceto móveis"
    },
    {
        value: "0321399",
        label: "Cultivos e semicultivos da aquicultura em água salgada e salobra não especificados anteriormente"
    },
    {
        value: "9601701",
        label: "Lavanderias"
    },
    {
        value: "0500302",
        label: "Beneficiamento de carvão mineral"
    },
    {
        value: "2349401",
        label: "Fabricação de material sanitário de cerâmica"
    },
    {
        value: "3011302",
        label: "Construção de embarcações para uso comercial e para usos especiais, exceto de grande porte"
    },
    {
        value: "4772500",
        label: "Comércio varejista de cosméticos, produtos de perfumaria e de higiene pessoal"
    },
    {
        value: "6511101",
        label: "Sociedade seguradora de seguros vida"
    },
    {
        value: "1042200",
        label: "Fabricação de óleos vegetais refinados, exceto óleo de milho"
    },
    {
        value: "5590601",
        label: "Albergues, exceto assistenciais"
    },
    {
        value: "4641902",
        label: "Comércio atacadista de artigos de cama, mesa e banho"
    },
    {
        value: "1413401",
        label: "Confecção de roupas profissionais, exceto sob medida"
    },
    {
        value: "6511102",
        label: "Planos de auxílio-funeral"
    },
    {
        value: "3314799",
        label: "Manutenção e reparação de outras máquinas e equipamentos para usos industriais não especificados anteriormente"
    },
    {
        value: "1340599",
        label: "Outros serviços de acabamento em fios, tecidos, artefatos têxteis e peças do vestuário"
    },
    {
        value: "5012202",
        label: "Transporte marítimo de longo curso - Passageiros"
    },
    {
        value: "4649402",
        label: "Comércio atacadista de aparelhos eletrônicos de uso pessoal e doméstico"
    },
    {
        value: "2061400",
        label: "Fabricação de sabões e detergentes sintéticos"
    },
    {
        value: "4611700",
        label: "Representantes comerciais e agentes do comércio de matérias-primas agrícolas e animais vivos"
    },
    {
        value: "8640210",
        label: "Serviços de quimioterapia"
    },
    {
        value: "2651500",
        label: "Fabricação de aparelhos e equipamentos de medida, teste e controle"
    },
    {
        value: "1312000",
        label: "Preparação e fiação de fibras têxteis naturais, exceto algodão"
    },
    {
        value: "1540800",
        label: "Fabricação de partes para calçados, de qualquer material"
    },
    {
        value: "9321200",
        label: "Parques de diversão e parques temáticos"
    },
    {
        value: "4637103",
        label: "Comércio atacadista de óleos e gorduras"
    },
    {
        value: "2223400",
        label: "Fabricação de tubos e acessórios de material plástico para uso na construção"
    },
    {
        value: "0322107",
        label: "Atividades de apoio à aquicultura em água doce"
    },
    {
        value: "8640209",
        label: "Serviços de diagnóstico por métodos ópticos - endoscopia e outros exames análogos"
    },
    {
        value: "4744005",
        label: "Comércio varejista de materiais de construção não especificados anteriormente"
    },
    {
        value: "4399199",
        label: "Serviços especializados para construção não especificados anteriormente"
    },
    {
        value: "0113000",
        label: "Cultivo de cana-de-açúcar"
    },
    {
        value: "8711504",
        label: "Centros de apoio a pacientes com câncer e com AIDS"
    },
    {
        value: "4763604",
        label: "Comércio varejista de artigos de caça, pesca e camping"
    },
    {
        value: "2073800",
        label: "Fabricação de impermeabilizantes, solventes e produtos afins"
    },
    {
        value: "8640212",
        label: "Serviços de hemoterapia"
    },
    {
        value: "4213800",
        label: "Obras de urbanização - ruas, praças e calçadas"
    },
    {
        value: "1411802",
        label: "Facção de roupas íntimas"
    }
]

export const classeSelect: formatJson[] = [
    {
        value: "01539",
        label: "Criação de caprinos e ovinos"
    },
    {
        value: "32302",
        label: "Fabricação de artefatos para pesca e esporte"
    },
    {
        value: "52231",
        label: "Estacionamento de veículos"
    },
    {
        value: "47814",
        label: "Comércio varejista de artigos do vestuário e acessórios"
    },
    {
        value: "32124",
        label: "Fabricação de bijuterias e artefatos semelhantes"
    },
    {
        value: "56121",
        label: "Serviços ambulantes de alimentação"
    },
    {
        value: "13308",
        label: "Fabricação de tecidos de malha"
    },
    {
        value: "01318",
        label: "Cultivo de laranja"
    },
    {
        value: "17338",
        label: "Fabricação de chapas e de embalagens de papelão ondulado"
    },
    {
        value: "22196",
        label: "Fabricação de artefatos de borracha não especificados anteriormente"
    },
    {
        value: "25128",
        label: "Fabricação de esquadrias de metal"
    },
    {
        value: "26221",
        label: "Fabricação de periféricos para equipamentos de informática"
    },
    {
        value: "16102",
        label: "Desdobramento de madeira"
    },
    {
        value: "25501",
        label: "Fabricação de equipamento bélico pesado, armas de fogo e munições"
    },
    {
        value: "25390",
        label: "Serviços de usinagem, solda, tratamento e revestimento em metais"
    },
    {
        value: "14134",
        label: "Confecção de roupas profissionais"
    },
    {
        value: "01148",
        label: "Cultivo de fumo"
    },
    {
        value: "47431",
        label: "Comércio varejista de vidros"
    },
    {
        value: "39005",
        label: "Descontaminação e outros serviços de gestão de resíduos"
    },
    {
        value: "43215",
        label: "Instalações elétricas"
    },
    {
        value: "10724",
        label: "Fabricação de açúcar refinado"
    },
    {
        value: "15211",
        label: "Fabricação de artigos para viagem, bolsas e semelhantes de qualquer material"
    },
    {
        value: "01555",
        label: "Criação de aves"
    },
    {
        value: "47717",
        label: "Comércio varejista de produtos farmacêuticos para uso humano e veterinário"
    },
    {
        value: "22218",
        label: "Fabricação de laminados planos e tubulares de material plástico"
    },
    {
        value: "10694",
        label: "Moagem e fabricação de produtos de origem vegetal não especificados anteriormente"
    },
    {
        value: "28518",
        label: "Fabricação de máquinas e equipamentos para a prospecção e extração de petróleo"
    },
    {
        value: "03124",
        label: "Pesca em água doce"
    },
    {
        value: "80111",
        label: "Atividades de vigilância e segurança privada"
    },
    {
        value: "66223",
        label: "Corretores e agentes de seguros, de planos de previdência complementar e de saúde"
    },
    {
        value: "31012",
        label: "Fabricação de móveis com predominância de madeira"
    },
    {
        value: "84124",
        label: "Regulação das atividades de saúde, educação, serviços culturais e outros serviços sociais"
    },
    {
        value: "52117",
        label: "Armazenamento"
    },
    {
        value: "86305",
        label: "Atividades de atenção ambulatorial executadas por médicos e odontólogos"
    },
    {
        value: "56201",
        label: "Serviços de catering, bufê e outros serviços de comida preparada"
    },
    {
        value: "45129",
        label: "Representantes comerciais e agentes do comércio de veículos automotores"
    },
    {
        value: "42910",
        label: "Obras portuárias, marítimas e fluviais"
    },
    {
        value: "43304",
        label: "Obras de acabamento"
    },
    {
        value: "64620",
        label: "Holdings de instituições não financeiras"
    },
    {
        value: "43134",
        label: "Obras de terraplenagem"
    },
    {
        value: "42227",
        label: "Construção de redes de abastecimento de água, coleta de esgoto e construções correlatas"
    },
    {
        value: "24229",
        label: "Produção de laminados planos de aço"
    },
    {
        value: "46796",
        label: "Comércio atacadista especializado de materiais de construção não especificados anteriormente e de materiais de construção em geral"
    },
    {
        value: "30318",
        label: "Fabricação de locomotivas, vagões e outros materiais rodantes"
    },
    {
        value: "47857",
        label: "Comércio varejista de artigos usados"
    },
    {
        value: "81214",
        label: "Limpeza em prédios e em domicílios"
    },
    {
        value: "20401",
        label: "Fabricação de fibras artificiais e sintéticas"
    },
    {
        value: "84221",
        label: "Defesa"
    },
    {
        value: "11216",
        label: "Fabricação de águas envasadas"
    },
    {
        value: "23206",
        label: "Fabricação de cimento"
    },
    {
        value: "58298",
        label: "Edição integrada à impressão de cadastros, listas e outros produtos gráficos"
    },
    {
        value: "64999",
        label: "Outras atividades de serviços financeiros não especificadas anteriormente"
    },
    {
        value: "82911",
        label: "Atividades de cobrança e informações cadastrais"
    },
    {
        value: "10643",
        label: "Fabricação de farinha de milho e derivados, exceto óleos de milho"
    },
    {
        value: "77314",
        label: "Aluguel de máquinas e equipamentos agrícolas sem operador"
    },
    {
        value: "55906",
        label: "Outros tipos de alojamento não especificados anteriormente"
    },
    {
        value: "42219",
        label: "Obras para geração e distribuição de energia elétrica e para telecomunicações"
    },
    {
        value: "47245",
        label: "Comércio varejista de hortifrutigranjeiros"
    },
    {
        value: "13529",
        label: "Fabricação de artefatos de tapeçaria"
    },
    {
        value: "82199",
        label: "Fotocópias, preparação de documentos e outros serviços especializados de apoio administrativo"
    },
    {
        value: "28542",
        label: "Fabricação de máquinas e equipamentos para terraplenagem, pavimentação e construção, exceto tratores"
    },
    {
        value: "25926",
        label: "Fabricação de produtos de trefilados de metal"
    },
    {
        value: "78108",
        label: "Seleção e agenciamento de mão de obra"
    },
    {
        value: "30121",
        label: "Construção de embarcações para esporte e lazer"
    },
    {
        value: "29301",
        label: "Fabricação de cabines, carrocerias e reboques para veículos automotores"
    },
    {
        value: "23303",
        label: "Fabricação de artefatos de concreto, cimento, fibrocimento, gesso e materiais semelhantes"
    },
    {
        value: "13138",
        label: "Fiação de fibras artificiais e sintéticas"
    },
    {
        value: "25438",
        label: "Fabricação de ferramentas"
    },
    {
        value: "46460",
        label: "Comércio atacadista de cosméticos, produtos de perfumaria e de higiene pessoal"
    },
    {
        value: "31039",
        label: "Fabricação de móveis de outros materiais, exceto madeira e metal"
    },
    {
        value: "13596",
        label: "Fabricação de outros produtos têxteis não especificados anteriormente"
    },
    {
        value: "61906",
        label: "Outras atividades de telecomunicações"
    },
    {
        value: "22234",
        label: "Fabricação de tubos e acessórios de material plástico para uso na construção"
    },
    {
        value: "51111",
        label: "Transporte aéreo de passageiros regular"
    },
    {
        value: "49507",
        label: "Trens turísticos, teleféricos e similares"
    },
    {
        value: "13235",
        label: "Tecelagem de fios de fibras artificiais e sintéticas"
    },
    {
        value: "33112",
        label: "Manutenção e reparação de tanques, reservatórios metálicos e caldeiras, exceto para veículos"
    },
    {
        value: "47423",
        label: "Comércio varejista de material elétrico"
    },
    {
        value: "61426",
        label: "Operadoras de televisão por assinatura por micro-ondas"
    },
    {
        value: "15319",
        label: "Fabricação de calçados de couro"
    },
    {
        value: "50220",
        label: "Transporte por navegação interior de passageiros em linhas regulares"
    },
    {
        value: "47539",
        label: "Comércio varejista especializado de eletrodomésticos e equipamentos de áudio e vídeo"
    },
    {
        value: "12204",
        label: "Fabricação de produtos do fumo"
    },
    {
        value: "09106",
        label: "Atividades de apoio à extração de petróleo e gás natural"
    },
    {
        value: "29450",
        label: "Fabricação de material elétrico e eletrônico para veículos automotores, exceto baterias"
    },
    {
        value: "49302",
        label: "Transporte rodoviário de carga"
    },
    {
        value: "46451",
        label: "Comércio atacadista de instrumentos e materiais para uso médico, cirúrgico, ortopédico e odontológico"
    },
    {
        value: "47130",
        label: "Comércio varejista de mercadorias em geral, sem predominância de produtos alimentícios"
    },
    {
        value: "17311",
        label: "Fabricação de embalagens de papel"
    },
    {
        value: "87301",
        label: "Atividades de assistência social prestadas em residências coletivas e particulares"
    },
    {
        value: "46869",
        label: "Comércio atacadista de papel e papelão em bruto e de embalagens"
    },
    {
        value: "46931",
        label: "Comércio atacadista de mercadorias em geral, sem predominância de alimentos ou de insumos agropecuários"
    },
    {
        value: "46737",
        label: "Comércio atacadista de material elétrico"
    },
    {
        value: "10121",
        label: "Abate de suínos, aves e outros pequenos animais"
    },
    {
        value: "51129",
        label: "Transporte aéreo de passageiros não regular"
    },
    {
        value: "10821",
        label: "Fabricação de produtos à base de café"
    },
    {
        value: "91031",
        label: "Atividades de jardins botânicos, zoológicos, parques nacionais, reservas ecológicas e áreas de proteção ambiental"
    },
    {
        value: "85112",
        label: "Educação infantil - creche"
    },
    {
        value: "64361",
        label: "Sociedades de crédito, financiamento e investimento - financeiras"
    },
    {
        value: "13405",
        label: "Acabamentos em fios, tecidos e artefatos têxteis"
    },
    {
        value: "90035",
        label: "Gestão de espaços para artes cênicas, espetáculos e outras atividades artísticas"
    },
    {
        value: "18121",
        label: "Impressão de material de segurança"
    },
    {
        value: "01351",
        label: "Cultivo de cacau"
    },
    {
        value: "23125",
        label: "Fabricação de embalagens de vidro"
    },
    {
        value: "50122",
        label: "Transporte marítimo de longo curso"
    },
    {
        value: "64336",
        label: "Bancos de desenvolvimento"
    },
    {
        value: "25314",
        label: "Produção de forjados de aço e de metais não ferrosos e suas ligas"
    },
    {
        value: "52222",
        label: "Terminais rodoviários e ferroviários"
    },
    {
        value: "07251",
        label: "Extração de minerais radioativos"
    },
    {
        value: "86909",
        label: "Atividades de atenção à saúde humana não especificadas anteriormente"
    },
    {
        value: "74901",
        label: "Atividades profissionais, científicas e técnicas não especificadas anteriormente"
    },
    {
        value: "94111",
        label: "Atividades de organizações associativas patronais e empresariais"
    },
    {
        value: "50301",
        label: "Navegação de apoio"
    },
    {
        value: "46427",
        label: "Comércio atacadista de artigos do vestuário e acessórios"
    },
    {
        value: "33198",
        label: "Manutenção e reparação de equipamentos e produtos não especificados anteriormente"
    },
    {
        value: "20916",
        label: "Fabricação de adesivos e selantes"
    },
    {
        value: "25934",
        label: "Fabricação de artigos de metal para uso doméstico e pessoal"
    },
    {
        value: "86500",
        label: "Atividades de profissionais da área de saúde, exceto médicos e odontólogos"
    },
    {
        value: "77217",
        label: "Aluguel de equipamentos recreativos e esportivos"
    },
    {
        value: "64352",
        label: "Crédito imobiliário"
    },
    {
        value: "49124",
        label: "Transporte metroferroviário de passageiros"
    },
    {
        value: "13111",
        label: "Preparação e fiação de fibras de algodão"
    },
    {
        value: "46478",
        label: "Comércio atacadista de artigos de escritório e de papelaria; livros, jornais e outras publicações"
    },
    {
        value: "17214",
        label: "Fabricação de papel"
    },
    {
        value: "20223",
        label: "Fabricação de intermediários para plastificantes, resinas e fibras"
    },
    {
        value: "66304",
        label: "Atividades de administração de fundos por contrato ou\ncomissão"
    },
    {
        value: "08924",
        label: "Extração e refino de sal marinho e sal-gema"
    },
    {
        value: "93298",
        label: "Atividades de recreação e lazer não especificadas\nanteriormente"
    },
    {
        value: "42120",
        label: "Construção de obras de arte especiais"
    },
    {
        value: "46877",
        label: "Comércio atacadista de resíduos e sucatas"
    },
    {
        value: "74102",
        label: "Design e decoração de interiores"
    },
    {
        value: "77233",
        label: "Aluguel de objetos do vestuário, jóias e acessórios"
    },
    {
        value: "47415",
        label: "Comércio varejista de tintas e materiais para pintura"
    },
    {
        value: "43126",
        label: "Perfurações e sondagens"
    },
    {
        value: "93212",
        label: "Parques de diversão e parques temáticos"
    },
    {
        value: "93123",
        label: "Clubes sociais, esportivos e similares"
    },
    {
        value: "62031",
        label: "Desenvolvimento e licenciamento de programas de computador não customizáveis"
    },
    {
        value: "28691",
        label: "Fabricação de máquinas e equipamentos para uso industrial específico não especificados anteriormente"
    },
    {
        value: "33121",
        label: "Manutenção e reparação de equipamentos eletrônicos e ópticos"
    },
    {
        value: "16218",
        label: "Fabricação de madeira laminada e de chapas de madeira compensada, prensada e aglomerada"
    },
    {
        value: "82997",
        label: "Atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
    },
    {
        value: "60225",
        label: "Programadoras e atividades relacionadas à televisão por assinatura"
    },
    {
        value: "11224",
        label: "Fabricação de refrigerantes e de outras bebidas não alcoólicas"
    },
    {
        value: "47563",
        label: "Comércio varejista especializado de instrumentos musicais e acessórios"
    },
    {
        value: "21211",
        label: "Fabricação de medicamentos para uso humano"
    },
    {
        value: "10996",
        label: "Fabricação de produtos alimentícios não especificados anteriormente"
    },
    {
        value: "25322",
        label: "Produção de artefatos estampados de metal; metalurgia do pó"
    },
    {
        value: "28232",
        label: "Fabricação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial"
    },
    {
        value: "27325",
        label: "Fabricação de material elétrico para instalações em circuito de consumo"
    },
    {
        value: "23117",
        label: "Fabricação de vidro plano e de segurança"
    },
    {
        value: "13227",
        label: "Tecelagem de fios de fibras têxteis naturais, exceto algodão"
    },
    {
        value: "32507",
        label: "Fabricação de instrumentos e materiais para uso médico e odontológico e de artigos ópticos"
    },
    {
        value: "10961",
        label: "Fabricação de alimentos e pratos prontos"
    },
    {
        value: "03221",
        label: "Aquicultura em água doce"
    },
    {
        value: "35301",
        label: "Produção e distribuição de vapor, água quente e ar\ncondicionado"
    },
    {
        value: "30326",
        label: "Fabricação de peças e acessórios para veículos ferroviários"
    },
    {
        value: "19217",
        label: "Fabricação de produtos do refino de petróleo"
    },
    {
        value: "08991",
        label: "Extração de minerais não metálicos não especificados anteriormente"
    },
    {
        value: "01229",
        label: "Cultivo de flores e plantas ornamentais"
    },
    {
        value: "28526",
        label: "Fabricação de outras máquinas e equipamentos para uso na extração mineral, exceto na extração de petróleo"
    },
    {
        value: "18211",
        label: "Serviços de pré-impressão"
    },
    {
        value: "13146",
        label: "Fabricação de linhas para costurar e bordar"
    },
    {
        value: "10953",
        label: "Fabricação de especiarias, molhos, temperos e condimentos"
    },
    {
        value: "88006",
        label: "Serviços de assistência social sem alojamento"
    },
    {
        value: "28135",
        label: "Fabricação de válvulas, registros e dispositivos semelhantes"
    },
    {
        value: "10317",
        label: "Fabricação de conservas de frutas"
    },
    {
        value: "66134",
        label: "Administração de cartões de crédito"
    },
    {
        value: "23192",
        label: "Fabricação de artigos de vidro"
    },
    {
        value: "20193",
        label: "Fabricação de produtos químicos inorgânicos não especificados anteriormente"
    },
    {
        value: "10422",
        label: "Fabricação de óleos vegetais refinados, exceto óleo de milho"
    },
    {
        value: "20932",
        label: "Fabricação de aditivos de uso industrial"
    },
    {
        value: "01211",
        label: "Horticultura"
    },
    {
        value: "53105",
        label: "Atividades de Correio"
    },
    {
        value: "28127",
        label: "Fabricação de equipamentos hidráulicos e pneumáticos, exceto válvulas"
    },
    {
        value: "46222",
        label: "Comércio atacadista de soja"
    },
    {
        value: "46419",
        label: "Comércio atacadista de tecidos, artefatos de tecidos e de armarinho"
    },
    {
        value: "43916",
        label: "Obras de fundações"
    },
    {
        value: "85317",
        label: "Educação superior - graduação"
    },
    {
        value: "79112",
        label: "Agências de viagens"
    },
    {
        value: "63917",
        label: "Agências de notícias"
    },
    {
        value: "33147",
        label: "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
    },
    {
        value: "10651",
        label: "Fabricação de amidos e féculas de vegetais e de óleos de milho"
    },
    {
        value: "73190",
        label: "Atividades de publicidade não especificadas anteriormente"
    },
    {
        value: "46826",
        label: "Comércio atacadista de gás liquefeito de petróleo (GLP)"
    },
    {
        value: "20215",
        label: "Fabricação de produtos petroquímicos básicos"
    },
    {
        value: "73122",
        label: "Agenciamento de espaços para publicidade, exceto em veículos de comunicação"
    },
    {
        value: "47440",
        label: "Comércio varejista de ferragens, madeira e materiais de construção"
    },
    {
        value: "28143",
        label: "Fabricação de compressores"
    },
    {
        value: "46745",
        label: "Comércio atacadista de cimento"
    },
    {
        value: "62040",
        label: "Consultoria em tecnologia da informação"
    },
    {
        value: "01598",
        label: "Criação de animais não especificados anteriormente"
    },
    {
        value: "85911",
        label: "Ensino de esportes"
    },
    {
        value: "24237",
        label: "Produção de laminados longos de aço"
    },
    {
        value: "42111",
        label: "Construção de rodovias e ferrovias"
    },
    {
        value: "01121",
        label: "Cultivo de algodão herbáceo e de outras fibras de lavoura temporária"
    },
    {
        value: "03213",
        label: "Aquicultura em água salgada e salobra"
    },
    {
        value: "25411",
        label: "Fabricação de artigos de cutelaria"
    },
    {
        value: "13219",
        label: "Tecelagem de fios de algodão"
    },
    {
        value: "47113",
        label: "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - hipermercados e supermercados"
    },
    {
        value: "07219",
        label: "Extração de minério de alumínio"
    },
    {
        value: "46117",
        label: "Representantes comerciais e agentes do comércio de matérias-primas agrícolas e animais vivos"
    },
    {
        value: "20738",
        label: "Fabricação de impermeabilizantes, solventes e produtos afins"
    },
    {
        value: "47628",
        label: "Comércio varejista de discos, CDs, DVDs e fitas"
    },
    {
        value: "71201",
        label: "Testes e análises técnicas"
    },
    {
        value: "24512",
        label: "Fundição de ferro e aço"
    },
    {
        value: "29433",
        label: "Fabricação de peças e acessórios para o sistema de freios de veículos automotores"
    },
    {
        value: "65502",
        label: "Planos de saúde"
    },
    {
        value: "63119",
        label: "Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na Internet"
    },
    {
        value: "59138",
        label: "Distribuição cinematográfica, de vídeo e de programas de televisão"
    },
    {
        value: "28321",
        label: "Fabricação de equipamentos para irrigação agrícola"
    },
    {
        value: "07103",
        label: "Extração de minério de ferro"
    },
    {
        value: "45421",
        label: "Representantes comerciais e agentes do comércio de motocicletas, peças e acessórios"
    },
    {
        value: "46125",
        label: "Representantes comerciais e agentes do comércio de combustíveis, minerais, produtos siderúrgicos e químicos"
    },
    {
        value: "61418",
        label: "Operadoras de televisão por assinatura por cabo"
    },
    {
        value: "46354",
        label: "Comércio atacadista de bebidas"
    },
    {
        value: "52311",
        label: "Gestão de portos e terminais"
    },
    {
        value: "24113",
        label: "Produção de ferro-gusa"
    },
    {
        value: "25918",
        label: "Fabricação de embalagens metálicas"
    },
    {
        value: "47725",
        label: "Comércio varejista de cosméticos, produtos de perfumaria e de higiene pessoal"
    },
    {
        value: "28534",
        label: "Fabricação de tratores, exceto agrícolas"
    },
    {
        value: "90027",
        label: "Criação artística"
    },
    {
        value: "27511",
        label: "Fabricação de fogões, refrigeradores e máquinas de lavar e secar para uso doméstico"
    },
    {
        value: "47822",
        label: "Comércio varejista de calçados e artigos de viagem"
    },
    {
        value: "49213",
        label: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, municipal e em região metropolitana"
    },
    {
        value: "49299",
        label: "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, e outros transportes rodoviários não especificados anteriormente"
    },
    {
        value: "19225",
        label: "Fabricação de produtos derivados do petróleo, exceto produtos do refino"
    },
    {
        value: "28666",
        label: "Fabricação de máquinas e equipamentos para a indústria do plástico"
    },
    {
        value: "66215",
        label: "Avaliação de riscos e perdas"
    },
    {
        value: "85139",
        label: "Ensino fundamental"
    },
    {
        value: "79902",
        label: "Serviços de reservas e outros serviços de turismo não especificados anteriormente"
    },
    {
        value: "72207",
        label: "Pesquisa e desenvolvimento experimental em ciências sociais e humanas"
    },
    {
        value: "24245",
        label: "Produção de relaminados, trefilados e perfilados de aço"
    },
    {
        value: "20118",
        label: "Fabricação de cloro e álcalis"
    },
    {
        value: "10716",
        label: "Fabricação de açúcar em bruto"
    },
    {
        value: "02306",
        label: "Atividades de apoio à produção florestal"
    },
    {
        value: "46397",
        label: "Comércio atacadista de produtos alimentícios em geral"
    },
    {
        value: "58131",
        label: "Edição de revistas"
    },
    {
        value: "46893",
        label: "Comércio atacadista especializado de outros produtos intermediários não especificados anteriormente"
    },
    {
        value: "28151",
        label: "Fabricação de equipamentos de transmissão para fins industriais"
    },
    {
        value: "32914",
        label: "Fabricação de escovas, pincéis e vassouras"
    },
    {
        value: "85996",
        label: "Atividades de ensino não especificadas anteriormente"
    },
    {
        value: "79121",
        label: "Operadores turísticos"
    },
    {
        value: "35204",
        label: "Produção de gás; processamento de gás natural; distribuição de combustíveis gasosos por redes urbanas"
    },
    {
        value: "29492",
        label: "Fabricação de peças e acessórios para veículos automotores não especificados anteriormente"
    },
    {
        value: "09904",
        label: "Atividades de apoio à extração de minerais, exceto petróleo e gás natural"
    },
    {
        value: "46192",
        label: "Representantes comerciais e agentes do comércio de mercadorias em geral não especializado"
    },
    {
        value: "27597",
        label: "Fabricação de aparelhos eletrodomésticos não especificados anteriormente"
    },
    {
        value: "26311",
        label: "Fabricação de equipamentos transmissores de comunicação"
    },
    {
        value: "28216",
        label: "Fabricação de aparelhos e equipamentos para instalações térmicas"
    },
    {
        value: "23991",
        label: "Fabricação de produtos de minerais não metálicos não especificados anteriormente"
    },
    {
        value: "86224",
        label: "Serviços de remoção de pacientes, exceto os serviços móveis de atendimento a urgências"
    },
    {
        value: "23419",
        label: "Fabricação de produtos cerâmicos refratários"
    },
    {
        value: "46630",
        label: "Comércio atacadista de máquinas e equipamentos para uso industrial; partes e peças"
    },
    {
        value: "26329",
        label: "Fabricação de aparelhos telefônicos e de outros equipamentos de comunicação"
    },
    {
        value: "13545",
        label: "Fabricação de tecidos especiais, inclusive artefatos"
    },
    {
        value: "10929",
        label: "Fabricação de biscoitos e bolachas"
    },
    {
        value: "77225",
        label: "Aluguel de fitas de vídeo, DVDs e similares"
    },
    {
        value: "20291",
        label: "Fabricação de produtos químicos orgânicos não especificados anteriormente"
    },
    {
        value: "46524",
        label: "Comércio atacadista de componentes eletrônicos e equipamentos de telefonia e comunicação"
    },
    {
        value: "21238",
        label: "Fabricação de preparações farmacêuticas"
    },
    {
        value: "01521",
        label: "Criação de outros animais de grande porte"
    },
    {
        value: "85121",
        label: "Educação infantil - pré-escola"
    },
    {
        value: "46923",
        label: "Comércio atacadista de mercadorias em geral, com predominância de insumos agropecuários"
    },
    {
        value: "14142",
        label: "Fabricação de acessórios do vestuário, exceto para segurança e proteção"
    },
    {
        value: "47121",
        label: "Comércio varejista de mercadorias em geral, com\npredominância de produtos alimentícios - minimercados,\nmercearias e armazéns"
    },
    {
        value: "46231",
        label: "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
    },
    {
        value: "46133",
        label: "Representantes comerciais e agentes do comércio de madeira, material de construção e ferragens"
    },
    {
        value: "01113",
        label: "Cultivo de cereais"
    },
    {
        value: "64212",
        label: "Bancos comerciais"
    },
    {
        value: "17419",
        label: "Fabricação de produtos de papel, cartolina, papel-cartão e papelão ondulado para uso comercial e de escritório"
    },
    {
        value: "28631",
        label: "Fabricação de máquinas e equipamentos para a indústria têxtil"
    },
    {
        value: "01547",
        label: "Criação de suínos"
    },
    {
        value: "29425",
        label: "Fabricação de peças e acessórios para os sistemas de marcha e transmissão de veículos automotores"
    },
    {
        value: "18113",
        label: "Impressão de jornais, livros, revistas e outras publicações periódicas"
    },
    {
        value: "47571",
        label: "Comércio varejista especializado de peças e acessórios para aparelhos eletroeletrônicos para uso doméstico, exceto informática e comunicação"
    },
    {
        value: "38327",
        label: "Recuperação de materiais plásticos"
    },
    {
        value: "81125",
        label: "Condomínios prediais"
    },
    {
        value: "10112",
        label: "Abate de reses, exceto suínos"
    },
    {
        value: "01326",
        label: "Cultivo de uva"
    },
    {
        value: "52508",
        label: "Atividades relacionadas à organização do transporte de carga"
    },
    {
        value: "30997",
        label: "Fabricação de equipamentos de transporte não especificados anteriormente"
    },
    {
        value: "49230",
        label: "Transporte rodoviário de táxi"
    },
    {
        value: "64930",
        label: "Administração de consórcios para aquisição de bens e direitos"
    },
    {
        value: "60217",
        label: "Atividades de televisão aberta"
    },
    {
        value: "46184",
        label: "Representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente"
    },
    {
        value: "02101",
        label: "Produção florestal - florestas plantadas"
    },
    {
        value: "46141",
        label: "Representantes comerciais e agentes do comércio de máquinas, equipamentos, embarcações e aeronaves"
    },
    {
        value: "94201",
        label: "Atividades de organizações sindicais"
    },
    {
        value: "64387",
        label: "Bancos de câmbio e outras instituições de intermediação não monetária"
    },
    {
        value: "46311",
        label: "Comércio atacadista de leite e laticínios"
    },
    {
        value: "59120",
        label: "Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão"
    },
    {
        value: "47849",
        label: "Comércio varejista de gás liqüefeito de petróleo (GLP)"
    },
    {
        value: "27317",
        label: "Fabricação de aparelhos e equipamentos para distribuição e controle de energia elétrica"
    },
    {
        value: "97005",
        label: "Serviços domésticos"
    },
    {
        value: "38114",
        label: "Coleta de resíduos não perigosos"
    },
    {
        value: "38122",
        label: "Coleta de resíduos perigosos"
    },
    {
        value: "08932",
        label: "Extração de gemas (pedras preciosas e semipreciosas)"
    },
    {
        value: "22111",
        label: "Fabricação de pneumáticos e de câmaras-de-ar"
    },
    {
        value: "85422",
        label: "Educação profissional de nível tecnológico"
    },
    {
        value: "58239",
        label: "Edição integrada à impressão de revistas"
    },
    {
        value: "33139",
        label: "Manutenção e reparação de máquinas e equipamentos elétricos"
    },
    {
        value: "84230",
        label: "Justiça"
    },
    {
        value: "46656",
        label: "Comércio atacadista de máquinas e equipamentos para uso comercial; partes e peças"
    },
    {
        value: "31047",
        label: "Fabricação de colchões"
    },
    {
        value: "22293",
        label: "Fabricação de artefatos de material plástico não especificados anteriormente"
    },
    {
        value: "47610",
        label: "Comércio varejista de livros, jornais, revistas e papelaria"
    },
    {
        value: "10937",
        label: "Fabricação de produtos derivados do cacau, de chocolates e confeitos"
    },
    {
        value: "95126",
        label: "Reparação e manutenção de equipamentos de comunicação"
    },
    {
        value: "64921",
        label: "Securitização de créditos"
    },
    {
        value: "24415",
        label: "Metalurgia do alumínio e suas ligas"
    },
    {
        value: "45200",
        label: "Manutenção e reparação de veículos automotores"
    },
    {
        value: "96033",
        label: "Atividades funerárias e serviços relacionados"
    },
    {
        value: "47890",
        label: "Comércio varejista de outros produtos novos não especificados anteriormente"
    },
    {
        value: "46346",
        label: "Comércio atacadista de carnes, produtos da carne e pescado"
    },
    {
        value: "06000",
        label: "Extração de petróleo e gás natural"
    },
    {
        value: "51307",
        label: "Transporte espacial"
    },
    {
        value: "43118",
        label: "Demolição e preparação de canteiros de obras"
    },
    {
        value: "64638",
        label: "Outras sociedades de participação, exceto holdings"
    },
    {
        value: "78205",
        label: "Locação de mão de obra temporária"
    },
    {
        value: "77195",
        label: "Locação de meios de transporte, exceto automóveis, sem condutor"
    },
    {
        value: "94928",
        label: "Atividades de organizações políticas"
    },
    {
        value: "12107",
        label: "Processamento industrial do fumo"
    },
    {
        value: "62023",
        label: "Desenvolvimento e licenciamento de programas de computador customizáveis"
    },
    {
        value: "47512",
        label: "Comércio varejista especializado de equipamentos e suprimentos de informática"
    },
    {
        value: "64913",
        label: "Sociedades de fomento mercantil - factoring"
    },
    {
        value: "52320",
        label: "Atividades de agenciamento marítimo"
    },
    {
        value: "20126",
        label: "Fabricação de intermediários para fertilizantes"
    },
    {
        value: "27333",
        label: "Fabricação de fios, cabos e condutores elétricos isolados"
    },
    {
        value: "01130",
        label: "Cultivo de cana-de-açúcar"
    },
    {
        value: "32922",
        label: "Fabricação de equipamentos e acessórios para segurança e proteção pessoal e profissional"
    },
    {
        value: "23915",
        label: "Aparelhamento e outros trabalhos em pedras"
    },
    {
        value: "15408",
        label: "Fabricação de partes para calçados, de qualquer material"
    },
    {
        value: "23427",
        label: "Fabricação de produtos cerâmicos não refratários para uso estrutural na construção"
    },
    {
        value: "91015",
        label: "Atividades de bibliotecas e arquivos"
    },
    {
        value: "42928",
        label: "Montagem de instalações industriais e de estruturas metálicas"
    },
    {
        value: "70204",
        label: "Atividades de consultoria em gestão empresarial"
    },
    {
        value: "64239",
        label: "Caixas econômicas"
    },
    {
        value: "45111",
        label: "Comércio a varejo e por atacado de veículos automotores"
    },
    {
        value: "28615",
        label: "Fabricação de máquinas para a indústria metalúrgica, exceto máquinas-ferramenta"
    },
    {
        value: "10538",
        label: "Fabricação de sorvetes e outros gelados comestíveis"
    },
    {
        value: "27210",
        label: "Fabricação de pilhas, baterias e acumuladores elétricos, exceto para veículos automotores"
    },
    {
        value: "64379",
        label: "Sociedades de crédito ao microempreendedor"
    },
    {
        value: "26604",
        label: "Fabricação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação"
    },
    {
        value: "38211",
        label: "Tratamento e disposição de resíduos não perigosos"
    },
    {
        value: "27406",
        label: "Fabricação de lâmpadas e outros equipamentos de iluminação"
    },
    {
        value: "47237",
        label: "Comércio varejista de bebidas"
    },
    {
        value: "10139",
        label: "Fabricação de produtos de carne"
    },
    {
        value: "62091",
        label: "Suporte técnico, manutenção e outros serviços em tecnologia da informação"
    },
    {
        value: "27228",
        label: "Fabricação de baterias e acumuladores para veículos automotores"
    },
    {
        value: "82300",
        label: "Atividades de organização de eventos, exceto culturais e esportivos"
    },
    {
        value: "86402",
        label: "Atividades de serviços de complementação diagnóstica e terapêutica"
    },
    {
        value: "52401",
        label: "Atividades auxiliares dos transportes aéreos"
    },
    {
        value: "18229",
        label: "Serviços de acabamentos gráficos"
    },
    {
        value: "50114",
        label: "Transporte marítimo de cabotagem"
    },
    {
        value: "32990",
        label: "Fabricação de produtos diversos não especificados anteriormente"
    },
    {
        value: "77331",
        label: "Aluguel de máquinas e equipamentos para escritório"
    },
    {
        value: "66118",
        label: "Administração de bolsas e mercados de balcão organizados"
    },
    {
        value: "50998",
        label: "Transportes aquaviários não especificados anteriormente"
    },
    {
        value: "46834",
        label: "Comércio atacadista de defensivos agrícolas, adubos, fertilizantes e corretivos do solo"
    },
    {
        value: "07294",
        label: "Extração de minerais metálicos não ferrosos não especificados anteriormente"
    },
    {
        value: "26108",
        label: "Fabricação de componentes eletrônicos"
    },
    {
        value: "16293",
        label: "Fabricação de artefatos de madeira, palha, cortiça, vime e material trançado não especificados anteriormente, exceto\nmóveis"
    },
    {
        value: "36006",
        label: "Captação, tratamento e distribuição de água"
    },
    {
        value: "29107",
        label: "Fabricação de automóveis, camionetas e utilitários"
    },
    {
        value: "10333",
        label: "Fabricação de sucos de frutas, hortaliças e legumes"
    },
    {
        value: "87123",
        label: "Atividades de fornecimento de infraestrutura de apoio e assistência a paciente no domicílio"
    },
    {
        value: "38319",
        label: "Recuperação de materiais metálicos"
    },
    {
        value: "92003",
        label: "Atividades de exploração de jogos de azar e apostas"
    },
    {
        value: "56112",
        label: "Restaurantes e outros estabelecimentos de serviços de alimentação e bebidas"
    },
    {
        value: "82202",
        label: "Atividades de teleatendimento"
    },
    {
        value: "46494",
        label: "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
    },
    {
        value: "13537",
        label: "Fabricação de artefatos de cordoaria"
    },
    {
        value: "68218",
        label: "Intermediação na compra, venda e aluguel de imóveis"
    },
    {
        value: "46371",
        label: "Comércio atacadista especializado em produtos alimentícios não especificados anteriormente"
    },
    {
        value: "46699",
        label: "Comércio atacadista de máquinas, aparelhos e equipamentos não especificados anteriormente; partes e peças"
    },
    {
        value: "46214",
        label: "Comércio atacadista de café em grão"
    },
    {
        value: "19314",
        label: "Fabricação de álcool"
    },
    {
        value: "28658",
        label: "Fabricação de máquinas e equipamentos para as indústrias de celulose, papel e papelão e artefatos"
    },
    {
        value: "46435",
        label: "Comércio atacadista de calçados e artigos de viagem"
    },
    {
        value: "42235",
        label: "Construção de redes de transportes por dutos, exceto para água e esgoto"
    },
    {
        value: "47326",
        label: "Comércio varejista de lubrificantes"
    },
    {
        value: "55108",
        label: "Hotéis e similares"
    },
    {
        value: "46818",
        label: "Comércio atacadista de combustíveis sólidos, líquidos e gasosos, exceto gás natural e GLP"
    },
    {
        value: "21106",
        label: "Fabricação de produtos farmoquímicos"
    },
    {
        value: "01423",
        label: "Produção de mudas e outras formas de propagação vegetal, certificadas"
    },
    {
        value: "74200",
        label: "Atividades fotográficas e similares"
    },
    {
        value: "61302",
        label: "Telecomunicações por satélite"
    },
    {
        value: "45439",
        label: "Manutenção e reparação de motocicletas"
    },
    {
        value: "94995",
        label: "Atividades associativas não especificadas anteriormente"
    },
    {
        value: "28224",
        label: "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas e pessoas"
    },
    {
        value: "26523",
        label: "Fabricação de cronômetros e relógios"
    },
    {
        value: "33171",
        label: "Manutenção e reparação de embarcações"
    },
    {
        value: "85201",
        label: "Ensino médio"
    },
    {
        value: "41204",
        label: "Construção de edifícios"
    },
    {
        value: "10431",
        label: "Fabricação de margarina e outras gorduras vegetais e de óleos não comestíveis de animais"
    },
    {
        value: "64247",
        label: "Crédito cooperativo"
    },
    {
        value: "93191",
        label: "Atividades esportivas não especificadas anteriormente"
    },
    {
        value: "68102",
        label: "Atividades imobiliárias de imóveis próprios"
    },
    {
        value: "01393",
        label: "Cultivo de plantas de lavoura permanente não especificadas anteriormente"
    },
    {
        value: "01156",
        label: "Cultivo de soja"
    },
    {
        value: "41107",
        label: "Incorporação de empreendimentos imobiliários"
    },
    {
        value: "47211",
        label: "Comércio varejista de produtos de padaria, laticínio, doces, balas e semelhantes"
    },
    {
        value: "90019",
        label: "Artes cênicas, espetáculos e atividades complementares"
    },
    {
        value: "10911",
        label: "Fabricação de produtos de panificação"
    },
    {
        value: "17320",
        label: "Fabricação de embalagens de cartolina e papel-cartão"
    },
    {
        value: "59146",
        label: "Atividades de exibição cinematográfica"
    },
    {
        value: "24423",
        label: "Metalurgia dos metais preciosos"
    },
    {
        value: "11127",
        label: "Fabricação de vinho"
    },
    {
        value: "20924",
        label: "Fabricação de explosivos"
    },
    {
        value: "94308",
        label: "Atividades de associações de defesa de direitos sociais"
    },
    {
        value: "64221",
        label: "Bancos múltiplos, com carteira comercial"
    },
    {
        value: "10520",
        label: "Fabricação de laticínios"
    },
    {
        value: "96092",
        label: "Atividades de serviços pessoais não especificadas anteriormente"
    },
    {
        value: "96017",
        label: "Lavanderias, tinturarias e toalheiros"
    },
    {
        value: "47636",
        label: "Comércio varejista de artigos recreativos e esportivos"
    },
    {
        value: "66291",
        label: "Atividades auxiliares dos seguros, da previdência complementar e dos planos de saúde não especificadas anteriormente"
    },
    {
        value: "47521",
        label: "Comércio varejista especializado de equipamentos de telefonia e comunicação"
    },
    {
        value: "25225",
        label: "Fabricação de caldeiras geradoras de vapor, exceto para aquecimento central e para veículos"
    },
    {
        value: "16226",
        label: "Fabricação de estruturas de madeira e de artigos de carpintaria para construção"
    },
    {
        value: "07235",
        label: "Extração de minério de manganês"
    },
    {
        value: "01415",
        label: "Produção de sementes certificadas"
    },
    {
        value: "59201",
        label: "Atividades de gravação de som e de edição de música"
    },
    {
        value: "69125",
        label: "Cartórios"
    },
    {
        value: "66126",
        label: "Atividades de intermediários em transações de títulos, valores mobiliários e mercadorias"
    },
    {
        value: "43991",
        label: "Serviços especializados para construção não especificados anteriormente"
    },
    {
        value: "80129",
        label: "Atividades de transporte de valores"
    },
    {
        value: "30911",
        label: "Fabricação de motocicletas"
    },
    {
        value: "24393",
        label: "Produção de outros tubos de ferro e aço"
    },
    {
        value: "93131",
        label: "Atividades de condicionamento físico"
    },
    {
        value: "85503",
        label: "Atividades de apoio à educação"
    },
    {
        value: "46842",
        label: "Comércio atacadista de produtos químicos e petroquímicos, exceto agroquímicos"
    },
    {
        value: "46915",
        label: "Comércio atacadista de mercadorias em geral, com predominância de produtos alimentícios"
    },
    {
        value: "58221",
        label: "Edição integrada à impressão de jornais"
    },
    {
        value: "50211",
        label: "Transporte por navegação interior de carga"
    },
    {
        value: "81290",
        label: "Atividades de limpeza não especificadas anteriormente"
    },
    {
        value: "84256",
        label: "Defesa Civil"
    },
    {
        value: "85325",
        label: "Educação superior - graduação e pós-graduação"
    },
    {
        value: "01628",
        label: "Atividades de apoio à pecuária"
    },
    {
        value: "29441",
        label: "Fabricação de peças e acessórios para o sistema de direção e suspensão de veículos automotores"
    },
    {
        value: "46362",
        label: "Comércio atacadista de produtos do fumo"
    },
    {
        value: "95291",
        label: "Reparação e manutenção de objetos e equipamentos pessoais e domésticos não especificados anteriormente"
    },
    {
        value: "15327",
        label: "Fabricação de tênis de qualquer material"
    },
    {
        value: "25993",
        label: "Fabricação de produtos de metal não especificados anteriormente"
    },
    {
        value: "24491",
        label: "Metalurgia dos metais não ferrosos e suas ligas não especificados anteriormente"
    },
    {
        value: "28119",
        label: "Fabricação de motores e turbinas, exceto para aviões e veículos rodoviários"
    },
    {
        value: "17427",
        label: "Fabricação de produtos de papel para usos doméstico e higiênico-sanitário"
    },
    {
        value: "49400",
        label: "Transporte dutoviário"
    },
    {
        value: "29204",
        label: "Fabricação de caminhões e ônibus"
    },
    {
        value: "85937",
        label: "Ensino de idiomas"
    },
    {
        value: "84213",
        label: "Relações exteriores"
    },
    {
        value: "10511",
        label: "Preparação do leite"
    },
    {
        value: "28330",
        label: "Fabricação de máquinas e equipamentos para a agricultura e pecuária, exceto para irrigação"
    },
    {
        value: "28241",
        label: "Fabricação de aparelhos e equipamentos de ar condicionado"
    },
    {
        value: "82920",
        label: "Envasamento e empacotamento sob contrato"
    },
    {
        value: "52125",
        label: "Carga e descarga"
    },
    {
        value: "32400",
        label: "Fabricação de brinquedos e jogos recreativos"
    },
    {
        value: "25217",
        label: "Fabricação de tanques, reservatórios metálicos e caldeiras para aquecimento central"
    },
    {
        value: "68226",
        label: "Gestão e administração da propriedade imobiliária"
    },
    {
        value: "20142",
        label: "Fabricação de gases industriais"
    },
    {
        value: "02209",
        label: "Produção florestal - florestas nativas"
    },
    {
        value: "20991",
        label: "Fabricação de produtos químicos não especificados anteriormente"
    },
    {
        value: "73203",
        label: "Pesquisas de mercado e de opinião pública"
    },
    {
        value: "21220",
        label: "Fabricação de medicamentos para uso veterinário"
    },
    {
        value: "64328",
        label: "Bancos de investimento"
    },
    {
        value: "52214",
        label: "Concessionárias de rodovias, pontes, túneis e serviços relacionados"
    },
    {
        value: "20631",
        label: "Fabricação de cosméticos, produtos de perfumaria e de higiene pessoal"
    },
    {
        value: "18130",
        label: "Impressão de materiais para outros usos"
    },
    {
        value: "10660",
        label: "Fabricação de alimentos para animais"
    },
    {
        value: "46320",
        label: "Comércio atacadista de cereais e leguminosas beneficiados, farinhas, amidos e féculas"
    },
    {
        value: "53202",
        label: "Atividades de malote e de entrega"
    },
    {
        value: "07227",
        label: "Extração de minério de estanho"
    },
    {
        value: "26701",
        label: "Fabricação de equipamentos e instrumentos ópticos, fotográficos e cinematográficos"
    },
    {
        value: "84132",
        label: "Regulação das atividades econômicas"
    },
    {
        value: "25420",
        label: "Fabricação de artigos de serralheria, exceto esquadrias"
    },
    {
        value: "10619",
        label: "Beneficiamento de arroz e fabricação de produtos do arroz"
    },
    {
        value: "77403",
        label: "Gestão de ativos intangíveis não financeiros"
    },
    {
        value: "35140",
        label: "Distribuição de energia elétrica"
    },
    {
        value: "86101",
        label: "Atividades de atendimento hospitalar"
    },
    {
        value: "20941",
        label: "Fabricação de catalisadores"
    },
    {
        value: "71120",
        label: "Serviços de engenharia"
    },
    {
        value: "16234",
        label: "Fabricação de artefatos de tanoaria e de embalagens de madeira"
    },
    {
        value: "20321",
        label: "Fabricação de resinas termofixas"
    },
    {
        value: "33163",
        label: "Manutenção e reparação de aeronaves"
    },
    {
        value: "28623",
        label: "Fabricação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo"
    },
    {
        value: "01342",
        label: "Cultivo de café"
    },
    {
        value: "43193",
        label: "Serviços de preparação do terreno não especificados anteriormente"
    },
    {
        value: "24121",
        label: "Produção de ferroligas"
    },
    {
        value: "80200",
        label: "Atividades de monitoramento de sistemas de segurança"
    },
    {
        value: "61108",
        label: "Telecomunicações por fio"
    },
    {
        value: "58123",
        label: "Edição de jornais"
    },
    {
        value: "60101",
        label: "Atividades de rádio"
    },
    {
        value: "27902",
        label: "Fabricação de equipamentos e aparelhos elétricos não especificados anteriormente"
    },
    {
        value: "43291",
        label: "Obras de instalações em construções não especificadas anteriormente"
    },
    {
        value: "10627",
        label: "Moagem de trigo e fabricação de derivados"
    },
    {
        value: "32116",
        label: "Lapidação de gemas e fabricação de artefatos de ourivesaria e joalheria"
    },
    {
        value: "47733",
        label: "Comércio varejista de artigos médicos e ortopédicos"
    },
    {
        value: "17494",
        label: "Fabricação de produtos de pastas celulósicas, papel, cartolina, papel-cartão e papelão ondulado não especificados anteriormente"
    },
    {
        value: "45307",
        label: "Comércio de peças e acessórios para veículos automotores"
    },
    {
        value: "47547",
        label: "Comércio varejista especializado de móveis, colchoaria e artigos de iluminação"
    },
    {
        value: "65308",
        label: "Resseguros"
    },
    {
        value: "20517",
        label: "Fabricação de defensivos agrícolas"
    },
    {
        value: "66193",
        label: "Atividades auxiliares dos serviços financeiros não especificadas anteriormente"
    },
    {
        value: "28291",
        label: "Fabricação de máquinas e equipamentos de uso geral não especificados anteriormente"
    },
    {
        value: "84302",
        label: "Seguridade social obrigatória"
    },
    {
        value: "81117",
        label: "Serviços combinados para apoio a edifícios, exceto condomínios prediais"
    },
    {
        value: "08916",
        label: "Extração de minerais para fabricação de adubos, fertilizantes e outros produtos químicos"
    },
    {
        value: "62015",
        label: "Desenvolvimento de programas de computador sob encomenda"
    },
    {
        value: "58115",
        label: "Edição de livros"
    },
    {
        value: "46443",
        label: "Comércio atacadista de produtos farmacêuticos para uso humano e veterinário"
    },
    {
        value: "22226",
        label: "Fabricação de embalagens de material plástico"
    },
    {
        value: "08100",
        label: "Extração de pedra, areia e argila"
    },
    {
        value: "93115",
        label: "Gestão de instalações de esportes"
    },
    {
        value: "95215",
        label: "Reparação e manutenção de equipamentos eletroeletrônicos de uso pessoal e doméstico"
    },
    {
        value: "46168",
        label: "Representantes comerciais e agentes do comércio de têxteis, vestuário, calçados e artigos de viagem"
    },
    {
        value: "26213",
        label: "Fabricação de equipamentos de informática"
    },
    {
        value: "46648",
        label: "Comércio atacadista de máquinas, aparelhos e equipamentos para uso odonto-médico-hospitalar; partes e peças"
    },
    {
        value: "45412",
        label: "Comércio por atacado e a varejo de motocicletas, peças e acessórios"
    },
    {
        value: "38220",
        label: "Tratamento e disposição de resíduos perigosos"
    },
    {
        value: "65111",
        label: "Seguros de vida"
    },
    {
        value: "65421",
        label: "Previdência complementar aberta"
    },
    {
        value: "47741",
        label: "Comércio varejista de artigos de óptica"
    },
    {
        value: "27104",
        label: "Fabricação de geradores, transformadores e motores elétricos"
    },
    {
        value: "20312",
        label: "Fabricação de resinas termoplásticas"
    },
    {
        value: "37029",
        label: "Atividades relacionadas a esgoto, exceto a gestão de redes"
    },
    {
        value: "01512",
        label: "Criação de bovinos"
    },
    {
        value: "59111",
        label: "Atividades de produção cinematográfica, de vídeos e de programas de televisão"
    },
    {
        value: "24521",
        label: "Fundição de metais não ferrosos e suas ligas"
    },
    {
        value: "65120",
        label: "Seguros não vida"
    },
    {
        value: "14118",
        label: "Confecção de roupas íntimas"
    },
    {
        value: "49116",
        label: "Transporte ferroviário de carga"
    },
    {
        value: "01610",
        label: "Atividades de apoio à agricultura"
    },
    {
        value: "77322",
        label: "Aluguel de máquinas e equipamentos para construção sem operador"
    },
    {
        value: "30504",
        label: "Fabricação de veículos militares de combate"
    },
    {
        value: "77390",
        label: "Aluguel de máquinas e equipamentos não especificados anteriormente"
    },
    {
        value: "11135",
        label: "Fabricação de malte, cervejas e chopes"
    },
    {
        value: "20720",
        label: "Fabricação de tintas de impressão"
    },
    {
        value: "85929",
        label: "Ensino de arte e cultura"
    },
    {
        value: "17222",
        label: "Fabricação de cartolina e papel-cartão"
    },
    {
        value: "25136",
        label: "Fabricação de obras de caldeiraria pesada"
    },
    {
        value: "26809",
        label: "Fabricação de mídias virgens, magnéticas e ópticas"
    },
    {
        value: "20622",
        label: "Fabricação de produtos de limpeza e polimento"
    },
    {
        value: "47318",
        label: "Comércio varejista de combustíveis para veículos automotores"
    },
    {
        value: "20134",
        label: "Fabricação de adubos e fertilizantes"
    },
    {
        value: "10325",
        label: "Fabricação de conservas de legumes e outros vegetais"
    },
    {
        value: "71111",
        label: "Serviços de arquitetura"
    },
    {
        value: "81222",
        label: "Imunização e controle de pragas urbanas"
    },
    {
        value: "86607",
        label: "Atividades de apoio à gestão de saúde"
    },
    {
        value: "30415",
        label: "Fabricação de aeronaves"
    },
    {
        value: "47831",
        label: "Comércio varejista de jóias e relógios"
    },
    {
        value: "01199",
        label: "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
    },
    {
        value: "46516",
        label: "Comércio atacadista de computadores, periféricos e suprimentos de informática"
    },
    {
        value: "72100",
        label: "Pesquisa e desenvolvimento experimental em ciências físicas e naturais"
    },
    {
        value: "35131",
        label: "Comércio atacadista de energia elétrica"
    },
    {
        value: "46613",
        label: "Comércio atacadista de máquinas, aparelhos e equipamentos para uso agropecuário; partes e peças"
    },
    {
        value: "20339",
        label: "Fabricação de elastômeros"
    },
    {
        value: "63992",
        label: "Outras atividades de prestação de serviços de informação não especificadas anteriormente"
    },
    {
        value: "18300",
        label: "Reprodução de materiais gravados em qualquer suporte"
    },
    {
        value: "91023",
        label: "Atividades de museus e de exploração, restauração artística\ne conservação de lugares e prédios históricos e atrações\nsimilares"
    },
    {
        value: "87115",
        label: "Atividades de assistência a idosos, deficientes físicos, imunodeprimidos e convalescentes prestadas em residências coletivas e particulares"
    },
    {
        value: "13120",
        label: "Preparação e fiação de fibras têxteis naturais, exceto algodão"
    },
    {
        value: "29506",
        label: "Recondicionamento e recuperação de motores para veículos automotores"
    },
    {
        value: "01636",
        label: "Atividades de pós-colheita"
    },
    {
        value: "71197",
        label: "Atividades técnicas relacionadas à arquitetura e engenharia"
    },
    {
        value: "46851",
        label: "Comércio atacadista de produtos siderúrgicos e metalúrgicos, exceto para construção"
    },
    {
        value: "15106",
        label: "Curtimento e outras preparações de couro"
    },
    {
        value: "61205",
        label: "Telecomunicações sem fio"
    },
    {
        value: "37011",
        label: "Gestão de redes de esgoto"
    },
    {
        value: "95118",
        label: "Reparação e manutenção de computadores e de equipamentos periféricos"
    },
    {
        value: "43223",
        label: "Instalações hidráulicas, de sistemas de ventilação e\nrefrigeração"
    },
    {
        value: "15335",
        label: "Fabricação de calçados de material sintético"
    },
    {
        value: "28313",
        label: "Fabricação de tratores agrícolas"
    },
    {
        value: "25110",
        label: "Fabricação de estruturas metálicas"
    },
    {
        value: "10813",
        label: "Torrefação e moagem de café"
    },
    {
        value: "49221",
        label: "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal, interestadual e internacional"
    },
    {
        value: "03116",
        label: "Pesca em água salgada"
    },
    {
        value: "14215",
        label: "Fabricação de meias"
    },
    {
        value: "87204",
        label: "Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência mental e dependência\nquímica"
    },
    {
        value: "61434",
        label: "Operadoras de televisão por assinatura por satélite"
    },
    {
        value: "64344",
        label: "Agências de fomento"
    },
    {
        value: "26515",
        label: "Fabricação de aparelhos e equipamentos de medida, teste e\ncontrole"
    },
    {
        value: "42138",
        label: "Obras de urbanização - ruas, praças e calçadas"
    },
    {
        value: "24431",
        label: "Metalurgia do cobre"
    },
    {
        value: "84248",
        label: "Segurança e ordem pública"
    },
    {
        value: "33210",
        label: "Instalação de máquinas e equipamentos industriais"
    },
    {
        value: "14223",
        label: "Fabricação de artigos do vestuário, produzidos em malharias e tricotagens, exceto meias"
    },
    {
        value: "69206",
        label: "Atividades de contabilidade, consultoria e auditoria contábil e tributária"
    },
    {
        value: "20614",
        label: "Fabricação de sabões e detergentes sintéticos"
    },
    {
        value: "78302",
        label: "Fornecimento e gestão de recursos humanos para terceiros"
    },
    {
        value: "47598",
        label: "Comércio varejista de artigos de uso doméstico não especificados anteriormente"
    },
    {
        value: "30423",
        label: "Fabricação de turbinas, motores e outros componentes e peças para aeronaves"
    },
    {
        value: "64310",
        label: "Bancos múltiplos, sem carteira comercial"
    },
    {
        value: "52397",
        label: "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente"
    },
    {
        value: "46176",
        label: "Representantes comerciais e agentes do comércio de produtos alimentícios, bebidas e fumo"
    },
    {
        value: "52290",
        label: "Atividades auxiliares dos transportes terrestres não especificadas anteriormente"
    },
    {
        value: "32205",
        label: "Fabricação de instrumentos musicais"
    },
    {
        value: "64409",
        label: "Arrendamento mercantil"
    },
    {
        value: "64506",
        label: "Sociedades de capitalização"
    },
    {
        value: "85414",
        label: "Educação profissional de nível técnico"
    },
    {
        value: "65201",
        label: "Seguros-saúde"
    },
    {
        value: "81303",
        label: "Atividades paisagísticas"
    },
    {
        value: "17109",
        label: "Fabricação de celulose e outras pastas para a fabricação de papel"
    },
    {
        value: "47296",
        label: "Comércio varejista de produtos alimentícios em geral ou especializado em produtos alimentícios não especificados anteriormente; produtos do fumo"
    },
    {
        value: "94120",
        label: "Atividades de organizações associativas profissionais"
    },
    {
        value: "82113",
        label: "Serviços combinados de escritório e apoio administrativo"
    },
    {
        value: "22129",
        label: "Reforma de pneumáticos usados"
    },
    {
        value: "80307",
        label: "Atividades de investigação particular"
    },
    {
        value: "46621",
        label: "Comércio atacadista de máquinas, equipamentos para terraplenagem, mineração e construção; partes e peças"
    },
    {
        value: "10414",
        label: "Fabricação de óleos vegetais em bruto, exceto óleo de milho"
    },
    {
        value: "77292",
        label: "Aluguel de objetos pessoais e domésticos não especificados anteriormente"
    },
    {
        value: "64701",
        label: "Fundos de investimento"
    },
    {
        value: "50912",
        label: "Transporte por navegação de travessia"
    },
    {
        value: "47229",
        label: "Comércio varejista de carnes e pescados - açougues e peixarias"
    },
    {
        value: "20711",
        label: "Fabricação de tintas, vernizes, esmaltes e lacas"
    },
    {
        value: "46338",
        label: "Comércio atacadista de hortifrutigranjeiros"
    },
    {
        value: "46711",
        label: "Comércio atacadista de madeira e produtos derivados"
    },
    {
        value: "28259",
        label: "Fabricação de máquinas e equipamentos para saneamento básico e ambiental"
    },
    {
        value: "24211",
        label: "Produção de semiacabados de aço"
    },
    {
        value: "23923",
        label: "Fabricação de cal e gesso"
    },
    {
        value: "94910",
        label: "Atividades de organizações religiosas"
    },
    {
        value: "31021",
        label: "Fabricação de móveis com predominância de metal"
    },
    {
        value: "01164",
        label: "Cultivo de oleaginosas de lavoura temporária, exceto soja"
    },
    {
        value: "58212",
        label: "Edição integrada à impressão de livros"
    },
    {
        value: "26400",
        label: "Fabricação de aparelhos de recepção, reprodução, gravação e amplificação de áudio e vídeo"
    },
    {
        value: "14126",
        label: "Confecção de peças do vestuário, exceto roupas íntimas"
    },
    {
        value: "28402",
        label: "Fabricação de máquinas-ferramenta"
    },
    {
        value: "11119",
        label: "Fabricação de aguardentes e outras bebidas destiladas"
    },
    {
        value: "65413",
        label: "Previdência complementar fechada"
    },
    {
        value: "85333",
        label: "Educação superior - pós-graduação e extensão"
    },
    {
        value: "24318",
        label: "Produção de tubos de aço com costura"
    },
    {
        value: "86216",
        label: "Serviços móveis de atendimento a urgências"
    },
    {
        value: "49248",
        label: "Transporte escolar"
    },
    {
        value: "38394",
        label: "Recuperação de materiais não especificados anteriormente"
    },
    {
        value: "63194",
        label: "Portais, provedores de conteúdo e outros serviços de informação na Internet"
    },
    {
        value: "94936",
        label: "Atividades de organizações associativas ligadas à cultura\ne à arte"
    },
    {
        value: "96025",
        label: "Cabeleireiros e outras atividades de tratamento de beleza"
    },
    {
        value: "23494",
        label: "Fabricação de produtos cerâmicos não refratários não especificados anteriormente"
    },
    {
        value: "01709",
        label: "Caça e serviços relacionados"
    },
    {
        value: "35123",
        label: "Transmissão de energia elétrica"
    },
    {
        value: "15297",
        label: "Fabricação de artefatos de couro não especificados anteriormente"
    },
    {
        value: "46150",
        label: "Representantes comerciais e agentes do comércio de eletrodomésticos, móveis e artigos de uso doméstico"
    },
    {
        value: "46729",
        label: "Comércio atacadista de ferragens e ferramentas"
    },
    {
        value: "10635",
        label: "Fabricação de farinha de mandioca e derivados"
    },
    {
        value: "30113",
        label: "Construção de embarcações e estruturas flutuantes"
    },
    {
        value: "13511",
        label: "Fabricação de artefatos têxteis para uso doméstico"
    },
    {
        value: "10945",
        label: "Fabricação de massas alimentícias"
    },
    {
        value: "75001",
        label: "Atividades veterinárias"
    },
    {
        value: "05003",
        label: "Extração de carvão mineral"
    },
    {
        value: "01334",
        label: "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
    },
    {
        value: "10201",
        label: "Preservação do pescado e fabricação de produtos do pescado"
    },
    {
        value: "99008",
        label: "Organismos internacionais e outras instituições extraterritoriais"
    },
    {
        value: "84116",
        label: "Administração pública em geral"
    },
    {
        value: "73114",
        label: "Agências de publicidade"
    },
    {
        value: "30920",
        label: "Fabricação de bicicletas e triciclos não motorizados"
    },
    {
        value: "19101",
        label: "Coquerias"
    },
    {
        value: "47555",
        label: "Comércio varejista especializado de tecidos e artigos de cama, mesa e banho"
    },
    {
        value: "19322",
        label: "Fabricação de biocombustíveis, exceto álcool"
    },
    {
        value: "58191",
        label: "Edição de cadastros, listas e outros produtos gráficos"
    },
    {
        value: "28640",
        label: "Fabricação de máquinas e equipamentos para as indústrias do vestuário, do couro e de calçados"
    },
    {
        value: "15394",
        label: "Fabricação de calçados de materiais não especificados anteriormente"
    },
    {
        value: "77110",
        label: "Locação de automóveis sem condutor"
    },
    {
        value: "35115",
        label: "Geração de energia elétrica"
    },
    {
        value: "69117",
        label: "Atividades jurídicas, exceto cartórios"
    },
    {
        value: "51200",
        label: "Transporte aéreo de carga"
    },
    {
        value: "29417",
        label: "Fabricação de peças e acessórios para o sistema motor de veículos automotores"
    },
    {
        value: "64107",
        label: "Banco Central"
    },
    {
        value: "33155",
        label: "Manutenção e reparação de veículos ferroviários"
    },
    {
        value: "64611",
        label: "Holdings de instituições financeiras"
    },
    {
        value: "42995",
        label: "Obras de engenharia civil não especificadas anteriormente"
    },
    {
        value: "07243",
        label: "Extração de minério de metais preciosos"
    },
    {
        value: "33295",
        label: "Instalação de equipamentos não especificados anteriormente"
    },
    {
        value: "20525",
        label: "Fabricação de desinfestantes domissanitários"
    }
]

export const grupoSelect: formatJson[] = [
    {
        value: "072",
        label: "Extração de minerais metálicos não ferrosos"
    },
    {
        value: "869",
        label: "Atividades de atenção à saúde humana não especificadas anteriormente"
    },
    {
        value: "243",
        label: "Produção de tubos de aço, exceto tubos sem costura"
    },
    {
        value: "291",
        label: "Fabricação de automóveis, camionetas e utilitários"
    },
    {
        value: "273",
        label: "Fabricação de equipamentos para distribuição e controle de energia elétrica"
    },
    {
        value: "943",
        label: "Atividades de associações de defesa de direitos sociais"
    },
    {
        value: "267",
        label: "Fabricação de equipamentos e instrumentos ópticos, fotográficos e cinematográficos"
    },
    {
        value: "652",
        label: "Seguros-saúde"
    },
    {
        value: "970",
        label: "Serviços domésticos"
    },
    {
        value: "491",
        label: "Transporte ferroviário e metroferroviário"
    },
    {
        value: "647",
        label: "Fundos de investimento"
    },
    {
        value: "192",
        label: "Fabricação de produtos derivados do petróleo"
    },
    {
        value: "941",
        label: "Atividades de organizações associativas patronais, empresariais e profissionais"
    },
    {
        value: "509",
        label: "Outros transportes aquaviários"
    },
    {
        value: "501",
        label: "Transporte marítimo de cabotagem e longo curso"
    },
    {
        value: "472",
        label: "Comércio varejista de produtos alimentícios, bebidas e fumo"
    },
    {
        value: "182",
        label: "Serviços de pré-impressão e acabamentos gráficos"
    },
    {
        value: "151",
        label: "Curtimento e outras preparações de couro"
    },
    {
        value: "524",
        label: "Atividades auxiliares dos transportes aéreos"
    },
    {
        value: "742",
        label: "Atividades fotográficas e similares"
    },
    {
        value: "465",
        label: "Comércio atacadista de equipamentos e produtos de tecnologias de informação e comunicação"
    },
    {
        value: "381",
        label: "Coleta de resíduos"
    },
    {
        value: "108",
        label: "Torrefação e moagem de café"
    },
    {
        value: "641",
        label: "Banco Central"
    },
    {
        value: "322",
        label: "Fabricação de instrumentos musicais"
    },
    {
        value: "852",
        label: "Ensino médio"
    },
    {
        value: "821",
        label: "Serviços de escritório e apoio administrativo"
    },
    {
        value: "602",
        label: "Atividades de televisão"
    },
    {
        value: "309",
        label: "Fabricação de equipamentos de transporte não especificados anteriormente"
    },
    {
        value: "209",
        label: "Fabricação de produtos e preparados químicos diversos"
    },
    {
        value: "513",
        label: "Transporte espacial"
    },
    {
        value: "431",
        label: "Demolição e preparação do terreno"
    },
    {
        value: "109",
        label: "Fabricação de outros produtos alimentícios"
    },
    {
        value: "731",
        label: "Publicidade"
    },
    {
        value: "525",
        label: "Atividades relacionadas à organização do transporte de carga"
    },
    {
        value: "813",
        label: "Atividades paisagísticas"
    },
    {
        value: "422",
        label: "Obras de infraestrutura para energia elétrica, telecomunicações, água, esgoto e transporte por dutos"
    },
    {
        value: "429",
        label: "Construção de outras obras de infraestrutura"
    },
    {
        value: "281",
        label: "Fabricação de motores, bombas, compressores e equipamentos de transmissão"
    },
    {
        value: "614",
        label: "Operadoras de televisão por assinatura"
    },
    {
        value: "174",
        label: "Fabricação de produtos diversos de papel, cartolina, papel-cartão e papelão ondulado"
    },
    {
        value: "871",
        label: "Atividades de assistência a idosos, deficientes físicos, imunodeprimidos e convalescentes, e de infraestrutura e apoio a pacientes prestadas em residências coletivas e particulares"
    },
    {
        value: "561",
        label: "Restaurantes e outros serviços de alimentação e bebidas"
    },
    {
        value: "523",
        label: "Atividades auxiliares dos transportes aquaviários"
    },
    {
        value: "321",
        label: "Fabricação de artigos de joalheria, bijuteria e semelhantes"
    },
    {
        value: "265",
        label: "Fabricação de aparelhos e instrumentos de medida, teste e controle; cronômetros e relógios"
    },
    {
        value: "183",
        label: "Reprodução de materiais gravados em qualquer suporte"
    },
    {
        value: "462",
        label: "Comércio atacadista de matérias-primas agrícolas e animais vivos"
    },
    {
        value: "142",
        label: "Fabricação de artigos de malharia e tricotagem"
    },
    {
        value: "106",
        label: "Moagem, fabricação de produtos amiláceos e de alimentos para animais"
    },
    {
        value: "162",
        label: "Fabricação de produtos de madeira, cortiça e material trançado, exceto móveis"
    },
    {
        value: "202",
        label: "Fabricação de produtos químicos orgânicos"
    },
    {
        value: "478",
        label: "Comércio varejista de produtos novos não especificados anteriormente e de produtos usados"
    },
    {
        value: "021",
        label: "Produção florestal - florestas plantadas"
    },
    {
        value: "251",
        label: "Fabricação de estruturas metálicas e obras de caldeiraria\npesada"
    },
    {
        value: "750",
        label: "Atividades veterinárias"
    },
    {
        value: "559",
        label: "Outros tipos de alojamento não especificados anteriormente"
    },
    {
        value: "691",
        label: "Atividades jurídicas"
    },
    {
        value: "873",
        label: "Atividades de assistência social prestadas em residências coletivas e particulares"
    },
    {
        value: "463",
        label: "Comércio atacadista especializado em produtos alimentícios, bebidas e fumo"
    },
    {
        value: "411",
        label: "Incorporação de empreendimentos imobiliários"
    },
    {
        value: "492",
        label: "Transporte rodoviário de passageiros"
    },
    {
        value: "960",
        label: "Outras atividades de serviços pessoais"
    },
    {
        value: "193",
        label: "Fabricação de biocombustíveis"
    },
    {
        value: "601",
        label: "Atividades de rádio"
    },
    {
        value: "013",
        label: "Produção de lavouras permanentes"
    },
    {
        value: "749",
        label: "Atividades profissionais, científicas e técnicas não especificadas anteriormente"
    },
    {
        value: "495",
        label: "Trens turísticos, teleféricos e similares"
    },
    {
        value: "464",
        label: "Comércio atacadista de produtos de consumo não alimentar"
    },
    {
        value: "089",
        label: "Extração de outros minerais não metálicos"
    },
    {
        value: "651",
        label: "Seguros de vida e não vida"
    },
    {
        value: "782",
        label: "Locação de mão de obra temporária"
    },
    {
        value: "581",
        label: "Edição de livros, jornais, revistas e outras atividades de edição"
    },
    {
        value: "203",
        label: "Fabricação de resinas e elastômeros"
    },
    {
        value: "292",
        label: "Fabricação de caminhões e ônibus"
    },
    {
        value: "352",
        label: "Produção e distribuição de combustíveis gasosos por redes urbanas"
    },
    {
        value: "211",
        label: "Fabricação de produtos farmoquímicos"
    },
    {
        value: "642",
        label: "Intermediação monetária - depósitos à vista"
    },
    {
        value: "012",
        label: "Horticultura e floricultura"
    },
    {
        value: "853",
        label: "Educação superior"
    },
    {
        value: "774",
        label: "Gestão de ativos intangíveis não financeiros"
    },
    {
        value: "091",
        label: "Atividades de apoio à extração de petróleo e gás natural"
    },
    {
        value: "662",
        label: "Atividades auxiliares dos seguros, da previdência complementar e dos planos de saúde"
    },
    {
        value: "295",
        label: "Recondicionamento e recuperação de motores para veículos automotores"
    },
    {
        value: "134",
        label: "Acabamentos em fios, tecidos e artefatos têxteis"
    },
    {
        value: "646",
        label: "Atividades de sociedades de participação"
    },
    {
        value: "494",
        label: "Transporte dutoviário"
    },
    {
        value: "253",
        label: "Forjaria, estamparia, metalurgia do pó e serviços de tratamento de metais"
    },
    {
        value: "466",
        label: "Comércio atacadista de máquinas, aparelhos e equipamentos, exceto de tecnologias de informação e comunicação"
    },
    {
        value: "081",
        label: "Extração de pedra, areia e argila"
    },
    {
        value: "244",
        label: "Metalurgia dos metais não ferrosos"
    },
    {
        value: "791",
        label: "Agências de viagens e operadores turísticos"
    },
    {
        value: "521",
        label: "Armazenamento, carga e descarga"
    },
    {
        value: "511",
        label: "Transporte aéreo de passageiros"
    },
    {
        value: "942",
        label: "Atividades de organizações sindicais"
    },
    {
        value: "432",
        label: "Instalações elétricas, hidráulicas e outras instalações em construções"
    },
    {
        value: "781",
        label: "Seleção e agenciamento de mão de obra"
    },
    {
        value: "255",
        label: "Fabricação de equipamento bélico pesado, armas e munições"
    },
    {
        value: "859",
        label: "Outras atividades de ensino"
    },
    {
        value: "711",
        label: "Serviços de arquitetura e engenharia e atividades técnicas relacionadas"
    },
    {
        value: "283",
        label: "Fabricação de tratores e de máquinas e equipamentos para a agricultura e pecuária"
    },
    {
        value: "842",
        label: "Serviços coletivos prestados pela administração pública"
    },
    {
        value: "152",
        label: "Fabricação de artigos para viagem e de artefatos diversos de couro"
    },
    {
        value: "303",
        label: "Fabricação de veículos ferroviários"
    },
    {
        value: "254",
        label: "Fabricação de artigos de cutelaria, de serralheria e ferramentas"
    },
    {
        value: "861",
        label: "Atividades de atendimento hospitalar"
    },
    {
        value: "272",
        label: "Fabricação de pilhas, baterias e acumuladores elétricos"
    },
    {
        value: "201",
        label: "Fabricação de produtos químicos inorgânicos"
    },
    {
        value: "771",
        label: "Locação de meios de transporte sem condutor"
    },
    {
        value: "141",
        label: "Confecção de artigos do vestuário e acessórios"
    },
    {
        value: "325",
        label: "Fabricação de instrumentos e materiais para uso médico e odontológico e de artigos ópticos"
    },
    {
        value: "841",
        label: "Administração do estado e da política econômica e social"
    },
    {
        value: "390",
        label: "Descontaminação e outros serviços de gestão de resíduos"
    },
    {
        value: "022",
        label: "Produção florestal - florestas nativas"
    },
    {
        value: "722",
        label: "Pesquisa e desenvolvimento experimental em ciências sociais e humanas"
    },
    {
        value: "643",
        label: "Intermediação não monetária - outros instrumentos de captação"
    },
    {
        value: "293",
        label: "Fabricação de cabines, carrocerias e reboques para veículos automotores"
    },
    {
        value: "261",
        label: "Fabricação de componentes eletrônicos"
    },
    {
        value: "360",
        label: "Captação, tratamento e distribuição de água"
    },
    {
        value: "469",
        label: "Comércio atacadista não especializado"
    },
    {
        value: "205",
        label: "Fabricação de defensivos agrícolas e desinfestantes domissanitários"
    },
    {
        value: "863",
        label: "Atividades de atenção ambulatorial executadas por médicos e odontólogos"
    },
    {
        value: "910",
        label: "Atividades ligadas ao patrimônio cultural e ambiental"
    },
    {
        value: "324",
        label: "Fabricação de brinquedos e jogos recreativos"
    },
    {
        value: "454",
        label: "Comércio, manutenção e reparação de motocicletas, peças e acessórios"
    },
    {
        value: "239",
        label: "Aparelhamento de pedras e fabricação de outros produtos de minerais não metálicos"
    },
    {
        value: "702",
        label: "Atividades de consultoria em gestão empresarial"
    },
    {
        value: "212",
        label: "Fabricação de produtos farmacêuticos"
    },
    {
        value: "631",
        label: "Tratamento de dados, hospedagem na Internet e outras atividades relacionadas"
    },
    {
        value: "900",
        label: "Atividades artísticas, criativas e de espetáculos"
    },
    {
        value: "851",
        label: "Educação infantil e ensino fundamental"
    },
    {
        value: "822",
        label: "Atividades de teleatendimento"
    },
    {
        value: "310",
        label: "Fabricação de móveis"
    },
    {
        value: "264",
        label: "Fabricação de aparelhos de recepção, reprodução, gravação e amplificação de áudio e vídeo"
    },
    {
        value: "663",
        label: "Atividades de administração de fundos por contrato ou\ncomissão"
    },
    {
        value: "931",
        label: "Atividades esportivas"
    },
    {
        value: "990",
        label: "Organismos internacionais e outras instituições extraterritoriais"
    },
    {
        value: "803",
        label: "Atividades de investigação particular"
    },
    {
        value: "732",
        label: "Pesquisas de mercado e de opinião pública"
    },
    {
        value: "181",
        label: "Atividade de impressão"
    },
    {
        value: "329",
        label: "Fabricação de produtos diversos"
    },
    {
        value: "721",
        label: "Pesquisa e desenvolvimento experimental em ciências físicas e naturais"
    },
    {
        value: "612",
        label: "Telecomunicações sem fio"
    },
    {
        value: "653",
        label: "Resseguros"
    },
    {
        value: "050",
        label: "Extração de carvão mineral"
    },
    {
        value: "661",
        label: "Atividades auxiliares dos serviços financeiros"
    },
    {
        value: "592",
        label: "Atividades de gravação de som e de edição de música"
    },
    {
        value: "862",
        label: "Serviços móveis de atendimento a urgências e de remoção de pacientes"
    },
    {
        value: "383",
        label: "Recuperação de materiais"
    },
    {
        value: "562",
        label: "Serviços de catering, bufê e outros serviços de comida preparada"
    },
    {
        value: "173",
        label: "Fabricação de embalagens de papel, cartolina, papel-cartão e papelão ondulado"
    },
    {
        value: "112",
        label: "Fabricação de bebidas não alcoólicas"
    },
    {
        value: "370",
        label: "Esgoto e atividades relacionadas"
    },
    {
        value: "351",
        label: "Geração, transmissão e distribuição de energia elétrica"
    },
    {
        value: "613",
        label: "Telecomunicações por satélite"
    },
    {
        value: "655",
        label: "Planos de saúde"
    },
    {
        value: "294",
        label: "Fabricação de peças e acessórios para veículos automotores"
    },
    {
        value: "865",
        label: "Atividades de profissionais da área de saúde, exceto médicos e odontólogos"
    },
    {
        value: "191",
        label: "Coquerias"
    },
    {
        value: "829",
        label: "Outras atividades de serviços prestados principalmente às empresas"
    },
    {
        value: "532",
        label: "Atividades de malote e de entrega"
    },
    {
        value: "773",
        label: "Aluguel de máquinas e equipamentos sem operador"
    },
    {
        value: "060",
        label: "Extração de petróleo e gás natural"
    },
    {
        value: "103",
        label: "Fabricação de conservas de frutas, legumes e outros vegetais"
    },
    {
        value: "654",
        label: "Previdência complementar"
    },
    {
        value: "204",
        label: "Fabricação de fibras artificiais e sintéticas"
    },
    {
        value: "301",
        label: "Construção de embarcações"
    },
    {
        value: "453",
        label: "Comércio de peças e acessórios para veículos automotores"
    },
    {
        value: "644",
        label: "Arrendamento mercantil"
    },
    {
        value: "234",
        label: "Fabricação de produtos cerâmicos"
    },
    {
        value: "011",
        label: "Produção de lavouras temporárias"
    },
    {
        value: "206",
        label: "Fabricação de sabões, detergentes, produtos de limpeza, cosméticos, produtos de perfumaria e de higiene pessoal"
    },
    {
        value: "741",
        label: "Design e decoração de interiores"
    },
    {
        value: "207",
        label: "Fabricação de tintas, vernizes, esmaltes, lacas e produtos afins"
    },
    {
        value: "263",
        label: "Fabricação de equipamentos de comunicação"
    },
    {
        value: "866",
        label: "Atividades de apoio à gestão de saúde"
    },
    {
        value: "122",
        label: "Fabricação de produtos do fumo"
    },
    {
        value: "522",
        label: "Atividades auxiliares dos transportes terrestres"
    },
    {
        value: "854",
        label: "Educação profissional de nível técnico e tecnológico"
    },
    {
        value: "503",
        label: "Navegação de apoio"
    },
    {
        value: "111",
        label: "Fabricação de bebidas alcoólicas"
    },
    {
        value: "619",
        label: "Outras atividades de telecomunicações"
    },
    {
        value: "502",
        label: "Transporte por navegação interior"
    },
    {
        value: "286",
        label: "Fabricação de máquinas e equipamentos de uso industrial específico"
    },
    {
        value: "843",
        label: "Seguridade social obrigatória"
    },
    {
        value: "305",
        label: "Fabricação de veículos militares de combate"
    },
    {
        value: "382",
        label: "Tratamento e disposição de resíduos"
    },
    {
        value: "017",
        label: "Caça e serviços relacionados"
    },
    {
        value: "864",
        label: "Atividades de serviços de complementação diagnóstica e terapêutica"
    },
    {
        value: "016",
        label: "Atividades de apoio à agricultura e à pecuária; atividades de\npós-colheita"
    },
    {
        value: "611",
        label: "Telecomunicações por fio"
    },
    {
        value: "474",
        label: "Comércio varejista de material de construção"
    },
    {
        value: "172",
        label: "Fabricação de papel, cartolina e papel-cartão"
    },
    {
        value: "015",
        label: "Pecuária"
    },
    {
        value: "645",
        label: "Sociedades de capitalização"
    },
    {
        value: "872",
        label: "Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência mental e dependência\nquímica"
    },
    {
        value: "531",
        label: "Atividades de Correio"
    },
    {
        value: "823",
        label: "Atividades de organização de eventos, exceto culturais e esportivos"
    },
    {
        value: "772",
        label: "Aluguel de objetos pessoais e domésticos"
    },
    {
        value: "241",
        label: "Produção de ferro-gusa e de ferroligas"
    },
    {
        value: "799",
        label: "Serviços de reservas e outros serviços de turismo não especificados anteriormente"
    },
    {
        value: "233",
        label: "Fabricação de artefatos de concreto, cimento, fibrocimento, gesso e materiais semelhantes"
    },
    {
        value: "031",
        label: "Pesca"
    },
    {
        value: "811",
        label: "Serviços combinados para apoio a edifícios"
    },
    {
        value: "421",
        label: "Construção de rodovias, ferrovias, obras urbanas e obras-de-arte especiais"
    },
    {
        value: "101",
        label: "Abate e fabricação de produtos de carne"
    },
    {
        value: "932",
        label: "Atividades de recreação e lazer"
    },
    {
        value: "855",
        label: "Atividades de apoio à educação"
    },
    {
        value: "154",
        label: "Fabricação de partes para calçados, de qualquer material"
    },
    {
        value: "649",
        label: "Atividades de serviços financeiros não especificadas anteriormente"
    },
    {
        value: "952",
        label: "Reparação e manutenção de objetos e equipamentos pessoais e domésticos"
    },
    {
        value: "135",
        label: "Fabricação de artefatos têxteis, exceto vestuário"
    },
    {
        value: "802",
        label: "Atividades de monitoramento de sistemas de segurança"
    },
    {
        value: "353",
        label: "Produção e distribuição de vapor, água quente e ar\ncondicionado"
    },
    {
        value: "275",
        label: "Fabricação de eletrodomésticos"
    },
    {
        value: "271",
        label: "Fabricação de geradores, transformadores e motores elétricos"
    },
    {
        value: "451",
        label: "Comércio de veículos automotores"
    },
    {
        value: "476",
        label: "Comércio varejista de artigos culturais, recreativos e esportivos"
    },
    {
        value: "433",
        label: "Obras de acabamento"
    },
    {
        value: "231",
        label: "Fabricação de vidro e de produtos do vidro"
    },
    {
        value: "242",
        label: "Siderurgia"
    },
    {
        value: "681",
        label: "Atividades imobiliárias de imóveis próprios"
    },
    {
        value: "591",
        label: "Atividades cinematográficas, produção de vídeos e de programas de televisão"
    },
    {
        value: "949",
        label: "Atividades de organizações associativas não especificadas anteriormente"
    },
    {
        value: "023",
        label: "Atividades de apoio à produção florestal"
    },
    {
        value: "439",
        label: "Outros serviços especializados para construção"
    },
    {
        value: "222",
        label: "Fabricação de produtos de material plástico"
    },
    {
        value: "279",
        label: "Fabricação de equipamentos e aparelhos elétricos não especificados anteriormente"
    },
    {
        value: "252",
        label: "Fabricação de tanques, reservatórios metálicos e caldeiras"
    },
    {
        value: "105",
        label: "Laticínios"
    },
    {
        value: "259",
        label: "Fabricação de produtos de metal não especificados anteriormente"
    },
    {
        value: "107",
        label: "Fabricação e refino de açúcar"
    },
    {
        value: "102",
        label: "Preservação do pescado e fabricação de produtos do pescado"
    },
    {
        value: "284",
        label: "Fabricação de máquinas-ferramenta"
    },
    {
        value: "153",
        label: "Fabricação de calçados"
    },
    {
        value: "475",
        label: "Comércio varejista de equipamentos de informática e comunicação; equipamentos e artigos de uso doméstico"
    },
    {
        value: "274",
        label: "Fabricação de lâmpadas e outros equipamentos de iluminação"
    },
    {
        value: "282",
        label: "Fabricação de máquinas e equipamentos de uso geral"
    },
    {
        value: "461",
        label: "Representantes comerciais e agentes do comércio, exceto de veículos automotores e motocicletas"
    },
    {
        value: "332",
        label: "Instalação de máquinas e equipamentos"
    },
    {
        value: "232",
        label: "Fabricação de cimento"
    },
    {
        value: "268",
        label: "Fabricação de mídias virgens, magnéticas e ópticas"
    },
    {
        value: "266",
        label: "Fabricação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação"
    },
    {
        value: "920",
        label: "Atividades de exploração de jogos de azar e apostas"
    },
    {
        value: "161",
        label: "Desdobramento de madeira"
    },
    {
        value: "620",
        label: "Atividades dos serviços de tecnologia da informação"
    },
    {
        value: "452",
        label: "Manutenção e reparação de veículos automotores"
    },
    {
        value: "071",
        label: "Extração de minério de ferro"
    },
    {
        value: "783",
        label: "Fornecimento e gestão de recursos humanos para terceiros"
    },
    {
        value: "032",
        label: "Aquicultura"
    },
    {
        value: "412",
        label: "Construção de edifícios"
    },
    {
        value: "880",
        label: "Serviços de assistência social sem alojamento"
    },
    {
        value: "471",
        label: "Comércio varejista não especializado"
    },
    {
        value: "304",
        label: "Fabricação de aeronaves"
    },
    {
        value: "171",
        label: "Fabricação de celulose e outras pastas para a fabricação de papel"
    },
    {
        value: "473",
        label: "Comércio varejista de combustíveis para veículos automotores"
    },
    {
        value: "331",
        label: "Manutenção e reparação de máquinas e equipamentos"
    },
    {
        value: "323",
        label: "Fabricação de artefatos para pesca e esporte"
    },
    {
        value: "801",
        label: "Atividades de vigilância, segurança privada e transporte de valores"
    },
    {
        value: "493",
        label: "Transporte rodoviário de carga"
    },
    {
        value: "121",
        label: "Processamento industrial do fumo"
    },
    {
        value: "131",
        label: "Preparação e fiação de fibras têxteis"
    },
    {
        value: "245",
        label: "Fundição"
    },
    {
        value: "262",
        label: "Fabricação de equipamentos de informática e periféricos"
    },
    {
        value: "014",
        label: "Produção de sementes e mudas certificadas"
    },
    {
        value: "812",
        label: "Atividades de limpeza"
    },
    {
        value: "951",
        label: "Reparação e manutenção de equipamentos de informática e comunicação"
    },
    {
        value: "104",
        label: "Fabricação de óleos e gorduras vegetais e animais"
    },
    {
        value: "099",
        label: "Atividades de apoio à extração de minerais, exceto petróleo e gás natural"
    },
    {
        value: "692",
        label: "Atividades de contabilidade, consultoria e auditoria contábil e tributária"
    },
    {
        value: "682",
        label: "Atividades imobiliárias por contrato ou comissão"
    },
    {
        value: "582",
        label: "Edição integrada à impressão de livros, jornais, revistas e outras publicações"
    },
    {
        value: "477",
        label: "Comércio varejista de produtos farmacêuticos, perfumaria e cosméticos e artigos médicos, ópticos e ortopédicos"
    },
    {
        value: "467",
        label: "Comércio atacadista de madeira, ferragens, ferramentas, material elétrico e material de construção"
    },
    {
        value: "468",
        label: "Comércio atacadista especializado em outros produtos"
    },
    {
        value: "221",
        label: "Fabricação de produtos de borracha"
    },
    {
        value: "132",
        label: "Tecelagem, exceto malha"
    },
    {
        value: "712",
        label: "Testes e análises técnicas"
    },
    {
        value: "285",
        label: "Fabricação de máquinas e equipamentos de uso na extração mineral e na construção"
    },
    {
        value: "133",
        label: "Fabricação de tecidos de malha"
    },
    {
        value: "639",
        label: "Outras atividades de prestação de serviços de informação"
    },
    {
        value: "551",
        label: "Hotéis e similares"
    },
    {
        value: "512",
        label: "Transporte aéreo de carga"
    }
]

export const divisaoSelect: formatJson[] = [
    {
        value: "91",
        label: "Atividades Ligadas Ao Patrimônio Cultural E Ambiental"
    },
    {
        value: "33",
        label: "Manutenção, Reparação E Instalação De Máquinas E Equipamentos"
    },
    {
        value: "17",
        label: "Fabricação De Celulose, Papel E Produtos De Papel"
    },
    {
        value: "59",
        label: "Atividades Cinematográficas, Produção De Vídeos E De Programas De Televisão; Gravação De Som E Edição De Música"
    },
    {
        value: "56",
        label: "Alimentação"
    },
    {
        value: "29",
        label: "Fabricação De Veículos Automotores, Reboques E Carrocerias"
    },
    {
        value: "49",
        label: "Transporte Terrestre"
    },
    {
        value: "28",
        label: "Fabricação De Máquinas E Equipamentos"
    },
    {
        value: "73",
        label: "Publicidade E Pesquisa De Mercado"
    },
    {
        value: "65",
        label: "Seguros, Resseguros, Previdência Complementar E Planos De Saúde"
    },
    {
        value: "63",
        label: "Atividades De Prestação De Serviços De Informação"
    },
    {
        value: "15",
        label: "Preparação De Couros E Fabricação De Artefatos De Couro, Artigos Para Viagem E Calçados"
    },
    {
        value: "18",
        label: "Impressão E Reprodução De Gravações"
    },
    {
        value: "64",
        label: "Atividades De Serviços Financeiros"
    },
    {
        value: "92",
        label: "Atividades De Exploração De Jogos De Azar E\nApostas"
    },
    {
        value: "47",
        label: "Comércio Varejista"
    },
    {
        value: "69",
        label: "Atividades Jurídicas, De Contabilidade E De Auditoria"
    },
    {
        value: "27",
        label: "Fabricação De Máquinas, Aparelhos E Materiais Elétricos"
    },
    {
        value: "53",
        label: "Correio E Outras Atividades De Entrega"
    },
    {
        value: "52",
        label: "Armazenamento E Atividades Auxiliares Dos Transportes"
    },
    {
        value: "96",
        label: "Outras Atividades De Serviços Pessoais"
    },
    {
        value: "19",
        label: "Fabricação De Coque, De Produtos Derivados Do Petróleo E De Biocombustíveis"
    },
    {
        value: "95",
        label: "Reparação E Manutenção De Equipamentos De Informática E Comunicação E De Objetos Pessoais E Domésticos"
    },
    {
        value: "70",
        label: "Atividades De Sedes De Empresas E De Consultoria Em Gestão Empresarial"
    },
    {
        value: "87",
        label: "Atividades De Atenção À Saúde Humana Integradas Com Assistência Social, Prestadas Em Residências Coletivas E Particulares"
    },
    {
        value: "30",
        label: "Fabricação De Outros Equipamentos De Transporte, Exceto Veículos Automotores"
    },
    {
        value: "58",
        label: "Edição E Edição Integrada À Impressão"
    },
    {
        value: "81",
        label: "Serviços Para Edifícios E Atividades Paisagísticas"
    },
    {
        value: "77",
        label: "Aluguéis Não Imobiliários E Gestão De Ativos Intangíveis Não Financeiros"
    },
    {
        value: "02",
        label: "Produção Florestal"
    },
    {
        value: "09",
        label: "Atividades De Apoio À Extração De Minerais"
    },
    {
        value: "21",
        label: "Fabricação De Produtos Farmoquímicos E Farmacêuticos"
    },
    {
        value: "01",
        label: "Agricultura, Pecuária E Serviços Relacionados"
    },
    {
        value: "75",
        label: "Atividades Veterinárias"
    },
    {
        value: "99",
        label: "Organismos Internacionais E Outras Instituições Extraterritoriais"
    },
    {
        value: "23",
        label: "Fabricação De Produtos De Minerais Não Metálicos"
    },
    {
        value: "03",
        label: "Pesca E Aqüicultura"
    },
    {
        value: "90",
        label: "Atividades Artísticas, Criativas E De Espetáculos"
    },
    {
        value: "82",
        label: "Serviços De Escritório, De Apoio Administrativo E Outros Serviços Prestados Principalmente Às\nEmpresas"
    },
    {
        value: "60",
        label: "Atividades De Rádio E De Televisão"
    },
    {
        value: "50",
        label: "Transporte Aquaviário"
    },
    {
        value: "97",
        label: "Serviços Domésticos"
    },
    {
        value: "72",
        label: "Pesquisa E Desenvolvimento Científico"
    },
    {
        value: "88",
        label: "Serviços De Assistência Social Sem Alojamento"
    },
    {
        value: "45",
        label: "Comércio E Reparação De Veículos Automotores E Motocicletas"
    },
    {
        value: "25",
        label: "Fabricação De Produtos De Metal, Exceto Máquinas E Equipamentos"
    },
    {
        value: "31",
        label: "Fabricação De Móveis"
    },
    {
        value: "55",
        label: "Alojamento"
    },
    {
        value: "32",
        label: "Fabricação De Produtos Diversos"
    },
    {
        value: "93",
        label: "Atividades Esportivas E De Recreação E Lazer"
    },
    {
        value: "05",
        label: "Extração De Carvão Mineral"
    },
    {
        value: "68",
        label: "Atividades Imobiliárias"
    },
    {
        value: "13",
        label: "Fabricação De Produtos Têxteis"
    },
    {
        value: "12",
        label: "Fabricação De Produtos Do Fumo"
    },
    {
        value: "80",
        label: "Atividades De Vigilância, Segurança E Investigação"
    },
    {
        value: "43",
        label: "Serviços Especializados Para Construção"
    },
    {
        value: "36",
        label: "Captação, Tratamento E Distribuição De Água"
    },
    {
        value: "42",
        label: "Obras De Infraestrutura"
    },
    {
        value: "16",
        label: "Fabricação De Produtos De Madeira"
    },
    {
        value: "35",
        label: "Eletricidade, Gás E Outras Utilidades"
    },
    {
        value: "08",
        label: "Extração De Minerais Não Metálicos"
    },
    {
        value: "74",
        label: "Outras Atividades Profissionais, Científicas E Técnicas"
    },
    {
        value: "79",
        label: "Agências De Viagens, Operadores Turísticos E Serviços De Reservas"
    },
    {
        value: "26",
        label: "Fabricação De Equipamentos De Informática, Produtos Eletrônicos E Ópticos"
    },
    {
        value: "20",
        label: "Fabricação De Produtos Químicos"
    },
    {
        value: "14",
        label: "Confecção De Artigos Do Vestuário E Acessórios"
    },
    {
        value: "66",
        label: "Atividades Auxiliares Dos Serviços Financeiros, Seguros, Previdência Complementar E Planos De Saúde"
    },
    {
        value: "51",
        label: "Transporte Aéreo"
    },
    {
        value: "11",
        label: "Fabricação De Bebidas"
    },
    {
        value: "84",
        label: "Administração Pública, Defesa E Seguridade Social"
    },
    {
        value: "38",
        label: "Coleta, Tratamento E Disposição De Resíduos; Recuperação De Materiais"
    },
    {
        value: "78",
        label: "Seleção, Agenciamento E Locação De Mão De Obra"
    },
    {
        value: "94",
        label: "Atividades De Organizações Associativas"
    },
    {
        value: "37",
        label: "Esgoto E Atividades Relacionadas"
    },
    {
        value: "71",
        label: "Serviços De Arquitetura E Engenharia; Testes E Análises Técnicas"
    },
    {
        value: "39",
        label: "Descontaminação E Outros Serviços De Gestão De Resíduos"
    },
    {
        value: "24",
        label: "Metalurgia"
    },
    {
        value: "06",
        label: "Extração De Petróleo E Gás Natural"
    },
    {
        value: "62",
        label: "Atividades Dos Serviços De Tecnologia Da Informação"
    },
    {
        value: "61",
        label: "Telecomunicações"
    },
    {
        value: "10",
        label: "Fabricação De Produtos Alimentícios"
    },
    {
        value: "41",
        label: "Construção De Edifícios"
    },
    {
        value: "46",
        label: "Comércio Por Atacado, Exceto Veículos Automotores E Motocicletas"
    },
    {
        value: "22",
        label: "Fabricação De Produtos De Borracha E De Material Plástico"
    },
    {
        value: "86",
        label: "Atividades De Atenção À Saúde Humana"
    },
    {
        value: "07",
        label: "Extração De Minerais Metálicos"
    },
    {
        value: "85",
        label: "Educação"
    }
]

export const secaoSelect: formatJson[] = [
    {
        value: "L",
        label: "Atividades Imobiliárias"
    },
    {
        value: "H",
        label: "Transporte, Armazenagem E Correio"
    },
    {
        value: "T",
        label: "Serviços Domésticos"
    },
    {
        value: "S",
        label: "Outras Atividades De Serviços"
    },
    {
        value: "G",
        label: "Comércio; Reparação De Veículos Automotores E Motocicletas"
    },
    {
        value: "K",
        label: "Atividades Financeiras, De Seguros E Serviços Relacionados"
    },
    {
        value: "F",
        label: "Construção"
    },
    {
        value: "R",
        label: "Artes, Cultura, Esporte E Recreação"
    },
    {
        value: "N",
        label: "Atividades Administrativas E Serviços Complementares"
    },
    {
        value: "P",
        label: "Educação"
    },
    {
        value: "U",
        label: "Organismos Internacionais E Outras Instituições Extraterritoriais"
    },
    {
        value: "D",
        label: "Eletricidade E Gás"
    },
    {
        value: "J",
        label: "Informação E Comunicação"
    },
    {
        value: "M",
        label: "Atividades Profissionais, Científicas E Técnicas"
    },
    {
        value: "B",
        label: "Indústrias Extrativas"
    },
    {
        value: "E",
        label: "Água, Esgoto, Atividades De Gestão De Resíduos E Descontaminação"
    },
    {
        value: "A",
        label: "Agricultura, Pecuária, Produção Florestal, Pesca E Aquicultura"
    },
    {
        value: "I",
        label: "Alojamento E Alimentação"
    },
    {
        value: "C",
        label: "Indústrias De Transformação"
    },
    {
        value: "Q",
        label: "Saúde Humana E Serviços Sociais"
    },
    {
        value: "O",
        label: "Administração Pública, Defesa E Seguridade Social"
    }
]

export const socialFB: Array<object> = [
  {
    value: 0,
    label: "Até 1.000",
  },
  {
    value: 1,
    label: "De 1.001 a 10.000",
  },
  {
    value: 2,
    label: "De 10.001 a 50.000",
  },
  {
    value: 3,
    label: "De 50.001 a 500.000",
  },
  {
    value: 4,
    label: "Acima de 500.000",
  },
];

export const socialIG: Array<object> = [
  {
    value: 0,
    label: "Até 1.000",
  },
  {
    value: 1,
    label: "De 1.001 a 10.000",
  },
  {
    value: 2,
    label: "De 10.001 a 50.000",
  },
  {
    value: 3,
    label: "De 50.001 a 500.000",
  },
  {
    value: 4,
    label: "Acima de 500.000",
  },
];
